export default {
    namespaced: true,

    state: {
        latvianAlphabet: [
            "A",
            "Ā",
            "B",
            "C",
            "Č",
            "D",
            "E",
            "Ē",
            "F",
            "G",
            "H",
            "I",
            "Ī",
            "J",
            "K",
            "Ķ",
            "L",
            "Ļ",
            "M",
            "N",
            "Ņ",
            "O",
            "P",
            "R",
            "S",
            "Š",
            "T",
            "U",
            "Ū",
            "V",
            "Z",
            "Ž",
        ],
        features: [
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Gaviezes",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.430840469290576, 56.425333880301466],
                            [21.433425250401424, 56.421389379609444],
                            [21.434807659140542, 56.419990119006009],
                            [21.438524463614709, 56.41835351500599],
                            [21.440326688322738, 56.414535499038912],
                            [21.42459719870951, 56.414780930802536],
                            [21.392652616236695, 56.414827235609977],
                            [21.347263548630085, 56.415577919910177],
                            [21.330544496872491, 56.415219084297846],
                            [21.323462764831472, 56.413352911206559],
                            [21.320583444243248, 56.414004677346981],
                            [21.319156971906967, 56.415972926055396],
                            [21.312983816284124, 56.415839296096479],
                            [21.304087398399979, 56.410505644854375],
                            [21.298923685739179, 56.410678835200592],
                            [21.283757545031094, 56.406634848026521],
                            [21.281359002509991, 56.404154778312332],
                            [21.278675741510643, 56.40566663386889],
                            [21.275477972850371, 56.407167127022326],
                            [21.269985975514327, 56.408331450971588],
                            [21.263660736789461, 56.410333912924543],
                            [21.25843536709483, 56.411360824512926],
                            [21.254249012054967, 56.415837608901093],
                            [21.249403383032242, 56.415159021245621],
                            [21.241563678693517, 56.416698387091429],
                            [21.237776741437255, 56.419184393375929],
                            [21.233198573219902, 56.418368336609291],
                            [21.227514689337447, 56.425666751454962],
                            [21.22094438389443, 56.430776566650529],
                            [21.215663357273446, 56.432560660076447],
                            [21.214134515516168, 56.435855798286575],
                            [21.215240785301628, 56.444204320071087],
                            [21.212593091136924, 56.451041605179235],
                            [21.210303556220509, 56.458838171102379],
                            [21.212528438772672, 56.463644559927708],
                            [21.212644021069607, 56.467927894257592],
                            [21.207761850521266, 56.4759039642937],
                            [21.211616505484233, 56.481936102082265],
                            [21.207116261814193, 56.484688729876233],
                            [21.205804022434616, 56.490842476981541],
                            [21.221167900471272, 56.49237649097531],
                            [21.230766269833872, 56.490450659075073],
                            [21.236155683604139, 56.493186764016116],
                            [21.235827363828722, 56.497697957947373],
                            [21.237662832669404, 56.502019500655813],
                            [21.237694846120831, 56.507489972535183],
                            [21.241935020492679, 56.514243065917107],
                            [21.247069039921911, 56.526485538972452],
                            [21.253495692703439, 56.532810992056639],
                            [21.254578394297958, 56.541634023882104],
                            [21.25359819419068, 56.549222377158166],
                            [21.237607036271449, 56.550056890629826],
                            [21.24460403069255, 56.554492926282272],
                            [21.253924599250237, 56.556601793640809],
                            [21.258791918842181, 56.560752088599642],
                            [21.267342253988055, 56.567599153839573],
                            [21.275151940761937, 56.566819405263089],
                            [21.286355558457913, 56.57277201020618],
                            [21.288756082693787, 56.563312013499832],
                            [21.292875041059169, 56.553889429520133],
                            [21.293417697197288, 56.546291334106989],
                            [21.298098603488867, 56.534978357351676],
                            [21.312987342170839, 56.537441624901106],
                            [21.327068721423242, 56.539172288896246],
                            [21.340291839635814, 56.540882966064139],
                            [21.350359748941088, 56.538482260161146],
                            [21.354079607390016, 56.534518855103087],
                            [21.347272512172054, 56.527239468618646],
                            [21.3514874560374, 56.522335493913971],
                            [21.354974626192512, 56.515513435983365],
                            [21.349475522990119, 56.50802416477012],
                            [21.347346935687156, 56.501557910976388],
                            [21.343781743224021, 56.497201144249928],
                            [21.343997621999037, 56.494114262659771],
                            [21.335578872322493, 56.491555760176297],
                            [21.331603434732425, 56.486951994160236],
                            [21.332349390435343, 56.482449659012516],
                            [21.338144370073891, 56.479482569776337],
                            [21.344730230440714, 56.477483376918251],
                            [21.355606024133518, 56.475575329511521],
                            [21.363064869624345, 56.473355973856371],
                            [21.368459951699627, 56.469903398165009],
                            [21.37591694740955, 56.46768325090239],
                            [21.389383589513233, 56.471772184167172],
                            [21.387119497165287, 56.467206231825948],
                            [21.390877232460575, 56.462529197976913],
                            [21.394650295310427, 56.457614575079134],
                            [21.398194998396267, 56.456024326301552],
                            [21.408956713085775, 56.449353221645694],
                            [21.414950415240156, 56.44329535958714],
                            [21.420926100298477, 56.437474654463941],
                            [21.42153169459074, 56.434871403316393],
                            [21.425469644799975, 56.433764190087956],
                            [21.427853380754041, 56.430246596082021],
                            [21.430840469290576, 56.425333880301466],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Gramzdas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.651719646402491, 56.42118346925708],
                            [21.652899012749035, 56.414810742740769],
                            [21.657181147616921, 56.410442178379647],
                            [21.661158731342191, 56.406661001261277],
                            [21.666059097077497, 56.405270161889447],
                            [21.675687140711982, 56.405302705874142],
                            [21.686321062587002, 56.406391494163898],
                            [21.689866565340051, 56.405271067554835],
                            [21.696733164552509, 56.406733660889955],
                            [21.699779758450756, 56.405010419254936],
                            [21.705052372008119, 56.406294651611184],
                            [21.710173834372139, 56.40564775708534],
                            [21.710467486481207, 56.400758751212017],
                            [21.712551011484386, 56.397237624518603],
                            [21.706353421306801, 56.393563528135296],
                            [21.704403754009078, 56.390412794558571],
                            [21.69550010217117, 56.391730763153689],
                            [21.692180162904098, 56.389147612561636],
                            [21.694060333991146, 56.384584774741555],
                            [21.694479599649213, 56.382071183731],
                            [21.687110397967743, 56.380154083475112],
                            [21.675175767749217, 56.378595938030813],
                            [21.670410152862605, 56.373463636810214],
                            [21.663862856040662, 56.371263931766677],
                            [21.656239471100278, 56.36919184344152],
                            [21.651689786738515, 56.364952775470634],
                            [21.6553203304485, 56.358050527441243],
                            [21.660120233836412, 56.353840014701817],
                            [21.658691798844234, 56.350994965384281],
                            [21.651752026884147, 56.346562355028965],
                            [21.645826084959459, 56.343038527027758],
                            [21.640710567565549, 56.339381520733781],
                            [21.637472094057465, 56.33561178771712],
                            [21.636349322841376, 56.332178996930374],
                            [21.633286804169238, 56.329895704206443],
                            [21.627070876789272, 56.331111652119603],
                            [21.625388043456738, 56.332414286748708],
                            [21.622454611090877, 56.332358010087809],
                            [21.619714057217593, 56.333491939894792],
                            [21.616661677790002, 56.331060100382885],
                            [21.614050514979258, 56.330119896053951],
                            [21.610087704261318, 56.329450202572609],
                            [21.604745388770613, 56.329495317058203],
                            [21.601353289107362, 56.328243090105161],
                            [21.596454755290047, 56.32547831731916],
                            [21.596251224195349, 56.324217239066044],
                            [21.594144653060265, 56.328251584024734],
                            [21.593471480064554, 56.330463339298156],
                            [21.591244877930833, 56.331903277098547],
                            [21.591858203042044, 56.334881649757108],
                            [21.594441154181254, 56.336266742416413],
                            [21.597942128724416, 56.340042736358555],
                            [21.594400111464118, 56.341160573700435],
                            [21.590928467796619, 56.345394444914966],
                            [21.587460595372914, 56.345326954630657],
                            [21.585387289393704, 56.348549648715988],
                            [21.580346619569756, 56.348006328635329],
                            [21.575993606352068, 56.349256131376919],
                            [21.568658456248851, 56.351188906837777],
                            [21.565619842317503, 56.352760787316171],
                            [21.562446536110691, 56.352253421736492],
                            [21.563268001223502, 56.356125982083789],
                            [21.568023773359659, 56.356961041386668],
                            [21.569483354145493, 56.359214524481295],
                            [21.569847343641698, 56.361891472456712],
                            [21.566961499753916, 56.365246261217187],
                            [21.563168254673275, 56.366061657828944],
                            [21.562645961243238, 56.370056101850736],
                            [21.558452538062394, 56.372940009210225],
                            [21.554801902492027, 56.375686168206435],
                            [21.553019621624486, 56.378469127915302],
                            [21.552257563931835, 56.38201383214259],
                            [21.549711771056447, 56.384188374275297],
                            [21.549826550622782, 56.386563811986051],
                            [21.546202562438609, 56.388865291152761],
                            [21.539897881252667, 56.391261818094762],
                            [21.537321260132746, 56.39803353033259],
                            [21.540688680808309, 56.39973193455738],
                            [21.540011037575393, 56.401943337173215],
                            [21.541461045095456, 56.404345269314739],
                            [21.54449522217163, 56.407075211875203],
                            [21.54485781671821, 56.40975220286542],
                            [21.546919141755918, 56.410979583615415],
                            [21.551089793030851, 56.41269357307209],
                            [21.556625499118606, 56.413989356665347],
                            [21.560205513541874, 56.416581322643367],
                            [21.562009922418987, 56.417655064831429],
                            [21.565846215728037, 56.416247210804471],
                            [21.571420727571141, 56.416949797538408],
                            [21.574017835019415, 56.418187204401391],
                            [21.577970324637985, 56.419154391760358],
                            [21.582837656657368, 56.418359434189227],
                            [21.587189026000079, 56.417257607941465],
                            [21.59011954214882, 56.417462913401621],
                            [21.593429648899999, 56.415895669626437],
                            [21.596083495821201, 56.416243785700559],
                            [21.594588216344789, 56.418736238256919],
                            [21.596651644175811, 56.419962808325231],
                            [21.594982481685118, 56.420968691732796],
                            [21.592713104348366, 56.423001147417985],
                            [21.594546808423974, 56.423630009205688],
                            [21.600240936700757, 56.426706723175911],
                            [21.60914423313233, 56.429845066813058],
                            [21.604956896553251, 56.43258235572614],
                            [21.606191314293625, 56.434237701960903],
                            [21.611143673121486, 56.432108385471018],
                            [21.615172801345036, 56.431889280225896],
                            [21.617100017631671, 56.431036404245425],
                            [21.618906726710641, 56.432109335455571],
                            [21.623212435780527, 56.431746959574731],
                            [21.623397355639131, 56.428784122178598],
                            [21.629334405459197, 56.428007829897048],
                            [21.628689022198838, 56.429775318583317],
                            [21.632173892580237, 56.429693576515291],
                            [21.63336301064075, 56.427788129124103],
                            [21.633989735487802, 56.426316899721186],
                            [21.639972094785495, 56.424799376251833],
                            [21.645558467845234, 56.425350507277898],
                            [21.646561839676334, 56.422106550344488],
                            [21.651719646402491, 56.42118346925708],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Rucavas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.304638441873475, 56.200021030150964],
                            [21.304536408793798, 56.199791061704914],
                            [21.304607387765344, 56.199397110024918],
                            [21.304326950800526, 56.199049423919526],
                            [21.303825419420797, 56.198642980998002],
                            [21.303331205624715, 56.198146809171682],
                            [21.302773363178357, 56.197667223497014],
                            [21.302336137126453, 56.197235211856729],
                            [21.301916776317508, 56.196821565944951],
                            [21.301411013073825, 56.196468951935394],
                            [21.300898124660357, 56.195945395689563],
                            [21.30039641415414, 56.195556911152998],
                            [21.300156157901004, 56.195219081195596],
                            [21.299960939364166, 56.194828303002147],
                            [21.29994939365535, 56.194720186817257],
                            [21.299921767103385, 56.194539809953291],
                            [21.300123912244846, 56.194301533707403],
                            [21.300169502413361, 56.193996915636745],
                            [21.300168175565567, 56.193736215606371],
                            [21.299890341909681, 56.193352620451975],
                            [21.299717968670606, 56.193196046028845],
                            [21.299450672699482, 56.192956498621434],
                            [21.299301449868654, 56.192764474947829],
                            [21.298913447678036, 56.192486333024362],
                            [21.298434070878972, 56.192053384515113],
                            [21.29781821650035, 56.19180621104244],
                            [21.297137217120088, 56.191611541223857],
                            [21.296835070233787, 56.191524032696513],
                            [21.296394614405948, 56.191397542151932],
                            [21.295994528983172, 56.191262944906242],
                            [21.295590024300751, 56.191191170298069],
                            [21.295117710029498, 56.191216785168812],
                            [21.294555709072448, 56.191321332365959],
                            [21.294019887359401, 56.191354541023728],
                            [21.293703306219872, 56.191221765184224],
                            [21.293269948712027, 56.19098755466505],
                            [21.292941603820413, 56.190728677543646],
                            [21.292859720306726, 56.190475200261744],
                            [21.292800112469831, 56.190177267622488],
                            [21.292735446576891, 56.18995113354795],
                            [21.292347659425435, 56.189942635186462],
                            [21.291874612024866, 56.189950244062381],
                            [21.291532367207218, 56.189888809325389],
                            [21.291240484027377, 56.189684658864188],
                            [21.291066393951485, 56.189546011399635],
                            [21.291058038135031, 56.189393020498621],
                            [21.291101551427779, 56.18909734793521],
                            [21.290914679903807, 56.188868533066639],
                            [21.290327899159507, 56.188774766213662],
                            [21.289741754393305, 56.188672021797139],
                            [21.289138040992718, 56.188254284768057],
                            [21.288794421461823, 56.188462472875123],
                            [21.288608817364739, 56.188737049042722],
                            [21.288369320282403, 56.188911566412777],
                            [21.288129319946989, 56.188843377500937],
                            [21.287859350654877, 56.188621722346006],
                            [21.287613545149028, 56.188364642293386],
                            [21.287468467425967, 56.187858089822861],
                            [21.28726821427972, 56.187548076946015],
                            [21.287149197182199, 56.187221870227667],
                            [21.287257392843227, 56.18687368678507],
                            [21.287237544253625, 56.186612578600212],
                            [21.286523277994831, 56.186363185625446],
                            [21.286271296005122, 56.186393605418175],
                            [21.285924414041524, 56.186376996281837],
                            [21.285065123519878, 56.185827781092698],
                            [21.284803392063719, 56.185768096509626],
                            [21.284119155394404, 56.185600247643343],
                            [21.283554359858901, 56.185246258417401],
                            [21.283333555921022, 56.184899831750656],
                            [21.283151431698183, 56.184626165029293],
                            [21.282824477905042, 56.184349312477465],
                            [21.282357379675364, 56.184024432385847],
                            [21.282114813229423, 56.18372246809836],
                            [21.281896808770892, 56.183358122685085],
                            [21.28191532330359, 56.183124823341792],
                            [21.28188047521699, 56.182791473901965],
                            [21.281815250069045, 56.182574309384322],
                            [21.281712970382518, 56.182311385821706],
                            [21.281613865898915, 56.182003588410524],
                            [21.281687513958165, 56.181852400816581],
                            [21.281724502425696, 56.181628496702693],
                            [21.281928832230349, 56.181381308659688],
                            [21.281941764996994, 56.181219796227118],
                            [21.281978116598498, 56.181004866753767],
                            [21.28187710898726, 56.180723993781726],
                            [21.281909256911941, 56.180589870326003],
                            [21.281833138061131, 56.18049830813613],
                            [21.28189402105621, 56.180256952305946],
                            [21.282333595527696, 56.180122804533056],
                            [21.282712563837563, 56.180005299483376],
                            [21.282938391944217, 56.179731616653051],
                            [21.282932738590763, 56.179533740430884],
                            [21.282653214706254, 56.179455681870607],
                            [21.282135627572611, 56.179525193159954],
                            [21.281818007261442, 56.179644046400639],
                            [21.281393735459446, 56.179832461446182],
                            [21.281123797662531, 56.179889441285596],
                            [21.280568911895099, 56.179895204037919],
                            [21.280049277808487, 56.1800006165479],
                            [21.279465886873531, 56.180131588924027],
                            [21.27897361385179, 56.180120746063089],
                            [21.278553964372879, 56.179994647730865],
                            [21.278197066503036, 56.179842964448518],
                            [21.278256462627574, 56.179601577364778],
                            [21.278734155737844, 56.17927053009759],
                            [21.278879451378732, 56.178968113983785],
                            [21.27898565771515, 56.178655847909951],
                            [21.278931493337502, 56.178304094111432],
                            [21.278593465598068, 56.17765844699894],
                            [21.278489949265595, 56.177413470404083],
                            [21.278570589220358, 56.177163562489376],
                            [21.278710027186829, 56.176950904881302],
                            [21.278681875255483, 56.176779498660466],
                            [21.278655953824348, 56.176320501980733],
                            [21.278633625582071, 56.176095291608412],
                            [21.278958848755561, 56.175868749387682],
                            [21.279057554969345, 56.175655194122477],
                            [21.279101141528919, 56.175359525957639],
                            [21.27915811586541, 56.17514505131934],
                            [21.279153807966253, 56.174686530813425],
                            [21.279247825869042, 56.174517815826249],
                            [21.27875776830248, 56.174498031285609],
                            [21.278391389851301, 56.174480970078797],
                            [21.278134193703149, 56.174358448957413],
                            [21.277685630383562, 56.174321597036453],
                            [21.277537564748759, 56.174641928253621],
                            [21.277156928770896, 56.174534661700733],
                            [21.276553203884482, 56.174413486394478],
                            [21.276145497972074, 56.174368541002309],
                            [21.275791867410643, 56.174441640655232],
                            [21.275356152757194, 56.174521917375856],
                            [21.274877568449124, 56.174610235501312],
                            [21.274642134886953, 56.174479198379622],
                            [21.274372209021582, 56.174266500876151],
                            [21.274572491937413, 56.174055190379725],
                            [21.274868971841727, 56.173935889556077],
                            [21.275186195925222, 56.17380805692644],
                            [21.275259349669152, 56.173656861988803],
                            [21.275018174447347, 56.173336935081402],
                            [21.274887215453646, 56.173181236975587],
                            [21.274559144183318, 56.17292231308204],
                            [21.274590438172297, 56.172779183572828],
                            [21.274565723866129, 56.172580885658171],
                            [21.274478168616824, 56.172381201034263],
                            [21.27424338610388, 56.172241188545009],
                            [21.273805905135433, 56.172069735411512],
                            [21.273345907097422, 56.171924749856082],
                            [21.273117865521002, 56.171703985125788],
                            [21.272747054949182, 56.171480067488325],
                            [21.272277919547175, 56.171442741174531],
                            [21.271855604213474, 56.171604200030714],
                            [21.271480743119149, 56.171685806961264],
                            [21.271122938647725, 56.171803744684787],
                            [21.270741703461059, 56.171975096227847],
                            [21.270383391346808, 56.172093020646571],
                            [21.270110710093757, 56.172167892903026],
                            [21.269729482533862, 56.172069578559949],
                            [21.269150759595313, 56.171894986329015],
                            [21.26856304160459, 56.171549405735725],
                            [21.268312910557633, 56.171328143240892],
                            [21.268245866772741, 56.171137896166854],
                            [21.267869350990154, 56.170994736229616],
                            [21.26742825291241, 56.170598460547012],
                            [21.267497873956849, 56.170483146792321],
                            [21.267555775079188, 56.170277685956769],
                            [21.267700349222991, 56.169993243587903],
                            [21.267842100416512, 56.169762671270377],
                            [21.268138199401371, 56.169634389492849],
                            [21.268116070386633, 56.169400191863282],
                            [21.267860854151902, 56.169250725916712],
                            [21.267462472541037, 56.169125058304878],
                            [21.266847052581134, 56.169120429421532],
                            [21.266346264003381, 56.168983503062833],
                            [21.26580731457128, 56.16880977468157],
                            [21.265593697985601, 56.1686702136099],
                            [21.265215843775955, 56.168518026702934],
                            [21.264839771960524, 56.168347900502482],
                            [21.264593744455016, 56.168090765600475],
                            [21.264363441038935, 56.168157574803054],
                            [21.264093330749979, 56.168196535404675],
                            [21.263665966334546, 56.168160101086627],
                            [21.263263044512719, 56.16807027416975],
                            [21.262993164245703, 56.168127215050262],
                            [21.262931409612921, 56.168386521404898],
                            [21.262643608733764, 56.168398120437026],
                            [21.262328466631015, 56.16825630325831],
                            [21.262011955198229, 56.168105466092932],
                            [21.261580967673279, 56.167844224313129],
                            [21.261020807859556, 56.167678993049101],
                            [21.260682418665194, 56.16754564474045],
                            [21.260353131980391, 56.167574295785258],
                            [21.259936566249849, 56.167654942380274],
                            [21.259742633455904, 56.167776482766271],
                            [21.259707314852992, 56.167982441532772],
                            [21.259800865667064, 56.168344069228262],
                            [21.259877371890191, 56.168669363457553],
                            [21.259907993148445, 56.168804874823756],
                            [21.259578055544903, 56.168842498294133],
                            [21.258963784729595, 56.168828866742231],
                            [21.258339096709555, 56.168707135232594],
                            [21.257897750978906, 56.168598460137673],
                            [21.257853064640631, 56.168363759033028],
                            [21.257985040845622, 56.168249834772553],
                            [21.257665849408415, 56.168143870785691],
                            [21.257469035305739, 56.16805860117325],
                            [21.257358546655528, 56.167885360238913],
                            [21.257352247256282, 56.167705444193373],
                            [21.257461381863934, 56.167375281853722],
                            [21.257218280637783, 56.167324939125415],
                            [21.256775811076761, 56.167225223619042],
                            [21.25666390980059, 56.167078917031105],
                            [21.256266475096375, 56.166665591587552],
                            [21.255849308057158, 56.166260815101097],
                            [21.255439632003917, 56.165991035781296],
                            [21.255284098940503, 56.165870724604005],
                            [21.255157817713034, 56.16567915283494],
                            [21.255002424723568, 56.165549855568152],
                            [21.254769036485193, 56.165391857903415],
                            [21.25447048540045, 56.165286344031955],
                            [21.254018208232857, 56.165303254864256],
                            [21.253927156794614, 56.165175386802787],
                            [21.253958520176248, 56.165032263066422],
                            [21.253716167226205, 56.164999907470204],
                            [21.253335339636607, 56.165144248128748],
                            [21.252276917819781, 56.165570144741508],
                            [21.251848814090508, 56.165812306159197],
                            [21.251494854927589, 56.165876339758533],
                            [21.251040645309775, 56.165920163257731],
                            [21.249998180960315, 56.165896954530282],
                            [21.248944964110809, 56.165756642619144],
                            [21.248662958364243, 56.165687438451727],
                            [21.248413706434757, 56.165484130865735],
                            [21.248288018929433, 56.165256609507324],
                            [21.247978736202999, 56.165033985695516],
                            [21.24755109083798, 56.164727823526299],
                            [21.247042391629297, 56.164428841795548],
                            [21.246551374546382, 56.164157218631615],
                            [21.245903765691484, 56.164061878198673],
                            [21.245572208468502, 56.164108416653526],
                            [21.245311330567969, 56.164039675826785],
                            [21.24507835405127, 56.163890657241105],
                            [21.24486025855871, 56.163786914425991],
                            [21.244719901434586, 56.164017493047822],
                            [21.244706177614155, 56.164187974968776],
                            [21.244394581948956, 56.164243944500676],
                            [21.243967422712572, 56.164198456931814],
                            [21.243653671317265, 56.164038644073194],
                            [21.243236245198833, 56.163885504943551],
                            [21.242731670729832, 56.163775362883747],
                            [21.242536621964806, 56.163645163878108],
                            [21.24270604159458, 56.163325347933295],
                            [21.242572673617733, 56.163205514969142],
                            [21.241734625976385, 56.163168821946741],
                            [21.240717216398266, 56.163092160293381],
                            [21.240348815260397, 56.163083928293474],
                            [21.23999035509425, 56.163210750309979],
                            [21.239726917241299, 56.163177895715926],
                            [21.239261500934386, 56.16310456993083],
                            [21.238693132462256, 56.163055906985768],
                            [21.238459827021956, 56.162897879279321],
                            [21.238658311178334, 56.162713551432532],
                            [21.238318111429592, 56.162607066367784],
                            [21.237868012885141, 56.162614977585903],
                            [21.237557709805149, 56.162652981007327],
                            [21.237338756650402, 56.16282786036215],
                            [21.236927573076315, 56.162854616497121],
                            [21.236471051799246, 56.162664623742955],
                            [21.235985042280628, 56.162590824603754],
                            [21.235540923304058, 56.162760660944954],
                            [21.235330421885404, 56.162845837289659],
                            [21.235020114634274, 56.162883834291449],
                            [21.234616672359728, 56.162802889540956],
                            [21.234376429611022, 56.162734587330718],
                            [21.234242084696195, 56.162614723133437],
                            [21.234137598753254, 56.162387660976158],
                            [21.234008133318351, 56.162213972496474],
                            [21.233766461555515, 56.162172603672879],
                            [21.233515679399012, 56.162229907981896],
                            [21.233496097157655, 56.162481157995892],
                            [21.233352375874944, 56.162729626909893],
                            [21.233123343723239, 56.162778428862296],
                            [21.232779930748983, 56.162716800779521],
                            [21.232190468603278, 56.162667635046148],
                            [21.231531217206168, 56.162455101959132],
                            [21.231102156184729, 56.162436493460866],
                            [21.230829972034819, 56.162259601368056],
                            [21.230621833031734, 56.162039200472059],
                            [21.230362793881337, 56.161700802011232],
                            [21.230359995699636, 56.161467028055604],
                            [21.230443710701408, 56.161199238837789],
                            [21.230458644949021, 56.161019795927295],
                            [21.230307446907414, 56.160854604755151],
                            [21.23002407541534, 56.160812293158564],
                            [21.229352218275938, 56.161012954297242],
                            [21.229263486357475, 56.16084017440199],
                            [21.229399398325526, 56.160672434803828],
                            [21.229664611191339, 56.160435684729237],
                            [21.229761608437585, 56.160249093943655],
                            [21.229793703256661, 56.160097002715013],
                            [21.229353976241445, 56.159961292866377],
                            [21.229005422590053, 56.159971449718654],
                            [21.228409973639845, 56.159985053291088],
                            [21.228196040283642, 56.159845417970821],
                            [21.228094830751772, 56.159573479124717],
                            [21.228033825703204, 56.159302442676712],
                            [21.227941887036227, 56.158922844940186],
                            [21.227646048475833, 56.158781369861735],
                            [21.227339958197579, 56.158495841387769],
                            [21.227040769107965, 56.158156533629196],
                            [21.226942806524328, 56.157839722008191],
                            [21.227080011307862, 56.157654036127717],
                            [21.227500414141275, 56.157519653518357],
                            [21.227759581521294, 56.157345694161521],
                            [21.22777725732395, 56.157121368379201],
                            [21.227341452271276, 56.156931805415752],
                            [21.226883754977763, 56.156759727018688],
                            [21.225957082225872, 56.156586100902409],
                            [21.225726457009316, 56.156392152437206],
                            [21.225572708146885, 56.156262853231226],
                            [21.225675393975337, 56.156004481963713],
                            [21.225812597998246, 56.15581879743776],
                            [21.22610225420296, 56.155780360225904],
                            [21.226386231223497, 56.155813706055625],
                            [21.226681062446975, 56.155703472460324],
                            [21.226801106692911, 56.155490434764445],
                            [21.226890128163383, 56.155393556066159],
                            [21.226710048634928, 56.155119844354189],
                            [21.226593510260304, 56.154739692617937],
                            [21.226519455477451, 56.154140266651638],
                            [21.226813355354469, 56.15386821156217],
                            [21.227369776115864, 56.153759356925235],
                            [21.228001816769279, 56.153620736319489],
                            [21.228242873486181, 56.153320524925498],
                            [21.228362901271346, 56.153107485476419],
                            [21.228624631635657, 56.152645937126948],
                            [21.22884077436429, 56.152237298576495],
                            [21.229079953809549, 56.151802209948343],
                            [21.229424065672852, 56.151342508812029],
                            [21.229512286076947, 56.151011898830355],
                            [21.229569495685023, 56.150797448757544],
                            [21.22949879966977, 56.15066102885055],
                            [21.22904991798325, 56.15063297789407],
                            [21.228509445673804, 56.150737703067009],
                            [21.228376811200292, 56.150608881046487],
                            [21.228231982177029, 56.150362929273356],
                            [21.227848814135363, 56.149779036516392],
                            [21.227857090708181, 56.149419665828212],
                            [21.227717441623394, 56.149101918310087],
                            [21.227524168599821, 56.148962744755423],
                            [21.227207161865383, 56.148829781059035],
                            [21.226823043843314, 56.148776209400019],
                            [21.22653538169109, 56.148787725716431],
                            [21.226463192751634, 56.148651270321594],
                            [21.226502617926645, 56.148418444092776],
                            [21.226653585575846, 56.148062278579737],
                            [21.226886941812761, 56.147707963445164],
                            [21.226935416889567, 56.147349495510554],
                            [21.226902863827753, 56.146998196528791],
                            [21.226819491146365, 56.146744634140468],
                            [21.226902548692319, 56.146485821074414],
                            [21.227063397418288, 56.14626471083961],
                            [21.227065646082092, 56.145968127013596],
                            [21.227273360167029, 56.145676157765621],
                            [21.227599264926617, 56.145440775831005],
                            [21.228097838446537, 56.145092414004594],
                            [21.228529598253893, 56.144553783164916],
                            [21.228948352138215, 56.144167670577524],
                            [21.229243300814183, 56.144075412360635],
                            [21.230166746624967, 56.143772532851848],
                            [21.230539979528512, 56.143466294042042],
                            [21.230555692922575, 56.143268890466132],
                            [21.230009946751597, 56.143175746569447],
                            [21.229697856084954, 56.143240655120898],
                            [21.229369905909586, 56.143260262397192],
                            [21.229135745919969, 56.143353885202174],
                            [21.228787342777064, 56.143364042980032],
                            [21.228636721212553, 56.143198861390978],
                            [21.228736261903414, 56.142976372908635],
                            [21.228838242113671, 56.142726972359654],
                            [21.229098737631251, 56.14252607423505],
                            [21.229327007286617, 56.142486252856685],
                            [21.229610100061592, 56.14253755048815],
                            [21.230031332038216, 56.142654869367803],
                            [21.23049712933874, 56.142719253047133],
                            [21.231025646392514, 56.142758074963133],
                            [21.231452326653987, 56.142533932513281],
                            [21.231716107539501, 56.14231512489954],
                            [21.231909351123971, 56.142202602106487],
                            [21.232328921809568, 56.142077175332624],
                            [21.232539959877489, 56.141983028326955],
                            [21.23245211635593, 56.141819258771307],
                            [21.232171606146508, 56.141732069900208],
                            [21.231766454183074, 56.141678041209751],
                            [21.23129449829657, 56.141685435360664],
                            [21.230762767359089, 56.141691486887979],
                            [21.230463174278849, 56.141603866016638],
                            [21.230328411010042, 56.14148398679631],
                            [21.230158630407491, 56.141291410435571],
                            [21.229847704564349, 56.141095666743105],
                            [21.229375759764174, 56.140851364011091],
                            [21.228675858289289, 56.140377219268487],
                            [21.228292612143225, 56.140305692838432],
                            [21.228202637305461, 56.140150861023649],
                            [21.228159020470788, 56.139925158634171],
                            [21.228268318207135, 56.139595022509425],
                            [21.228322284863573, 56.139425444635883],
                            [21.228252905232672, 56.13927107521716],
                            [21.22819645275646, 56.138874295059736],
                            [21.228318868631892, 56.138760187604163],
                            [21.228586154254462, 56.138604387828487],
                            [21.228637965114117, 56.138443750355734],
                            [21.228819363460413, 56.13816017701852],
                            [21.228832283813421, 56.137980688596109],
                            [21.228974143822306, 56.137687238561625],
                            [21.229052573960182, 56.13740135353369],
                            [21.229147144914737, 56.137205719988593],
                            [21.229307008120504, 56.136948629398219],
                            [21.229544716536477, 56.136756208169352],
                            [21.230084773300575, 56.136633493571686],
                            [21.230558890712256, 56.136581208698622],
                            [21.230809436328734, 56.136496940158302],
                            [21.231313608126136, 56.136292515010695],
                            [21.231695889039639, 56.136390977622064],
                            [21.232077310431293, 56.136480430835732],
                            [21.232292691234093, 56.136332448442118],
                            [21.232509932098534, 56.136130573903159],
                            [21.232746974470697, 56.135947120727494],
                            [21.232844748058103, 56.135706611811806],
                            [21.233146209017519, 56.1354526906226],
                            [21.23359491752997, 56.135480724998594],
                            [21.234272921793128, 56.135432995098384],
                            [21.234637149625033, 56.135180476675117],
                            [21.234851793479255, 56.13501449567385],
                            [21.235034636044752, 56.134730946192782],
                            [21.235277884199618, 56.134439760478209],
                            [21.235373704714956, 56.134226172737506],
                            [21.2354503643475, 56.133985189082054],
                            [21.2355461826976, 56.133771601172548],
                            [21.235617543532047, 56.133611398933539],
                            [21.235788776437175, 56.133489388790473],
                            [21.236153027966523, 56.133551478464319],
                            [21.23656983718887, 56.133434965542669],
                            [21.236602305049633, 56.133255914273363],
                            [21.236231779043674, 56.132986940544953],
                            [21.236138349091277, 56.132859003921816],
                            [21.23589935906368, 56.13275477456429],
                            [21.235519035761467, 56.132629401731094],
                            [21.235285630432749, 56.132426418198413],
                            [21.235089616020833, 56.132305171929495],
                            [21.235038944227171, 56.132142236495156],
                            [21.235212105405189, 56.131993303646183],
                            [21.235476615215653, 56.132008216868044],
                            [21.235911280227146, 56.131937050778944],
                            [21.236223050425295, 56.131854142686393],
                            [21.236492068311097, 56.131806232319164],
                            [21.236663290272428, 56.131684220822777],
                            [21.236959619136947, 56.131529053973445],
                            [21.237233141168108, 56.131418320505759],
                            [21.237366541491721, 56.131241528102592],
                            [21.237480999590137, 56.131055322729296],
                            [21.237698685055975, 56.130853449573486],
                            [21.23783294398687, 56.130685664823837],
                            [21.238009730812863, 56.130464898126888],
                            [21.238310691608117, 56.130237920599733],
                            [21.238441727741957, 56.130115007649394],
                            [21.238455023615494, 56.12990856031233],
                            [21.238545022544063, 56.129775740238202],
                            [21.238636527308859, 56.129642953791539],
                            [21.238506708047616, 56.129433304676716],
                            [21.238178879421259, 56.129452936614086],
                            [21.237897157615315, 56.129383710377965],
                            [21.237746111354433, 56.129182574293765],
                            [21.237674058571436, 56.129037139298518],
                            [21.237785791906717, 56.128895817249486],
                            [21.237528164915542, 56.128764206952262],
                            [21.237099475223363, 56.12874562294342],
                            [21.236771007924485, 56.128774225693014],
                            [21.236403154500305, 56.128783967910962],
                            [21.23593328944915, 56.128764457932263],
                            [21.235691322136699, 56.128723083523546],
                            [21.23543434782902, 56.128582494451592],
                            [21.235301972401139, 56.128408740087352],
                            [21.235191550005837, 56.12824446622335],
                            [21.235159537192505, 56.128108915399778],
                            [21.235074422670962, 56.127837341305217],
                            [21.235455293827521, 56.127639127495485],
                            [21.235568319398553, 56.127479858491753],
                            [21.235844818677993, 56.127306272627031],
                            [21.23599750934094, 56.127147891541718],
                            [21.236155853182449, 56.126917725551877],
                            [21.23635780277429, 56.126661569008583],
                            [21.236620930790057, 56.126379815142897],
                            [21.237009286669117, 56.126055919567278],
                            [21.237161182012663, 56.125915497158616],
                            [21.237352176072832, 56.125811905377837],
                            [21.237506360787201, 56.125653555986091],
                            [21.237483134496205, 56.125374379855586],
                            [21.237138758240071, 56.125330715854624],
                            [21.237047416066005, 56.125166870684716],
                            [21.237140627029614, 56.124989178967212],
                            [21.237270785908269, 56.12485725880228],
                            [21.237471429543877, 56.124619049188205],
                            [21.237647121194716, 56.124434214299498],
                            [21.237905075601656, 56.124224253428785],
                            [21.238187332145579, 56.123969891294969],
                            [21.238268456034806, 56.123666083558263],
                            [21.238341715859978, 56.123478955666577],
                            [21.238171752035498, 56.123268407488162],
                            [21.237916091330156, 56.123109874720214],
                            [21.237605616365073, 56.122860225409823],
                            [21.237511703226009, 56.122732278603507],
                            [21.237441451945589, 56.122568905686713],
                            [21.237267416071703, 56.122394220647912],
                            [21.237022912127518, 56.12238874722955],
                            [21.236715727464862, 56.122408836718655],
                            [21.236410255677768, 56.122384019206685],
                            [21.236024236349955, 56.122339419264442],
                            [21.235681395079482, 56.122295785200485],
                            [21.235174807658847, 56.122221515299934],
                            [21.234981203498268, 56.122046388514079],
                            [21.234892956788162, 56.12184665512671],
                            [21.234906409533906, 56.121631222349798],
                            [21.234977748893211, 56.121471020000271],
                            [21.23504815924732, 56.12133776357296],
                            [21.235061468746128, 56.121131316493283],
                            [21.234907465197182, 56.120993032366385],
                            [21.234670483874901, 56.120861877753242],
                            [21.234481900649158, 56.120623940057996],
                            [21.234674305736171, 56.12049341742874],
                            [21.234433320301733, 56.120425095073763],
                            [21.234195055383307, 56.120311888566846],
                            [21.23397787719604, 56.120199154183005],
                            [21.233699954649907, 56.12008505785996],
                            [21.233425826202545, 56.119890145568142],
                            [21.233299933798339, 56.119626644406999],
                            [21.233180271584377, 56.119255415582174],
                            [21.232903760432514, 56.118799769533702],
                            [21.233033955700126, 56.118380208776784],
                            [21.233116823573326, 56.118031498294577],
                            [21.233279154689107, 56.11773850284645],
                            [21.233419612561342, 56.117462994726104],
                            [21.233673069655953, 56.117028218675678],
                            [21.23399760878835, 56.116765825061549],
                            [21.234398595676311, 56.116559077444045],
                            [21.234833731425681, 56.116478938754348],
                            [21.235094724403705, 56.116233096382857],
                            [21.235165550283952, 56.116072882444819],
                            [21.234896594723466, 56.115806177511345],
                            [21.234538309489988, 56.115663315212565],
                            [21.234120576943713, 56.115501141619198],
                            [21.233715479457889, 56.115429139136943],
                            [21.232988045586833, 56.115322941553188],
                            [21.232335271289877, 56.11529032556178],
                            [21.23168257167994, 56.11528467459906],
                            [21.231002985177163, 56.115359317378577],
                            [21.230291409697465, 56.115298404334489],
                            [21.229784136435001, 56.115242073469695],
                            [21.229280880241056, 56.115122908058432],
                            [21.229092572602891, 56.11490294528145],
                            [21.229041444795993, 56.114739996194935],
                            [21.228925851620325, 56.114620544270466],
                            [21.228698253185208, 56.114345764837914],
                            [21.228633360955978, 56.114101605878119],
                            [21.228621602866589, 56.113957518608615],
                            [21.22838920453238, 56.113763531278224],
                            [21.22810696925243, 56.113703258339086],
                            [21.227557627756067, 56.113672939928655],
                            [21.227062778159556, 56.113751710996297],
                            [21.226469981695992, 56.113738389196342],
                            [21.225978792058839, 56.11374532654213],
                            [21.225575234837152, 56.113673331519905],
                            [21.225299109615566, 56.113514310893727],
                            [21.224817618071047, 56.113386627207923],
                            [21.224352869189588, 56.112998638231474],
                            [21.224130484790972, 56.112652055351042],
                            [21.22386486223359, 56.112340455157216],
                            [21.223635084004119, 56.112110561489985],
                            [21.223495816729272, 56.111747869359924],
                            [21.223376416000658, 56.111367646106494],
                            [21.223211546855747, 56.111067300270577],
                            [21.223209075300975, 56.110815553501283],
                            [21.223167464944733, 56.110500003195568],
                            [21.223168159263029, 56.110176415880126],
                            [21.223410901210972, 56.109912208995667],
                            [21.22372962922503, 56.109730612009372],
                            [21.224172039577383, 56.109506851712233],
                            [21.224429530562944, 56.109323875434285],
                            [21.224665149296406, 56.109158384645546],
                            [21.22501905937429, 56.109067465415748],
                            [21.225121763396938, 56.108737183270179],
                            [21.224969280721989, 56.108571952769978],
                            [21.224471047428597, 56.108677603556956],
                            [21.224059210873246, 56.108749240128475],
                            [21.223627518968279, 56.10877548374728],
                            [21.223410436216298, 56.108662731559455],
                            [21.223125514925883, 56.108647331049447],
                            [21.222702877814402, 56.108547929561141],
                            [21.222447324417317, 56.108703978980238],
                            [21.222039298482763, 56.108694793851612],
                            [21.221702582192737, 56.108840025567076],
                            [21.221308080806857, 56.10895698823176],
                            [21.220758100032068, 56.108908646265142],
                            [21.220604341150654, 56.108761359364721],
                            [21.220473458549222, 56.108596609597321],
                            [21.220588362978894, 56.108383462305973],
                            [21.220762116775163, 56.108225574294657],
                            [21.221098685864106, 56.108089330821969],
                            [21.221482663993719, 56.107846286264966],
                            [21.221698356494436, 56.107671363397266],
                            [21.221910310745255, 56.107541300895733],
                            [21.22210448655138, 56.10739285985246],
                            [21.222118003071564, 56.107177428696843],
                            [21.221948197611823, 56.106966859321204],
                            [21.222144745623154, 56.106764537784734],
                            [21.222476769906976, 56.106691111266002],
                            [21.223007371253022, 56.106694064927808],
                            [21.223333931747209, 56.106710402904667],
                            [21.223645522129885, 56.106627524474739],
                            [21.2238983265845, 56.106516355779526],
                            [21.223871540354306, 56.106309006751438],
                            [21.22368065147311, 56.106097965456385],
                            [21.223391268123226, 56.105830773629442],
                            [21.222997284867603, 56.105606171862178],
                            [21.222620001390567, 56.105435878538373],
                            [21.222509483945412, 56.105253611275245],
                            [21.222379830814859, 56.105043946193881],
                            [21.222335210405625, 56.104791250313184],
                            [21.222351812912702, 56.104539932642375],
                            [21.222436248829943, 56.104191263206097],
                            [21.222471986528532, 56.103967343203806],
                            [21.222821810467803, 56.103597680414353],
                            [21.22320504022564, 56.103678217413197],
                            [21.223442524501102, 56.10380041846107],
                            [21.223512038131481, 56.103972773265376],
                            [21.223656952863895, 56.104263681341273],
                            [21.223943781056313, 56.104252157007252],
                            [21.224275780274354, 56.104178725368158],
                            [21.224509428908743, 56.10404015775233],
                            [21.224446304087703, 56.10375109061885],
                            [21.224342244741013, 56.103479080532651],
                            [21.22415136676938, 56.103268039995648],
                            [21.223750941242962, 56.103133185130247],
                            [21.223249009643204, 56.103005033572153],
                            [21.222721045354096, 56.102966183758909],
                            [21.222277897298735, 56.102866318275638],
                            [21.221951726695739, 56.102858974847912],
                            [21.221510522529176, 56.102732183382095],
                            [21.221197665619993, 56.102833005571448],
                            [21.220859121605123, 56.102690545793607],
                            [21.220797967151533, 56.102374553801077],
                            [21.220601792301593, 56.102244289005576],
                            [21.220268072868823, 56.102362616837283],
                            [21.220033125217164, 56.102519125218315],
                            [21.219840115745985, 56.102658600177755],
                            [21.219513947573496, 56.102651250330013],
                            [21.21923677609588, 56.102501180041116],
                            [21.219042758776961, 56.102361972344653],
                            [21.218844793283591, 56.102249642304592],
                            [21.21864689356747, 56.102164280391968],
                            [21.218471300476935, 56.102034476063288],
                            [21.218461233740808, 56.101881436229341],
                            [21.218551880040312, 56.101739655834677],
                            [21.218868619372625, 56.101584993924014],
                            [21.218740292800423, 56.101357376438173],
                            [21.21860570306611, 56.101237485530397],
                            [21.21836033352249, 56.101231953902115],
                            [21.218053309608724, 56.101251998631099],
                            [21.217712410289796, 56.101163410745059],
                            [21.217387988920514, 56.101111149515191],
                            [21.217065073782273, 56.101058921394703],
                            [21.216787826011068, 56.101223458569251],
                            [21.216637107228479, 56.101354893581217],
                            [21.216363743659144, 56.101465583468141],
                            [21.216088643406518, 56.101621178585461],
                            [21.215811387417556, 56.101785713469624],
                            [21.215716841859088, 56.101981337992243],
                            [21.215339516910397, 56.102125635635701],
                            [21.2151658802361, 56.101968903606178],
                            [21.215076629133211, 56.101778120037892],
                            [21.214965509141855, 56.10160482076401],
                            [21.21487366633065, 56.101449934533811],
                            [21.214924830817417, 56.101298276399518],
                            [21.215101167918988, 56.10110449862816],
                            [21.215313609004497, 56.100974458516703],
                            [21.215466275377469, 56.100816102022762],
                            [21.215599873241175, 56.100657315022126],
                            [21.215854605015736, 56.100519239416393],
                            [21.216068482753606, 56.100362263478907],
                            [21.216268914616055, 56.100106104798208],
                            [21.21620023420359, 56.099915786136769],
                            [21.216278735879342, 56.099656876281351],
                            [21.216288894597692, 56.099495303442268],
                            [21.216615181362712, 56.099493675834061],
                            [21.21697281189131, 56.099663545394151],
                            [21.217327089499765, 56.099545690274049],
                            [21.217360260668841, 56.099357669422247],
                            [21.216818196384096, 56.099201618604106],
                            [21.216472134435548, 56.099184822566777],
                            [21.216056098560035, 56.098995655582002],
                            [21.215878584167406, 56.098892770883921],
                            [21.215598275519646, 56.098814533087143],
                            [21.215358902218767, 56.098719240553329],
                            [21.215120826601439, 56.098605998816872],
                            [21.214885199021701, 56.098465844841044],
                            [21.214602448715272, 56.098414516620664],
                            [21.21423927422482, 56.098370360845124],
                            [21.213969167938568, 56.098436173783995],
                            [21.213517663299108, 56.098452944289107],
                            [21.213363972771003, 56.098305648854968],
                            [21.213518435098695, 56.098129357291626],
                            [21.213792431204979, 56.09800969913065],
                            [21.214003268750186, 56.097915581213485],
                            [21.214054871731591, 56.097736966257891],
                            [21.214052396484394, 56.097458251018473],
                            [21.214213336415852, 56.097192214808928],
                            [21.214269684538927, 56.096968761861071],
                            [21.214277905400309, 56.096834112315804],
                            [21.213903988287903, 56.096618921551183],
                            [21.213664485916187, 56.096532611580315],
                            [21.213120089657387, 56.096430425198939],
                            [21.212715440504947, 56.096376338770725],
                            [21.212479186376694, 56.096245154743542],
                            [21.212307533678747, 56.096061495875524],
                            [21.212029139513401, 56.095929358740108],
                            [21.211279116912348, 56.095849484169747],
                            [21.210949906377561, 56.095572371494619],
                            [21.211252545092506, 56.095327520283661],
                            [21.211163769902168, 56.095109776986142],
                            [21.211095624567594, 56.094919467036384],
                            [21.211335044186914, 56.094673186521412],
                            [21.211752003210329, 56.094556764548933],
                            [21.211785343661596, 56.094359759600721],
                            [21.211855426713537, 56.094217519164594],
                            [21.211587430547137, 56.093941791457048],
                            [21.211367220780946, 56.09387389082972],
                            [21.210986710082878, 56.093757420807457],
                            [21.210859753072317, 56.093511846912364],
                            [21.210938630308465, 56.093261937482644],
                            [21.210680681805915, 56.093139248206434],
                            [21.21017972123607, 56.092993085047539],
                            [21.209899467067935, 56.092914834796673],
                            [21.209480933143283, 56.092761543865521],
                            [21.20959180393201, 56.092611238197343],
                            [21.209822392658747, 56.09253555241343],
                            [21.210110435107964, 56.092506110671906],
                            [21.210480542896629, 56.092460545885665],
                            [21.210896624361151, 56.09233511816857],
                            [21.211133050101598, 56.092178660719185],
                            [21.211307865674929, 56.092290480892117],
                            [21.211713118902107, 56.092335597152115],
                            [21.21184864811746, 56.092149890801466],
                            [21.212019619607965, 56.092036897484],
                            [21.212132130486037, 56.091877637708969],
                            [21.212366394751825, 56.0917301181589],
                            [21.212404918792508, 56.091461317993684],
                            [21.212239566903985, 56.091169932747803],
                            [21.212007887235959, 56.090975927519793],
                            [21.211813244100817, 56.090818715014017],
                            [21.211884176298188, 56.090685482796999],
                            [21.211695816331638, 56.09042054377084],
                            [21.211551896925794, 56.09013863090135],
                            [21.211376381480367, 56.090008817056592],
                            [21.210934060940865, 56.089899938118656],
                            [21.210844060433107, 56.089727111709372],
                            [21.210959814044955, 56.089522981153621],
                            [21.210971288948066, 56.089343460004336],
                            [21.21094133629715, 56.089180980273923],
                            [21.210739769755111, 56.088834839700013],
                            [21.210750094741435, 56.088664281575724],
                            [21.210819521556729, 56.088531015900813],
                            [21.211054418958671, 56.088374524256842],
                            [21.211186692246454, 56.08823369021308],
                            [21.211158037216137, 56.08805326178895],
                            [21.210784221348266, 56.087838062346762],
                            [21.210382704259267, 56.087721114636821],
                            [21.21013957629247, 56.087706627219831],
                            [21.209893143739354, 56.087710042646037],
                            [21.209610331172332, 56.087667689477207],
                            [21.209453450890582, 56.087565261277788],
                            [21.20944392345935, 56.087412232141439],
                            [21.209546902978232, 56.087099945441061],
                            [21.209683515459311, 56.086878309809507],
                            [21.209756336159437, 56.086691187253514],
                            [21.209808797598743, 56.086521582221089],
                            [21.209882266128048, 56.086325485215902],
                            [21.209728488824364, 56.086187171330316],
                            [21.209552997145941, 56.08605735506476],
                            [21.209247182912801, 56.086041447679364],
                            [21.209216590339235, 56.085887941901845],
                            [21.209008118783917, 56.085658499237141],
                            [21.208919376786159, 56.085440754379178],
                            [21.208810425293876, 56.085231541185074],
                            [21.208766562022944, 56.084969866477159],
                            [21.208636457232203, 56.084796130590433],
                            [21.208389555112948, 56.084493904729001],
                            [21.208195016447803, 56.084363655289081],
                            [21.207895712063749, 56.084258001274058],
                            [21.207456715542222, 56.084104238858323],
                            [21.207174730065592, 56.084043920354993],
                            [21.206929620442853, 56.084029381431826],
                            [21.206593892653569, 56.083850987035092],
                            [21.206506672796824, 56.083633274641706],
                            [21.206393041546164, 56.083495865448818],
                            [21.206367661305745, 56.083270564403591],
                            [21.206337880332427, 56.083099097971349],
                            [21.206265023959723, 56.082953623060398],
                            [21.206175208075695, 56.082771807764075],
                            [21.205804572322336, 56.082520707925362],
                            [21.205527597278305, 56.082370608440819],
                            [21.205268642077549, 56.082283839966458],
                            [21.205008183478036, 56.082197036866326],
                            [21.204818368105794, 56.081994976361713],
                            [21.204833119322146, 56.081770584256368],
                            [21.204955436722795, 56.081503684392089],
                            [21.204484352940526, 56.08116940255163],
                            [21.204329314505252, 56.081049030880905],
                            [21.204097232711323, 56.08085500018187],
                            [21.203941342623082, 56.08072561962372],
                            [21.203934588397843, 56.080527707206649],
                            [21.20390836982137, 56.080293397305304],
                            [21.203816172837797, 56.080165460399492],
                            [21.203723772848914, 56.080019540691424],
                            [21.203568537786889, 56.079881185379648],
                            [21.203433417988546, 56.079770253120699],
                            [21.20321590533246, 56.079666441535203],
                            [21.202936561468995, 56.079570216464809],
                            [21.20256751879198, 56.079588814218027],
                            [21.202273412446861, 56.079716979432561],
                            [21.201885908905094, 56.079699200158878],
                            [21.201396453646865, 56.079688095513291],
                            [21.201133619625974, 56.07965516438783],
                            [21.200828511315343, 56.07963026238405],
                            [21.200541561929153, 56.079659706191691],
                            [21.200385890663821, 56.079548304018786],
                            [21.200318422588122, 56.079322045829308],
                            [21.200491322765082, 56.079182145169327],
                            [21.200705141010314, 56.079025194804764],
                            [21.200955574217151, 56.078958965718193],
                            [21.201170541818222, 56.078793051594602],
                            [21.201329684554267, 56.078544968803307],
                            [21.201343803116163, 56.07832955149744],
                            [21.201419250333718, 56.078106536683968],
                            [21.201558532435346, 56.077875981127335],
                            [21.201805499810099, 56.077836638985424],
                            [21.202197987656593, 56.077764641136298],
                            [21.202516340120667, 56.077565113653776],
                            [21.202425252343563, 56.077401244414837],
                            [21.202214262858998, 56.077207688109816],
                            [21.201960353035297, 56.077031135865809],
                            [21.201703191355847, 56.07689945463774],
                            [21.201425823873048, 56.07677630344287],
                            [21.201022048590588, 56.076713206499981],
                            [21.200713057201003, 56.076742150228078],
                            [21.200262004598859, 56.076776857566642],
                            [21.199912244717424, 56.076813862928589],
                            [21.199360848347087, 56.076819321640166],
                            [21.198412346777886, 56.076662943961864],
                            [21.198146728374887, 56.076647921082156],
                            [21.197596186952179, 56.07666238037887],
                            [21.196874299184763, 56.076753844834521],
                            [21.196572677268964, 56.076702043950966],
                            [21.196372951406982, 56.076616602270754],
                            [21.1959926559793, 56.076500087939998],
                            [21.195633574372646, 56.076375065671101],
                            [21.195303920819303, 56.076439482406144],
                            [21.194872423956571, 56.07647461474469],
                            [21.194502906396188, 56.0764931772434],
                            [21.193936327566153, 56.076417364455317],
                            [21.193672869933909, 56.076393391959755],
                            [21.193476463461064, 56.076290042822521],
                            [21.193139710994011, 56.076120575783946],
                            [21.192891073167623, 56.075872211437378],
                            [21.192536578239597, 56.075684360647429],
                            [21.192254526745256, 56.075632994495379],
                            [21.192012089268058, 56.075582529598044],
                            [21.191727578459325, 56.075558073531226],
                            [21.191422054019707, 56.075560105584984],
                            [21.191155990950797, 56.075572024692939],
                            [21.190679812297255, 56.075669048409424],
                            [21.190075555707963, 56.07553842476031],
                            [21.189835933221769, 56.075470041461685],
                            [21.18954800446998, 56.075499437100376],
                            [21.189319441174032, 56.075548163190064],
                            [21.188985862192677, 56.075666408273349],
                            [21.188612471239452, 56.075765766759169],
                            [21.188244919890778, 56.075757387943035],
                            [21.187856352175412, 56.07577549617195],
                            [21.187501510470842, 56.075875274279667],
                            [21.187015380820426, 56.075819242144242],
                            [21.186637739605285, 56.075666802569309],
                            [21.18623269285742, 56.075621605961878],
                            [21.185779678598852, 56.075683182916215],
                            [21.185394188602103, 56.075638429785172],
                            [21.185130087526733, 56.075623413333616],
                            [21.184766467066545, 56.075561179111013],
                            [21.184444967862515, 56.075499905383332],
                            [21.184149226208657, 56.075340338531682],
                            [21.184037663400844, 56.075175987151155],
                            [21.183758206588575, 56.075061736741986],
                            [21.18345969742002, 56.074947050581237],
                            [21.182997921143077, 56.074846612898455],
                            [21.182549959358582, 56.074818402063265],
                            [21.182023081964079, 56.074770408243666],
                            [21.181527798264629, 56.074839992863744],
                            [21.181115748575692, 56.074911477937711],
                            [21.180729616490336, 56.074875684509735],
                            [21.180461588442792, 56.074914503004173],
                            [21.180173348693426, 56.074961847946518],
                            [21.179911294571887, 56.075207551957924],
                            [21.179652053207111, 56.075435341496295],
                            [21.179540925857811, 56.075567637261955],
                            [21.179370436742676, 56.075680597080037],
                            [21.179239405059047, 56.075803448243597],
                            [21.179026985835083, 56.075933426896249],
                            [21.178828061233634, 56.076153605252017],
                            [21.178912676353693, 56.076425214830273],
                            [21.178961732590519, 56.07660611963329],
                            [21.179229184683262, 56.076863932543866],
                            [21.179506672635782, 56.07700511557762],
                            [21.179659648873958, 56.077152439938942],
                            [21.17948718492422, 56.077292322223713],
                            [21.179215202417407, 56.077384982599902],
                            [21.178960998949183, 56.077522994723417],
                            [21.178745288199956, 56.077697843387377],
                            [21.178409535332481, 56.07785196727972],
                            [21.178019879368811, 56.07819362888177],
                            [21.177685204211876, 56.07828485157215],
                            [21.177379658590834, 56.07828684861861],
                            [21.176993687847176, 56.078269025856983],
                            [21.176573521933154, 56.078430201930651],
                            [21.176237252650889, 56.078584308260062],
                            [21.176345352198048, 56.07880252248745],
                            [21.176246726858423, 56.079051960547851],
                            [21.176082979156117, 56.079353842404252],
                            [21.175599024464105, 56.079576478851124],
                            [21.17522243249995, 56.079711680913888],
                            [21.174576956732292, 56.079903646730934],
                            [21.174200358058435, 56.080038845597457],
                            [21.17374204836517, 56.080199138479657],
                            [21.173505548389034, 56.080355523738483],
                            [21.17346514037952, 56.080660228782648],
                            [21.173405329348086, 56.080955500012792],
                            [21.173146634596307, 56.081147332608325],
                            [21.172675605196591, 56.081172492960469],
                            [21.172043216781418, 56.081157995450233],
                            [21.171680413419562, 56.081104730949008],
                            [21.171292913264651, 56.081086855596482],
                            [21.171001827733953, 56.081179060288029],
                            [21.170746410361243, 56.081326017404386],
                            [21.170531142527313, 56.081500862507568],
                            [21.170163070049703, 56.081807038951155],
                            [21.169997287605852, 56.082135834154137],
                            [21.169674623885815, 56.082398105298644],
                            [21.169180214727582, 56.082755314892417],
                            [21.168013129023318, 56.083133036662034],
                            [21.167795173636836, 56.083316804688216],
                            [21.167457351497333, 56.083497819784569],
                            [21.167160464959355, 56.083661795814564],
                            [21.166779691594108, 56.083859801010171],
                            [21.166583449719308, 56.084035076582602],
                            [21.16622586967415, 56.084197656250197],
                            [21.165939364015891, 56.084227030455601],
                            [21.165583070440153, 56.084344692034477],
                            [21.165275498727127, 56.084373580638477],
                            [21.164798489348527, 56.084479476540452],
                            [21.164586289781607, 56.084591458093392],
                            [21.164270798716387, 56.084728032228739],
                            [21.163979167646374, 56.084820208313651],
                            [21.163634582260343, 56.084785317661726],
                            [21.163282737978495, 56.084849140008799],
                            [21.162967900308693, 56.08497673674286],
                            [21.162754557021735, 56.085124645630373],
                            [21.162561591143771, 56.085255044564121],
                            [21.162288192040958, 56.085365614488111],
                            [21.162173858930551, 56.085560746025628],
                            [21.162202124304958, 56.085750168989101],
                            [21.162333367401008, 56.085932971791685],
                            [21.162342047428812, 56.086094976619179],
                            [21.162145139108734, 56.086306186844979],
                            [21.161792776986722, 56.086369993220558],
                            [21.161512011942705, 56.086300608517085],
                            [21.161229425421528, 56.086249159597479],
                            [21.16073057034119, 56.086084862040146],
                            [21.160100090178982, 56.086043380616417],
                            [21.159694308064228, 56.086007070106717],
                            [21.159242932179886, 56.086023643342784],
                            [21.158956408135619, 56.08605300112923],
                            [21.158738298816374, 56.085931117986362],
                            [21.158487840370253, 56.085709608195202],
                            [21.158157616028756, 56.085459292598621],
                            [21.157907163929888, 56.085237781680405],
                            [21.157552758176955, 56.085049831511782],
                            [21.157213468165118, 56.084943131365563],
                            [21.156881514139222, 56.085016383191288],
                            [21.156628504145964, 56.085136399899127],
                            [21.156414452973745, 56.085266303427119],
                            [21.156023792774459, 56.085311232040127],
                            [21.15565814611827, 56.085275833465296],
                            [21.154876694996741, 56.084754416233672],
                            [21.154578861968268, 56.084630686540116],
                            [21.15420192922172, 56.084469174389859],
                            [21.153982539563881, 56.084392198973561],
                            [21.153622863413329, 56.084276029162517],
                            [21.153284915903694, 56.084151370544248],
                            [21.152942315112274, 56.084062560382861],
                            [21.152617486743392, 56.084046073159435],
                            [21.152347380986821, 56.084111751301116],
                            [21.151771682826379, 56.084179361965546],
                            [21.151407376595461, 56.084126003127928],
                            [21.151128133994803, 56.084029661845747],
                            [21.150975241505432, 56.08388230311165],
                            [21.150719538255572, 56.083732569300409],
                            [21.15050809731936, 56.083520932983618],
                            [21.150151593433218, 56.083368869228323],
                            [21.149804544081697, 56.08336085030907],
                            [21.149559480986888, 56.083373165724417],
                            [21.149222221165314, 56.083518188070414],
                            [21.148893419653657, 56.083555534430793],
                            [21.148587655320146, 56.083539477171698],
                            [21.148282732404375, 56.083532427823265],
                            [21.147813149860216, 56.083530559540222],
                            [21.147604218323064, 56.083292008384738],
                            [21.147619966401326, 56.08305865280996],
                            [21.147713478930829, 56.082881030849833],
                            [21.147585633317384, 56.082653343867591],
                            [21.147017913667074, 56.082613246000783],
                            [21.146787265647372, 56.082688813851632],
                            [21.146573874205522, 56.082836694291636],
                            [21.146461948440191, 56.082977932571559],
                            [21.146166143839206, 56.083132894937684],
                            [21.146106105535697, 56.08340118258463],
                            [21.145901982203995, 56.083702093210334],
                            [21.145463236309645, 56.08385374638457],
                            [21.145174074943458, 56.083613334207982],
                            [21.145020705526772, 56.083465956734301],
                            [21.144888224696881, 56.083301084110737],
                            [21.144780129546032, 56.08309182966714],
                            [21.144899530493525, 56.082842895109508],
                            [21.144852606602043, 56.082608088956512],
                            [21.144985600199668, 56.082467339725291],
                            [21.145029041129924, 56.082423399088491],
                            [21.145428316253433, 56.082261844911542],
                            [21.145664763658878, 56.082087532293883],
                            [21.146147591387557, 56.081882963226533],
                            [21.146269458089574, 56.08158014915449],
                            [21.1461943572567, 56.081182885539008],
                            [21.145618701428237, 56.080944834256201],
                            [21.145208176974567, 56.080980279292071],
                            [21.145026097717381, 56.080895161757972],
                            [21.122316945117039, 56.077275097539953],
                            [21.120684501453773, 56.077012264849799],
                            [21.118027865885608, 56.076662556374416],
                            [21.116790905485434, 56.076498805512983],
                            [21.115599584291822, 56.076336109495287],
                            [21.114249497117093, 56.076160697723459],
                            [21.113191231522794, 56.076019070051728],
                            [21.11174323307625, 56.075823360001841],
                            [21.110832708589989, 56.075748097072406],
                            [21.109131379460216, 56.07550147443235],
                            [21.10696933194362, 56.07516311723785],
                            [21.105265891662718, 56.074898412344055],
                            [21.104057969143412, 56.074717235105993],
                            [21.102850732087209, 56.074527072619766],
                            [21.09086096927394, 56.072950355962227],
                            [21.084976913063329, 56.0721821539533],
                            [21.074879209842852, 56.07084634160438],
                            [21.069471792509631, 56.069926885563511],
                            [21.064145146884268, 56.069400722726407],
                            [21.064145099782994, 56.069400809375622],
                            [21.063940764433905, 56.069777341670132],
                            [21.063820620140135, 56.070089113111187],
                            [21.063803423760238, 56.070394346204964],
                            [21.063576948262892, 56.071153059957275],
                            [21.063341284192973, 56.071695806860362],
                            [21.063062912969723, 56.072291473199272],
                            [21.062829283209535, 56.072807299221552],
                            [21.062741306842739, 56.073263667663653],
                            [21.062234202531748, 56.074626980092667],
                            [21.062009718349103, 56.075358770281127],
                            [21.061627252443124, 56.076311533330561],
                            [21.061158164639743, 56.077379094557067],
                            [21.060997176352483, 56.077698879767702],
                            [21.060742926068329, 56.078214210894025],
                            [21.060411222475334, 56.078664769078941],
                            [21.060217766413754, 56.079199527216907],
                            [21.059943985293135, 56.079687422863984],
                            [21.05967848962684, 56.080409242185297],
                            [21.05940122633384, 56.080968969648737],
                            [21.059187366759307, 56.081494250403367],
                            [21.059078216327819, 56.081977080170873],
                            [21.059020538154797, 56.082272357960051],
                            [21.058840501396997, 56.082564717991254],
                            [21.058629178825811, 56.083063089924451],
                            [21.058510315265636, 56.083356908357054],
                            [21.058424176652878, 56.083768370506263],
                            [21.057132605803542, 56.086704092677216],
                            [21.056857996411559, 56.087227920432333],
                            [21.056649958212567, 56.087636472835122],
                            [21.056245512068191, 56.08830103293198],
                            [21.055823827820202, 56.088875285477926],
                            [21.055561611790655, 56.089552227796332],
                            [21.055055766811098, 56.090511017103353],
                            [21.054875793666717, 56.090821352452728],
                            [21.05475271382365, 56.091195972432224],
                            [21.054716102517549, 56.091464783018822],
                            [21.054659928904599, 56.091733126503868],
                            [21.054641641341409, 56.092038332543453],
                            [21.054521346638278, 56.092350092382674],
                            [21.053119900232364, 56.09576858614512],
                            [21.053020649419924, 56.09608084739007],
                            [21.052990193301781, 56.096268899143659],
                            [21.052878020168809, 56.096428030230605],
                            [21.050462957965561, 56.101134743977042],
                            [21.050427678204962, 56.101385606332137],
                            [21.050377505879517, 56.101555207176744],
                            [21.050389783234056, 56.101690343110924],
                            [21.050273409718784, 56.101930277090425],
                            [21.050114282244248, 56.102223125678456],
                            [21.049767699830017, 56.103257619605387],
                            [21.049629635545845, 56.103550971320054],
                            [21.049599024293592, 56.103721039664606],
                            [21.049488134567682, 56.103889188178407],
                            [21.048966917700508, 56.104748703249086],
                            [21.048829582958167, 56.105006113636961],
                            [21.048736324149441, 56.105219630741139],
                            [21.046699078438166, 56.110079147984919],
                            [21.04658540591441, 56.110283185542755],
                            [21.046363615735814, 56.110592508891571],
                            [21.046149816757019, 56.110758191238389],
                            [21.045976162208486, 56.110924834338135],
                            [21.045884304536525, 56.111093435589034],
                            [21.045774622730761, 56.111225652036985],
                            [21.045699842124474, 56.111466578008923],
                            [21.045623684519391, 56.111725449964979],
                            [21.045314914645648, 56.11281477523309],
                            [21.045235440125641, 56.11313649402932],
                            [21.04517484861503, 56.11346765446126],
                            [21.045032079222736, 56.113814825918944],
                            [21.044978237722731, 56.114038273950776],
                            [21.044815575744014, 56.114375979301762],
                            [21.044645469190659, 56.114515737225673],
                            [21.044343768105158, 56.114778195895433],
                            [21.044228003210879, 56.115009149887356],
                            [21.044094600032079, 56.115194733772547],
                            [21.044062016701446, 56.115409701197251],
                            [21.043923231907605, 56.115685050982677],
                            [21.043812401966186, 56.116185807792085],
                            [21.043555714021551, 56.116745996526184],
                            [21.043313526819254, 56.117405416711108],
                            [21.042900384445559, 56.118195582397092],
                            [21.042528068076127, 56.118977735798389],
                            [21.042146801389983, 56.119561904686869],
                            [21.041775476875902, 56.119957531340489],
                            [21.041529691690876, 56.120329198175412],
                            [21.04135735125849, 56.120477887913843],
                            [21.041187990430377, 56.120941281403518],
                            [21.040931919777989, 56.121492490576877],
                            [21.040757033727093, 56.122027667068835],
                            [21.040525067892897, 56.122867117548701],
                            [21.040243063584626, 56.123480630050963],
                            [21.040117784597424, 56.123900131957548],
                            [21.039434822366427, 56.125097332702161],
                            [21.039183587654389, 56.125558759655377],
                            [21.039131073302791, 56.125764258318853],
                            [21.038663913519841, 56.126750884439616],
                            [21.038294190621919, 56.127856710802739],
                            [21.03786043021773, 56.12863737717322],
                            [21.036765476826638, 56.130238193103949],
                            [21.034712797706423, 56.134378004125082],
                            [21.03459735540665, 56.134564010292181],
                            [21.034041251663339, 56.135134966576373],
                            [21.033552008426625, 56.136013170709361],
                            [21.033306406856223, 56.136438764308501],
                            [21.032980264595135, 56.136871411009338],
                            [21.032761843726238, 56.137198772382682],
                            [21.032477312295811, 56.137587470606768],
                            [21.032254788323488, 56.138013617132231],
                            [21.031776871976028, 56.138613412441394],
                            [21.03146384873796, 56.139208182160921],
                            [21.031409686065761, 56.139512522973902],
                            [21.031149532404694, 56.140315322213482],
                            [21.031093858764692, 56.140619626560685],
                            [21.03095909225209, 56.140886070486147],
                            [21.030889815043704, 56.141073183910578],
                            [21.030628282765711, 56.141417483955202],
                            [21.03036951507627, 56.141725891953328],
                            [21.030108665952049, 56.142061217912158],
                            [21.029652572022414, 56.142670520341596],
                            [21.029596311580022, 56.143001778548125],
                            [21.029436328805751, 56.143366498851513],
                            [21.029368995695187, 56.143508710741024],
                            [21.029254106046665, 56.14378462084013],
                            [21.029020388239275, 56.143976765429393],
                            [21.028771565955754, 56.144051682366943],
                            [21.028461588911135, 56.144143105766112],
                            [21.028151489490462, 56.144216546426804],
                            [21.027779109303111, 56.144288486798537],
                            [21.027491488351572, 56.144344488009786],
                            [21.027118030768488, 56.144443369031997],
                            [21.026744380298449, 56.144551233822398],
                            [21.026575458447461, 56.144673018442639],
                            [21.0268817660621, 56.144707364570117],
                            [21.027126366684762, 56.144713255346439],
                            [21.027292182896222, 56.144690279907657],
                            [21.027581055153586, 56.145119743179997],
                            [21.027411892224315, 56.145205565061225],
                            [21.027112840908124, 56.145468049156044],
                            [21.026816367559004, 56.145703626104954],
                            [21.026645481006806, 56.145870311144634],
                            [21.026411617231702, 56.146044468530093],
                            [21.026223601036353, 56.146165792810358],
                            [21.025886192316158, 56.146364423466366],
                            [21.025438994762649, 56.146290722232273],
                            [21.025137412241612, 56.146175580834786],
                            [21.024918587799007, 56.146044454098622],
                            [21.024739755334057, 56.145923280338302],
                            [21.024361584362946, 56.146147893058405],
                            [21.024702580628585, 56.146299944416228],
                            [21.025145160025822, 56.146472421802763],
                            [21.025364178984777, 56.146594563252791],
                            [21.025541557669637, 56.146760648610176],
                            [21.025717742023755, 56.146935694434816],
                            [21.025873334039197, 56.147110243882551],
                            [21.025968914838973, 56.14724738933306],
                            [21.026081480398407, 56.147483828568241],
                            [21.026111096718076, 56.147745238058512],
                            [21.026121457293669, 56.147943257044723],
                            [21.026094407598453, 56.14810441676449],
                            [21.026085560571985, 56.148283994008302],
                            [21.026017632248916, 56.148453158479697],
                            [21.025865745988497, 56.148647268861211],
                            [21.025655111043548, 56.148768047517045],
                            [21.025545487806802, 56.14893620720423],
                            [21.025518434861077, 56.149097366741586],
                            [21.025550463928212, 56.149268939295702],
                            [21.025580771245753, 56.149521376017297],
                            [21.025550249607605, 56.149727399573585],
                            [21.025478082259372, 56.149977367315827],
                            [21.025386969005378, 56.150172941421886],
                            [21.025208591347052, 56.150501255567576],
                            [21.02503482852234, 56.150730795981531],
                            [21.024837428379751, 56.151031682699333],
                            [21.024703273716543, 56.151289145743334],
                            [21.024483883757032, 56.151607481040983],
                            [21.02430479734355, 56.151944766452296],
                            [21.024005789993385, 56.152225223881672],
                            [21.023830048276491, 56.152499662652403],
                            [21.023652915609937, 56.152792046706331],
                            [21.023440331909544, 56.153002670148105],
                            [21.023287098808865, 56.153187755668256],
                            [21.023066342023519, 56.153568982370906],
                            [21.022827213921119, 56.153868860016715],
                            [21.022569686014062, 56.154159303988145],
                            [21.022496175011135, 56.154400248295609],
                            [21.022444575950363, 56.154650710534625],
                            [21.022352740909785, 56.154855254758338],
                            [21.022262796400224, 56.155041865472363],
                            [21.022112830073493, 56.155191070368573],
                            [21.021983460821112, 56.155340771904179],
                            [21.021813011700839, 56.155507461456459],
                            [21.021722442783435, 56.15567607770803],
                            [21.021611509960358, 56.155880160756503],
                            [21.021497796804368, 56.156120134739133],
                            [21.021384584590592, 56.156360120714027],
                            [21.021207532175641, 56.156670482590592],
                            [21.021235730508813, 56.156949838147767],
                            [21.021038149829486, 56.157232735979072],
                            [21.020839988541752, 56.157542588087111],
                            [21.020426339198444, 56.158125915214121],
                            [21.020121734220808, 56.158523092791988],
                            [21.019915373789168, 56.159003546665602],
                            [21.019589653485657, 56.159400213417413],
                            [21.019351272658803, 56.159709092525546],
                            [21.019155633117808, 56.159947086846067],
                            [21.018750701078488, 56.160332849707693],
                            [21.018576351112319, 56.160562367683696],
                            [21.01835685525932, 56.160880690555821],
                            [21.018134688917925, 56.161252885756532],
                            [21.017873711582741, 56.161606164204613],
                            [21.017334466460063, 56.162204427568973],
                            [21.017096629966996, 56.162486347247302],
                            [21.016941198457914, 56.162770257319991],
                            [21.016741001427999, 56.163125001935938],
                            [21.016481275161684, 56.163442349799276],
                            [21.016323243963257, 56.163753164955182],
                            [21.016038959467039, 56.164159813883124],
                            [21.015778523838705, 56.16448613278942],
                            [21.015441127573276, 56.164720695739177],
                            [21.015351010294729, 56.164889318705981],
                            [21.015241293916869, 56.165057467874576],
                            [21.015068293815169, 56.165269034889356],
                            [21.014953117129803, 56.165526947176367],
                            [21.014736462554353, 56.165827353812624],
                            [21.014560475328445, 56.166083795638997],
                            [21.014488282278911, 56.166306788598803],
                            [21.014419457658352, 56.166466936218768],
                            [21.01424357938189, 56.166741359345316],
                            [21.014113362393349, 56.166926990993225],
                            [21.013938839730745, 56.167138519756982],
                            [21.013806643177489, 56.167369050920691],
                            [21.013733860080333, 56.16761899783419],
                            [21.013742101396517, 56.1678888832013],
                            [21.013714286067707, 56.168059011720814],
                            [21.013492614402757, 56.16840424275329],
                            [21.013376947456123, 56.168707089561273],
                            [21.013305941707205, 56.168921121096623],
                            [21.013124110710216, 56.169330241870547],
                            [21.013055971682636, 56.169481415867118],
                            [21.012738698582783, 56.169689490216136],
                            [21.012187765834291, 56.170098670072278],
                            [21.011761432553424, 56.170465915019605],
                            [21.011499746930408, 56.170846132694116],
                            [21.011235850653069, 56.171235285903379],
                            [21.011145113787791, 56.171430859742223],
                            [21.011097569746507, 56.171582531222228],
                            [21.011070324542906, 56.171725704442458],
                            [21.010899753524402, 56.171892377243346],
                            [21.010747079856205, 56.172068472582424],
                            [21.009984586590683, 56.173092800523733],
                            [21.009571379849728, 56.17364014715767],
                            [21.009218980148418, 56.174188965122966],
                            [21.008808208754314, 56.174646472974608],
                            [21.00856626312644, 56.175018173573001],
                            [21.008363742075748, 56.175426786937386],
                            [21.008205592960561, 56.175737589932247],
                            [21.007988127283394, 56.176046955725106],
                            [21.007747254722631, 56.176391712241362],
                            [21.007587699278091, 56.176720459546111],
                            [21.007434232560755, 56.176977437839305],
                            [21.006913116220183, 56.177603067527578],
                            [21.006425564286463, 56.178418289240867],
                            [21.006140473213904, 56.178851866597057],
                            [21.00587775329625, 56.179205079763229],
                            [21.005702452076569, 56.179470516336735],
                            [21.005379791623891, 56.179804296230266],
                            [21.005140466083528, 56.180122116995179],
                            [21.005010048254189, 56.180289755967053],
                            [21.004683310414229, 56.180740299458179],
                            [21.00393862005291, 56.181648161031575],
                            [21.003479524115555, 56.182284271464901],
                            [21.003002490550926, 56.182866007780518],
                            [21.002583692851683, 56.18352107210508],
                            [21.001905478624867, 56.184466493906932],
                            [21.001595780255922, 56.184962391335446],
                            [21.000946911142659, 56.185737719153266],
                            [21.000507431153071, 56.186392274931102],
                            [21.000069823187953, 56.186983947855396],
                            [20.999611891287952, 56.18758411525063],
                            [20.999092114035186, 56.188227726411498],
                            [20.998710475663156, 56.188515109635773],
                            [20.998202743789367, 56.188862354490453],
                            [20.99775764394716, 56.189175161396065],
                            [20.997251998608501, 56.189495484566848],
                            [20.996804792064481, 56.189880153524733],
                            [20.996609555473913, 56.190109135404327],
                            [20.996455946910018, 56.190321150063866],
                            [20.996321562237352, 56.190596558961339],
                            [20.996208283245025, 56.190827533126317],
                            [20.99608410450001, 56.191300960420151],
                            [20.995979534050562, 56.191774864447822],
                            [20.995731748978006, 56.192263264593265],
                            [20.995549612586807, 56.192672354900061],
                            [20.995041000474345, 56.193487023773905],
                            [20.994535971277017, 56.19422986139363],
                            [20.994033427358179, 56.194927809777596],
                            [20.993638859967131, 56.195475561400237],
                            [20.993124180170415, 56.195993419681741],
                            [20.992878932521119, 56.196409959909033],
                            [20.992718466446838, 56.196792605291648],
                            [20.992208401746137, 56.198074685969871],
                            [20.991216903070836, 56.199596748754807],
                            [20.990839357038258, 56.200234802579864],
                            [20.990638512905612, 56.200598482934552],
                            [20.990561392520529, 56.200920228995386],
                            [20.990292955945446, 56.201426095512232],
                            [20.990133140389091, 56.201754816343716],
                            [20.989956318337541, 56.202056153933185],
                            [20.989800414865964, 56.202322042679349],
                            [20.989581237144201, 56.202649316514318],
                            [20.989296467960543, 56.203028929088056],
                            [20.989034124804803, 56.203373129301795],
                            [20.988724202006999, 56.203886971293578],
                            [20.988017109695754, 56.20501141162903],
                            [20.987304745333784, 56.206234605125175],
                            [20.986631070163394, 56.207503686422193],
                            [20.985840133674238, 56.208680008169985],
                            [20.985350108768856, 56.209522063370848],
                            [20.985058395600333, 56.210072299724168],
                            [20.984892956560202, 56.210535721020669],
                            [20.984834779176502, 56.210929842924976],
                            [20.984585891645079, 56.211858685703767],
                            [20.984269489754283, 56.21249821374029],
                            [20.983964668649495, 56.212868336301597],
                            [20.983891595287204, 56.213118260949528],
                            [20.983791741462802, 56.21352934431939],
                            [20.983491808720338, 56.21424118924989],
                            [20.983022745417035, 56.215533227086603],
                            [20.982744374503753, 56.216650128011949],
                            [20.982374529993105, 56.217558034311793],
                            [20.981976667040627, 56.218636057410251],
                            [20.981608537261401, 56.219957524318438],
                            [20.981419142452971, 56.220519241832577],
                            [20.981279528576515, 56.221306914630738],
                            [20.981190904923565, 56.222311582771049],
                            [20.980864584956443, 56.223607100275558],
                            [20.980697362615917, 56.225014378910487],
                            [20.980638234472231, 56.225848965138148],
                            [20.980295471409221, 56.227045194194503],
                            [20.980344366320388, 56.227756565426056],
                            [20.980432116726934, 56.228486865008186],
                            [20.980232955911557, 56.22925510258213],
                            [20.979960651092913, 56.230273260751005],
                            [20.979801033208727, 56.231051453495255],
                            [20.979830899128586, 56.231735390944273],
                            [20.979681781895, 56.232316069475388],
                            [20.979631518582742, 56.232935121813362],
                            [20.979731797123844, 56.233423009151508],
                            [20.979772579172309, 56.233891463426595],
                            [20.979586230988833, 56.234803846244994],
                            [20.979358185485705, 56.2357331889718],
                            [20.979204801410386, 56.236835157805899],
                            [20.979041591953319, 56.237703157475949],
                            [20.978918951696087, 56.238581138034789],
                            [20.97884761497178, 56.239217653979068],
                            [20.978830106536016, 56.24003527683471],
                            [20.978864404784442, 56.241078904958165],
                            [20.978777978586848, 56.242047665938408],
                            [20.978845881438843, 56.242786469873117],
                            [20.97884708843501, 56.244512495775432],
                            [20.978828053095999, 56.245797538096149],
                            [20.978775822100154, 56.246479468375284],
                            [20.978943418563357, 56.24773311299333],
                            [20.979053538392137, 56.248877477902639],
                            [20.979123470865268, 56.250038839636886],
                            [20.979221551622103, 56.250580609524143],
                            [20.979573404698858, 56.251398265900391],
                            [20.979871527463342, 56.252475305516199],
                            [20.980046869179496, 56.253567324201988],
                            [20.980338851142303, 56.254761076142032],
                            [20.980556630742392, 56.255827161281061],
                            [20.980930931463991, 56.256591423162867],
                            [20.981062046583293, 56.256855321354791],
                            [20.981196096630704, 56.257056364231047],
                            [20.981351100836267, 56.257266908052365],
                            [20.981360319894847, 56.257300107313689],
                            [20.981562224560012, 56.258027183657497],
                            [20.981554362145399, 56.258620301393023],
                            [21.022324922563669, 56.257812727001024],
                            [21.033633485422012, 56.256216764351258],
                            [21.045985633135707, 56.255578561091419],
                            [21.067138237970962, 56.249545069201297],
                            [21.087159648733135, 56.250952108552752],
                            [21.097206244793167, 56.25118832942055],
                            [21.156271670042674, 56.276528478871398],
                            [21.162894076512799, 56.292866568407561],
                            [21.168633901149136, 56.306071326005338],
                            [21.171528230442892, 56.312362867621609],
                            [21.172952765605576, 56.31581935789054],
                            [21.178521136036821, 56.316257663093388],
                            [21.213037021792726, 56.311436757782275],
                            [21.216087658327627, 56.300299899184985],
                            [21.216946567559575, 56.288491171473083],
                            [21.221399203299939, 56.281120888310056],
                            [21.215215325728494, 56.273822768784711],
                            [21.220557889679458, 56.269585199260142],
                            [21.223048946789071, 56.250653973429429],
                            [21.273563473516688, 56.200730970841505],
                            [21.304638441873475, 56.200021030150964],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "PÄ“rkones",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.061545653991701, 56.438981025358807],
                            [21.056681788074819, 56.429216128286285],
                            [21.050939756881526, 56.416317338489847],
                            [21.042381304921538, 56.410821717935356],
                            [21.034337321084589, 56.405960338846455],
                            [21.033212571933522, 56.398773991723438],
                            [21.035009864899482, 56.390101171537502],
                            [21.026847076821909, 56.379633321603372],
                            [21.01523328201894, 56.377486390636797],
                            [21.002429354631239, 56.369083880340803],
                            [20.971175543320271, 56.366186761629365],
                            [20.971173802826264, 56.368434083675133],
                            [20.970898960943362, 56.369020665961848],
                            [20.971063193441474, 56.369483145002739],
                            [20.971248763694781, 56.369919177200579],
                            [20.971481265816028, 56.370644019212435],
                            [20.971654630290633, 56.371807897789346],
                            [20.971938471977232, 56.372740751169601],
                            [20.972229447618432, 56.3735838835197],
                            [20.972614847767684, 56.374564164629639],
                            [20.973149871509641, 56.375458206282701],
                            [20.973340911311428, 56.375768515784408],
                            [20.973916504871951, 56.37663657656671],
                            [20.974693580764121, 56.377626418188754],
                            [20.975219927070277, 56.378241564936729],
                            [20.975735971767037, 56.379108161731907],
                            [20.976274704893484, 56.37991238381472],
                            [20.9765644989868, 56.38030600301115],
                            [20.976887277559857, 56.380871225535266],
                            [20.977168103366019, 56.381480370397647],
                            [20.977383822739935, 56.382150851759569],
                            [20.977722147551709, 56.382833313422779],
                            [20.977868752085904, 56.383232424716681],
                            [20.977927483215964, 56.383737265060283],
                            [20.978004597783489, 56.384278511472083],
                            [20.978078347529074, 56.384900580447926],
                            [20.978206314184973, 56.385694770757553],
                            [20.978396562904649, 56.386463511706999],
                            [20.978591606713721, 56.387133485590326],
                            [20.978815367225316, 56.388073841717869],
                            [20.979270204756251, 56.389370418821429],
                            [20.979562894525863, 56.390150644294046],
                            [20.980079353590508, 56.391430740946468],
                            [20.980476315567287, 56.392186537092783],
                            [20.980958703908282, 56.393321968206664],
                            [20.981385048366477, 56.394321190480113],
                            [20.982485189031422, 56.396784115203175],
                            [20.983073378607823, 56.397832218643167],
                            [20.983927306745187, 56.399408171943143],
                            [20.984451653480196, 56.400508649648891],
                            [20.984746452697376, 56.401270931819454],
                            [20.984954888765152, 56.402094037274246],
                            [20.985281117645155, 56.403054848745576],
                            [20.9857927318347, 56.404029158093536],
                            [20.986141866590458, 56.404918608783589],
                            [20.986396081389106, 56.405643941134919],
                            [20.986789042382998, 56.406498497797074],
                            [20.987084036424619, 56.407233809241625],
                            [20.987213366881576, 56.408001049649997],
                            [20.98722161697474, 56.408261941779386],
                            [20.987430008656233, 56.408644561309721],
                            [20.987663837867899, 56.409378383851845],
                            [20.987822854670327, 56.409930600147788],
                            [20.988002604371481, 56.410528266852481],
                            [20.988246805517285, 56.411028616621778],
                            [20.988676524875181, 56.411515495184965],
                            [20.988824565194882, 56.41186068786007],
                            [20.988887530051514, 56.412275728060706],
                            [20.988962304043635, 56.412906799591099],
                            [20.989118614905458, 56.413512883905881],
                            [20.989685933578642, 56.415054855016336],
                            [20.990156960905058, 56.416873153879592],
                            [20.990667417551499, 56.418314854972564],
                            [20.991549056007411, 56.420646518533026],
                            [20.992514900546933, 56.422458835711303],
                            [20.992942354999833, 56.423458033151661],
                            [20.993219578810642, 56.424138958038817],
                            [20.993173627063896, 56.424695181632792],
                            [20.99345540117449, 56.426185255355662],
                            [20.993784763884619, 56.427047229448057],
                            [20.993987950892432, 56.428005025147854],
                            [20.994258137883563, 56.430169013579516],
                            [20.994495657558929, 56.430839982050436],
                            [20.994759193194412, 56.431367751567102],
                            [20.995059374273204, 56.432022259084825],
                            [20.995391652267287, 56.432848340554465],
                            [20.995590644445713, 56.43345544724324],
                            [20.996160435194192, 56.435383977573458],
                            [20.99686766958736, 56.437891148856266],
                            [20.996932198698886, 56.438737706233397],
                            [20.997020512471622, 56.439494946571941],
                            [20.996968928204293, 56.440167894517714],
                            [20.997004492733424, 56.440726092444436],
                            [20.997811427679444, 56.443784016260132],
                            [20.998149419842949, 56.444520332442856],
                            [20.998297158265725, 56.444865502237548],
                            [20.998360976554942, 56.445271565237533],
                            [20.998342283918056, 56.445675630693167],
                            [20.998345053426068, 56.446071226417992],
                            [20.998500319219154, 56.446713224496527],
                            [20.998692656705213, 56.447463991029728],
                            [20.999217491908187, 56.449040828999649],
                            [20.999222894130305, 56.449364573881297],
                            [20.999321071203383, 56.44993327447856],
                            [20.999449550030111, 56.45070946160336],
                            [20.999525106351854, 56.451745056952717],
                            [20.999524906018085, 56.452634990592927],
                            [20.999511018997886, 56.453389753823068],
                            [20.999665725715822, 56.454058703512878],
                            [20.999798970152209, 56.454736122902411],
                            [20.999882778142631, 56.456059573662472],
                            [20.999983006619672, 56.457464324752451],
                            [20.99995391583121, 56.458083880655508],
                            [21.000019844544159, 56.458894509793488],
                            [21.000227237483379, 56.461101897027511],
                            [21.000219513521834, 56.461695001732252],
                            [21.000073217411256, 56.462185872640177],
                            [21.000089592308278, 56.462743603158088],
                            [21.000014523817061, 56.46346991775264],
                            [20.999922660281971, 56.464683307265297],
                            [20.999906511683086, 56.4648965979273],
                            [20.99981683132701, 56.466386646149139],
                            [20.999689655742568, 56.467830840830899],
                            [20.999710865880456, 56.469143785830269],
                            [20.999610357349425, 56.469986344886586],
                            [20.999576277706634, 56.471594597636361],
                            [20.999433840729662, 56.473784530569674],
                            [20.999203166210421, 56.475208241888495],
                            [20.999076494872526, 56.476176016923517],
                            [20.998837830968466, 56.476871404747385],
                            [20.998556401654525, 56.477619692963891],
                            [20.998477390180881, 56.477977351355101],
                            [20.998411256641102, 56.478506117119018],
                            [21.008990537972071, 56.478502262080468],
                            [21.011675548496633, 56.480123352114092],
                            [21.026443898392586, 56.478299198504551],
                            [21.042774261938337, 56.478066921398259],
                            [21.059048008103453, 56.471294398424398],
                            [21.060633652439908, 56.45078786276293],
                            [21.061545653991701, 56.438981025358807],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "NÄ«cas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [20.971175543320271, 56.366186761629365],
                            [21.002429354631239, 56.369083880340803],
                            [21.01523328201894, 56.377486390636797],
                            [21.026847076821909, 56.379633321603372],
                            [21.035009864899482, 56.390101171537502],
                            [21.033212571933522, 56.398773991723438],
                            [21.034337321084589, 56.405960338846455],
                            [21.042381304921538, 56.410821717935356],
                            [21.050939756881526, 56.416317338489847],
                            [21.056681788074819, 56.429216128286285],
                            [21.061545653991701, 56.438981025358807],
                            [21.092118737531205, 56.43596641705134],
                            [21.093982552514522, 56.44099045453811],
                            [21.101859216161358, 56.440863502293666],
                            [21.116004482177058, 56.432166440135795],
                            [21.126474346656284, 56.427429204535684],
                            [21.141193773815008, 56.425901843553895],
                            [21.151801172250572, 56.426768487471207],
                            [21.159906591297787, 56.423530488675439],
                            [21.169276875001813, 56.425923617826285],
                            [21.177572865370166, 56.427669048256028],
                            [21.186499321288728, 56.42849443275],
                            [21.193835390333259, 56.428038143171555],
                            [21.199889768533762, 56.429731311701268],
                            [21.206241137850341, 56.427384486024458],
                            [21.212568983133878, 56.425348074885591],
                            [21.222079174929551, 56.425872755918846],
                            [21.21405424073, 56.420401300129633],
                            [21.21053914341406, 56.414719583841169],
                            [21.199441548929812, 56.412913084580168],
                            [21.197519317932368, 56.408511980901849],
                            [21.198204774010136, 56.399189614965586],
                            [21.198661517483814, 56.392974693474713],
                            [21.20308492727041, 56.386226831709642],
                            [21.202934996929997, 56.380620726232159],
                            [21.203745669654179, 56.377215136211312],
                            [21.214568052655824, 56.374968802143748],
                            [21.215778791262245, 56.373750968821135],
                            [21.212449098455444, 56.365583293713584],
                            [21.211473283125834, 56.355912201796812],
                            [21.207299399476142, 56.343990169841881],
                            [21.204396928217999, 56.337699410428421],
                            [21.201290553961716, 56.334205337376169],
                            [21.195261911840408, 56.324730979462842],
                            [21.178521136036821, 56.316257663093388],
                            [21.172952765605576, 56.31581935789054],
                            [21.171528230442892, 56.312362867621609],
                            [21.168633901149136, 56.306071326005338],
                            [21.162894076512799, 56.292866568407561],
                            [21.156271670042674, 56.276528478871398],
                            [21.097206244793167, 56.25118832942055],
                            [21.087159648733135, 56.250952108552752],
                            [21.067138237970962, 56.249545069201297],
                            [21.045985633135707, 56.255578561091419],
                            [21.033633485422012, 56.256216764351258],
                            [21.022324922563669, 56.257812727001024],
                            [20.981554362145399, 56.258620301393023],
                            [20.981549953219766, 56.259618032664697],
                            [20.981420384886043, 56.260199189710725],
                            [20.981366757505505, 56.260899064557933],
                            [20.981678238841678, 56.261724716018065],
                            [20.981814764649485, 56.2622853996914],
                            [20.982226211778965, 56.263149447403997],
                            [20.982511181333599, 56.26363284684129],
                            [20.982686707203946, 56.264275386614038],
                            [20.982854654542706, 56.265097531687147],
                            [20.983002938688912, 56.266746233147643],
                            [20.983186443808851, 56.268108128363167],
                            [20.983568812996378, 56.270041213542406],
                            [20.983831502107879, 56.271872493115097],
                            [20.984099215652034, 56.273191491485228],
                            [20.984445300341839, 56.2750158125138],
                            [20.984908572280276, 56.276519366207246],
                            [20.985136279215176, 56.277378920452001],
                            [20.985264417138726, 56.278137162551346],
                            [20.985425703036793, 56.2791029709485],
                            [20.985377377387596, 56.280576072007285],
                            [20.985258503447241, 56.281822715774062],
                            [20.98506994272914, 56.283229471843654],
                            [20.985270511158291, 56.284645712159943],
                            [20.985363810600894, 56.286167211492334],
                            [20.98550547846234, 56.288004521477767],
                            [20.985688298381984, 56.289806875504098],
                            [20.985678410459641, 56.290894363271491],
                            [20.985664982639385, 56.292071659568649],
                            [20.985525501207384, 56.293290831662858],
                            [20.985318679140804, 56.29422968838071],
                            [20.985061606188314, 56.295338120484999],
                            [20.985027029944064, 56.296065426529381],
                            [20.985087374727225, 56.297415320411744],
                            [20.984705653895709, 56.299015135974805],
                            [20.984501309712936, 56.299864156902174],
                            [20.984151473841887, 56.300341062177331],
                            [20.983876011141401, 56.300496158053903],
                            [20.983587855836863, 56.300543070025668],
                            [20.983316740017056, 56.300617365270604],
                            [20.983062045330989, 56.300790944754425],
                            [20.98332344544546, 56.300923171421616],
                            [20.983713665800973, 56.300914706275336],
                            [20.983975174036608, 56.301019965694138],
                            [20.98415023367615, 56.301222001698797],
                            [20.984301789806835, 56.302843803234573],
                            [20.984321666624759, 56.304174731309345],
                            [20.984181137449479, 56.304989349077061],
                            [20.983931090750705, 56.306853066586946],
                            [20.983703299835447, 56.308177957195994],
                            [20.983283575851072, 56.309731894806134],
                            [20.982505745213885, 56.311429920381933],
                            [20.982246430698442, 56.312583239802663],
                            [20.982024099181452, 56.313395860429999],
                            [20.981708278920255, 56.313990452956993],
                            [20.981406743528563, 56.314288740328038],
                            [20.981201728208145, 56.314715234364897],
                            [20.980378742031679, 56.317392000230086],
                            [20.979886556363606, 56.319546455017822],
                            [20.979420596379008, 56.321189147744725],
                            [20.978955930464519, 56.322750965205863],
                            [20.978354618180376, 56.32419258187624],
                            [20.977485299311564, 56.326535589045129],
                            [20.977079859008086, 56.327730277971078],
                            [20.976557867512238, 56.328787276578964],
                            [20.976201959060035, 56.329380877618192],
                            [20.975695077352164, 56.331409106232954],
                            [20.975136692755743, 56.332375315578673],
                            [20.974465526811688, 56.333105039510464],
                            [20.97392605323877, 56.333640210906445],
                            [20.973584240302738, 56.334342023657598],
                            [20.973414290397724, 56.335344690796653],
                            [20.972863402469109, 56.338333708345331],
                            [20.972150152670363, 56.339943361623924],
                            [20.972000121044495, 56.340955503662833],
                            [20.971790327820248, 56.341930225768316],
                            [20.971450645592956, 56.342578148703126],
                            [20.971062184885007, 56.343413656559534],
                            [20.970704624029576, 56.344025182323506],
                            [20.970682970365878, 56.344483116181522],
                            [20.970712069880015, 56.345193997419457],
                            [20.971029742420701, 56.346316465686705],
                            [20.970862198580868, 56.34766977814845],
                            [20.970508898609925, 56.349081471616572],
                            [20.970395876055239, 56.351487886399283],
                            [20.970202062443143, 56.353847376329881],
                            [20.97013404025877, 56.355724512121192],
                            [20.970593995410415, 56.357560628783617],
                            [20.970624495350066, 56.357750153837557],
                            [20.970769978128814, 56.358607712525],
                            [20.970840817883065, 56.359283655593465],
                            [20.970859555361749, 56.359742576806319],
                            [20.970972123228663, 56.361327476450406],
                            [20.970975370062678, 56.361669155547958],
                            [20.97096664444393, 56.362289215182884],
                            [20.970876390183495, 56.362916270016534],
                            [20.970788799160204, 56.363471474215181],
                            [20.970871387544229, 56.363922967563369],
                            [20.970964278834884, 56.364563491514794],
                            [20.971091745669177, 56.365348692338749],
                            [20.971175543320271, 56.366186761629365],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "KalÄ“tu",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.49137190576074, 56.290082704498261],
                            [21.485131266904727, 56.289800963626114],
                            [21.482151408117101, 56.292167756808446],
                            [21.47859914985683, 56.291524295137648],
                            [21.475809353253879, 56.294894322540721],
                            [21.472249690694536, 56.298248572108257],
                            [21.476981345913469, 56.300486911048885],
                            [21.473287176075214, 56.301982219357299],
                            [21.47296697245379, 56.306830443013666],
                            [21.469196558611475, 56.309466377382833],
                            [21.463619095855112, 56.308352723827667],
                            [21.456749919575298, 56.307355072954294],
                            [21.448170871967928, 56.308891987156052],
                            [21.442631393749242, 56.31106229228817],
                            [21.445576508578949, 56.313122126503288],
                            [21.438630587371197, 56.313264198190225],
                            [21.439276124150911, 56.315133799601014],
                            [21.435351199370761, 56.316194867342169],
                            [21.432651496627621, 56.318137955771675],
                            [21.433220238602932, 56.321148305265652],
                            [21.430292209843568, 56.322658247437893],
                            [21.42270634311425, 56.324642418289123],
                            [21.418629273395396, 56.324129125191448],
                            [21.414160680026995, 56.325606569643185],
                            [21.406089165471872, 56.327151226931043],
                            [21.400423794937467, 56.327318002422096],
                            [21.39509275343412, 56.326349232684855],
                            [21.391344272567522, 56.328554963320407],
                            [21.393774591814989, 56.330605196652634],
                            [21.388267893347571, 56.332202663502571],
                            [21.38320574752057, 56.334808817325964],
                            [21.388943854951769, 56.337357361530344],
                            [21.393694759512332, 56.339313700313753],
                            [21.397831350106486, 56.338972311561065],
                            [21.40285903200467, 56.340648526458608],
                            [21.403750284270711, 56.342666262834825],
                            [21.408701335514049, 56.345482937147636],
                            [21.412552743579056, 56.345563450622045],
                            [21.41455858128106, 56.34631927895083],
                            [21.414535455070755, 56.350459669755971],
                            [21.419430494243091, 56.354131452675659],
                            [21.422111131780603, 56.356329088629828],
                            [21.427427840912934, 56.357581912800313],
                            [21.429072137901507, 56.359900653130019],
                            [21.427624507504223, 56.362297999207712],
                            [21.427185040669745, 56.365001844342885],
                            [21.426488593043672, 56.367700350482295],
                            [21.426514757499678, 56.371127801902396],
                            [21.425664220206507, 56.376107707164046],
                            [21.429357865017604, 56.374756507883532],
                            [21.439093731392738, 56.375386452704817],
                            [21.443187114411188, 56.371901301845625],
                            [21.447649997733844, 56.374420683601905],
                            [21.453826632454025, 56.374404962188478],
                            [21.453788507797135, 56.37112008714594],
                            [21.456262557387802, 56.368743528649347],
                            [21.461134677864813, 56.368986238801952],
                            [21.467397055497624, 56.371541756587604],
                            [21.466693845097222, 56.374383103039541],
                            [21.471005572552258, 56.375327887479749],
                            [21.474251840170169, 56.376821950922121],
                            [21.481494480243406, 56.376255425884516],
                            [21.485969829925587, 56.378630858976486],
                            [21.4878662005375, 56.381096659366861],
                            [21.491702686806835, 56.381459934808909],
                            [21.499544128140354, 56.379619404740623],
                            [21.502296530982605, 56.380817181809867],
                            [21.5070719250715, 56.378628782932616],
                            [21.515379621373683, 56.37751056238973],
                            [21.518584146114922, 56.375718578320587],
                            [21.527598872029216, 56.371615251027983],
                            [21.53949263310518, 56.370709716028792],
                            [21.549789224667968, 56.370628170179273],
                            [21.558726478918519, 56.367663351420617],
                            [21.56312772835804, 56.366371632065054],
                            [21.563168254673275, 56.366061657828944],
                            [21.566961499753916, 56.365246261217187],
                            [21.569847343641698, 56.361891472456712],
                            [21.569483354145493, 56.359214524481295],
                            [21.568023773359659, 56.356961041386668],
                            [21.563268001223502, 56.356125982083789],
                            [21.562446536110691, 56.352253421736492],
                            [21.565619842317503, 56.352760787316171],
                            [21.568658456248851, 56.351188906837777],
                            [21.575993606352068, 56.349256131376919],
                            [21.580346619569756, 56.348006328635329],
                            [21.585387289393704, 56.348549648715988],
                            [21.587460595372914, 56.345326954630657],
                            [21.590928467796619, 56.345394444914966],
                            [21.594400111464118, 56.341160573700435],
                            [21.597942128724416, 56.340042736358555],
                            [21.594441154181254, 56.336266742416413],
                            [21.591858203042044, 56.334881649757108],
                            [21.591244877930833, 56.331903277098547],
                            [21.593471480064554, 56.330463339298156],
                            [21.594144653060265, 56.328251584024734],
                            [21.596251224195349, 56.324217239066044],
                            [21.596099740430105, 56.323278596298955],
                            [21.596050905499474, 56.323285156942703],
                            [21.595704678525994, 56.323188556267226],
                            [21.595090472502864, 56.323149663156663],
                            [21.594724355206768, 56.323007734732144],
                            [21.5943541325579, 56.323027504310843],
                            [21.59408508105529, 56.3230941775766],
                            [21.59369591400683, 56.323077626160249],
                            [21.593574910508618, 56.322976409233753],
                            [21.593352172493915, 56.322837263625402],
                            [21.592843318867899, 56.322674579200495],
                            [21.592048980113976, 56.322470389196901],
                            [21.591777303849472, 56.322626883631401],
                            [21.591463986850755, 56.322818518259012],
                            [21.591031165728943, 56.322837060009142],
                            [21.59056196026032, 56.322711088504299],
                            [21.589867927331362, 56.32260770157076],
                            [21.588655778963044, 56.322593084928357],
                            [21.588182389056279, 56.322637789693012],
                            [21.587687795378848, 56.322682079486654],
                            [21.587276177058985, 56.322701021262596],
                            [21.587221053827061, 56.322493229041378],
                            [21.587428832077983, 56.322380437854164],
                            [21.587411397390731, 56.322272245268628],
                            [21.587172951575518, 56.321997966087103],
                            [21.586814290687247, 56.321658428921019],
                            [21.586532758805344, 56.321410271712388],
                            [21.586105670653613, 56.321258140817768],
                            [21.586137176648794, 56.320935196532673],
                            [21.586326580892411, 56.320777110257978],
                            [21.586005303319709, 56.320510201286922],
                            [21.585597728316426, 56.320385412222087],
                            [21.585130085561492, 56.320259450042414],
                            [21.584986972715118, 56.320220707248573],
                            [21.584803476767416, 56.320181176421919],
                            [21.584449755367753, 56.320300103269929],
                            [21.584304886015545, 56.32036917834774],
                            [21.584116796841499, 56.320482348543678],
                            [21.584009349443299, 56.320615067803146],
                            [21.583911344838459, 56.320478338900116],
                            [21.583567501111361, 56.320264909433867],
                            [21.583039225085649, 56.320074841452751],
                            [21.582471326992955, 56.31984804638688],
                            [21.582164981557021, 56.319761173670116],
                            [21.581612429941284, 56.319723417091502],
                            [21.581034830132065, 56.319802009384439],
                            [21.580583299414176, 56.319757234408371],
                            [21.580212849174728, 56.319812908010249],
                            [21.579758286564456, 56.319911874865511],
                            [21.579189655125827, 56.319649099126181],
                            [21.579158120388776, 56.319324923116689],
                            [21.579165133204096, 56.319118341790315],
                            [21.578947398150721, 56.318853438566521],
                            [21.578665619954695, 56.318650196580869],
                            [21.578630425581977, 56.318415826372018],
                            [21.578536683267103, 56.318108408790962],
                            [21.578358956883608, 56.317898213578303],
                            [21.577998706882276, 56.317585581618097],
                            [21.577639414296275, 56.317210052907413],
                            [21.577564416095822, 56.316965915583573],
                            [21.577673714233072, 56.316716396978613],
                            [21.577475112900387, 56.316532755141147],
                            [21.577416192169661, 56.31644172436404],
                            [21.577260822301671, 56.31614208722894],
                            [21.577207851554618, 56.315853441884798],
                            [21.577355373935646, 56.315694549360103],
                            [21.577890643442771, 56.315669073115821],
                            [21.578322251646963, 56.315668529915492],
                            [21.578489639754011, 56.315554963565454],
                            [21.578453498682212, 56.315383489008404],
                            [21.578202703715977, 56.315513399042338],
                            [21.578175830525556, 56.315458946676891],
                            [21.57806745648681, 56.315223144367579],
                            [21.577784125773576, 56.31510075947012],
                            [21.577540350668606, 56.315024086860284],
                            [21.577254180021857, 56.31494658398146],
                            [21.576863142436395, 56.314992856421988],
                            [21.576638989940879, 56.314925553902249],
                            [21.576378386529036, 56.314731708473396],
                            [21.575968500804247, 56.314660767986489],
                            [21.57563960915526, 56.314699265757056],
                            [21.575450761049236, 56.314848359076755],
                            [21.575240144105887, 56.315006013474168],
                            [21.574906770765679, 56.315035433769673],
                            [21.574410401035387, 56.31526837815786],
                            [21.573917014887758, 56.315541824087823],
                            [21.573282765035664, 56.315677689981534],
                            [21.572382022181564, 56.31591168608476],
                            [21.5718998401954, 56.316064008873795],
                            [21.571450449327035, 56.316010254149418],
                            [21.571280781961342, 56.315809194077247],
                            [21.57088676585845, 56.315846401578803],
                            [21.570585592107832, 56.315750613219961],
                            [21.569781379407868, 56.315483168953207],
                            [21.569109700059496, 56.315110468638622],
                            [21.568658041997381, 56.315092610244008],
                            [21.568143667177985, 56.315091493659096],
                            [21.567667692709804, 56.315154044062524],
                            [21.567043568467021, 56.315249632047447],
                            [21.566390751072401, 56.315470481962976],
                            [21.565949062646236, 56.315605602280755],
                            [21.565555043940044, 56.315642792790726],
                            [21.5652575691138, 56.315798722427502],
                            [21.565060970946849, 56.315965623533039],
                            [21.564123863187287, 56.316126942403457],
                            [21.563744947470258, 56.31623632684655],
                            [21.563550056073417, 56.316376295821712],
                            [21.563062887853185, 56.316582413299308],
                            [21.562652469571447, 56.316583320629292],
                            [21.562252417928988, 56.316413662436595],
                            [21.561909369141478, 56.316317028115883],
                            [21.561626047232508, 56.316266508405455],
                            [21.561436949234192, 56.316038088110766],
                            [21.561410879964008, 56.315812879319338],
                            [21.561388614565566, 56.315551794213079],
                            [21.561539098584884, 56.31527613665618],
                            [21.56167699427397, 56.315063145625878],
                            [21.561878549817013, 56.314842420555806],
                            [21.562260519732174, 56.314661199582616],
                            [21.562557728188082, 56.314541223074869],
                            [21.562629969610491, 56.314398840668169],
                            [21.562560085443781, 56.314226696218917],
                            [21.562490773951939, 56.314045575188082],
                            [21.562234588997264, 56.313878749541054],
                            [21.561571241264708, 56.313955561762221],
                            [21.560866505369631, 56.314031554899863],
                            [21.560330676992201, 56.31406593418879],
                            [21.559983713479991, 56.314023143948056],
                            [21.559706274354888, 56.313864881788092],
                            [21.559352163586173, 56.313633204687811],
                            [21.559262748683292, 56.313442697445787],
                            [21.558987512600766, 56.313194598840013],
                            [21.559104790532487, 56.312972216126184],
                            [21.559521197743685, 56.312908524343435],
                            [21.560169428975033, 56.312759522763614],
                            [21.56067939488841, 56.312805525025162],
                            [21.560755406246724, 56.312699169191767],
                            [21.561375127971768, 56.312648465499358],
                            [21.561569006735695, 56.312238845668496],
                            [21.561242963468572, 56.311899873048134],
                            [21.560829513122194, 56.311640067396709],
                            [21.560696859592493, 56.311493648170632],
                            [21.560565419778591, 56.311320289259037],
                            [21.560406775320086, 56.310939674197002],
                            [21.560304549454941, 56.310641061308061],
                            [21.559990855599505, 56.31014054771213],
                            [21.559780028868019, 56.309920683729587],
                            [21.559277844154362, 56.309452403120765],
                            [21.558755254197933, 56.309280316032286],
                            [21.558562674365945, 56.309051821891977],
                            [21.558101658406418, 56.308880946492039],
                            [21.557867867374966, 56.308696577258708],
                            [21.55749291963425, 56.308491446378198],
                            [21.55728440884857, 56.308235672226864],
                            [21.557073607988645, 56.308015803802625],
                            [21.556739040645912, 56.307811467508884],
                            [21.556395509381105, 56.307723795101779],
                            [21.556025624831658, 56.307716491841695],
                            [21.555784395388219, 56.307648813408754],
                            [21.555735242777324, 56.307477073887405],
                            [21.555834423925187, 56.307245348865983],
                            [21.555915919884225, 56.306950359701332],
                            [21.556131983299515, 56.306810820849542],
                            [21.556657871817698, 56.306677398400446],
                            [21.556987378178246, 56.306683902873345],
                            [21.557352369035062, 56.306736045938308],
                            [21.557681876070948, 56.306742548568238],
                            [21.558050911034464, 56.306462219696257],
                            [21.557930386315292, 56.306118304144611],
                            [21.557673906169132, 56.305403204575931],
                            [21.557422556773027, 56.30487695004517],
                            [21.556873152998794, 56.304524568249299],
                            [21.556173925069334, 56.304232140400977],
                            [21.55552576265525, 56.303796911678994],
                            [21.555009697796898, 56.303247447194821],
                            [21.554669777391812, 56.302827290639939],
                            [21.554377352777006, 56.3025968163277],
                            [21.553866147072625, 56.302272138771045],
                            [21.55298757816059, 56.302209831288273],
                            [21.552327287214897, 56.302241713255874],
                            [21.552000412675717, 56.30222626014956],
                            [21.551592725930767, 56.302155280339257],
                            [21.550965480604546, 56.302026027457948],
                            [21.55057783945233, 56.301973416640791],
                            [21.550160040502259, 56.301776401941261],
                            [21.549737577312573, 56.301660184137354],
                            [21.549523406324134, 56.301494162200328],
                            [21.549311466359228, 56.301301220475182],
                            [21.549104773236568, 56.301018503683224],
                            [21.549036122732417, 56.300828399067576],
                            [21.548947796552838, 56.30063790471668],
                            [21.548859612126595, 56.300429437376124],
                            [21.548763449290963, 56.300337654110869],
                            [21.548651201856149, 56.300173649276829],
                            [21.548585430120752, 56.299938662065664],
                            [21.548584447811511, 56.299677994630336],
                            [21.548602636659002, 56.299417706941831],
                            [21.548521145434869, 56.29912848109818],
                            [21.548080978118662, 56.2989579793297],
                            [21.547771823127558, 56.298682217721456],
                            [21.547513103183288, 56.298281624679511],
                            [21.547226509092994, 56.297961369350645],
                            [21.546693591145743, 56.29765420600404],
                            [21.546019570405658, 56.297326266507255],
                            [21.545015372146167, 56.297279385417539],
                            [21.544344936658703, 56.297454828695379],
                            [21.544067627991403, 56.29762009520752],
                            [21.543702826668927, 56.297810588161632],
                            [21.543226454455013, 56.297882022755168],
                            [21.542785172776252, 56.297729455334462],
                            [21.542496893381941, 56.29743611872069],
                            [21.542272830335843, 56.297126080998552],
                            [21.542018359290061, 56.296959244946152],
                            [21.541480956729558, 56.296714884598472],
                            [21.541230452394228, 56.296745859104725],
                            [21.540984993742558, 56.296714018178939],
                            [21.540529756439362, 56.296480274154398],
                            [21.539840738852355, 56.296331759836193],
                            [21.539278059435759, 56.296158790248228],
                            [21.538965095679568, 56.295927869299362],
                            [21.538460001208847, 56.295809968442278],
                            [21.538117440626749, 56.295434650218922],
                            [21.538117902372228, 56.295129071016831],
                            [21.53783812054964, 56.294728037151188],
                            [21.537297888370329, 56.294528541103148],
                            [21.536921741229328, 56.294377248273754],
                            [21.536471251733829, 56.294062692070135],
                            [21.536153699466102, 56.293903575423222],
                            [21.535644017145401, 56.293857474513672],
                            [21.535220172894864, 56.293741178062071],
                            [21.534583783040887, 56.293458863322542],
                            [21.534138539336293, 56.293369100433601],
                            [21.533803948079086, 56.293443323615058],
                            [21.533430084670002, 56.29350777518853],
                            [21.533017319757334, 56.293517522641146],
                            [21.532760020199746, 56.293395549913974],
                            [21.532430634148415, 56.293388982000245],
                            [21.532131337823269, 56.29322123089986],
                            [21.531779387089415, 56.293259150772847],
                            [21.53140841677321, 56.293278714395356],
                            [21.531158936277034, 56.293309688789101],
                            [21.530580929747007, 56.293352082828399],
                            [21.530021510694155, 56.293403833118269],
                            [21.529195531823039, 56.293477222446533],
                            [21.528345616572331, 56.293577091950468],
                            [21.527607835026966, 56.293840978771932],
                            [21.527016780333284, 56.294053866144033],
                            [21.526437018253674, 56.294123169685655],
                            [21.525966816692947, 56.294122757638817],
                            [21.525645599232568, 56.294044431612456],
                            [21.525238630950387, 56.293964389817887],
                            [21.524572999675151, 56.293807269035867],
                            [21.523913990027673, 56.29352444604929],
                            [21.523414079598666, 56.293280755513521],
                            [21.523088457071918, 56.293247274214984],
                            [21.522647536468149, 56.293364278713113],
                            [21.522253402739196, 56.293437278827533],
                            [21.521888314747432, 56.293358064439055],
                            [21.521771553501939, 56.293265846679887],
                            [21.52170479550659, 56.293048799132734],
                            [21.521618289537631, 56.29284034394739],
                            [21.521492901696572, 56.292577182250191],
                            [21.521403217814143, 56.29238663910462],
                            [21.521176491865507, 56.292175374765307],
                            [21.520564613468157, 56.292109188081014],
                            [21.519772626363142, 56.291985460708318],
                            [21.518931216431017, 56.291977580567064],
                            [21.518463252926523, 56.291896293041049],
                            [21.518153205074771, 56.291638412161426],
                            [21.518184632157368, 56.291504223245539],
                            [21.51839387331307, 56.291166877723064],
                            [21.51819161459095, 56.291045977820467],
                            [21.517906948618709, 56.291004316121814],
                            [21.516973177864347, 56.291120401035144],
                            [21.516165551433858, 56.290942408625519],
                            [21.515606555940277, 56.290715475385873],
                            [21.515162695179701, 56.290302104551223],
                            [21.51475829707498, 56.289934464420604],
                            [21.514389828526074, 56.289612484442735],
                            [21.513763422970612, 56.289483055933957],
                            [21.513248394727054, 56.289769309073137],
                            [21.512999350107641, 56.290096858392111],
                            [21.512787734982602, 56.290470099445351],
                            [21.512909052769601, 56.290787116764101],
                            [21.513167281333775, 56.291196765232215],
                            [21.513356553729746, 56.291416280133774],
                            [21.513620464258786, 56.291754138011285],
                            [21.513379572817087, 56.291956020476128],
                            [21.51271935331042, 56.291996678903729],
                            [21.511823907638796, 56.292167423542878],
                            [21.510630565046302, 56.292251277376756],
                            [21.510236075529235, 56.29230625624492],
                            [21.510077379980011, 56.292509786338584],
                            [21.510003235890434, 56.292679065803902],
                            [21.509780664335857, 56.29291726204147],
                            [21.509482216310051, 56.293064051056533],
                            [21.50918827946926, 56.293157002350874],
                            [21.508508603078724, 56.293170283005601],
                            [21.507973026906221, 56.293204438014136],
                            [21.50755266285443, 56.293330791185674],
                            [21.507033912792789, 56.293401232988955],
                            [21.506752165684553, 56.293314664610236],
                            [21.506452502220803, 56.29320077059981],
                            [21.506175538802239, 56.293087333333162],
                            [21.505890844210459, 56.292767016039633],
                            [21.505539595027361, 56.292499284260629],
                            [21.505302647883635, 56.292368675658977],
                            [21.504844172599562, 56.292188659813355],
                            [21.504622300556775, 56.292121269734949],
                            [21.504103461946983, 56.292146757420852],
                            [21.503856652218257, 56.292159754820517],
                            [21.503565555128478, 56.292216798175978],
                            [21.503107178394902, 56.292306417432684],
                            [21.502647628310473, 56.292413987312521],
                            [21.502387833412858, 56.292579515570274],
                            [21.502289541945157, 56.292793243341436],
                            [21.502373859862956, 56.29306458498408],
                            [21.502766371920618, 56.293342146650239],
                            [21.502961792296695, 56.293489898113194],
                            [21.50327793075558, 56.293622109055725],
                            [21.503782883981604, 56.293740152265315],
                            [21.504056090129854, 56.293934410978366],
                            [21.504212840072697, 56.294063404387614],
                            [21.504261826268095, 56.2942261760967],
                            [21.504093383026095, 56.294555334077209],
                            [21.503717786029288, 56.29463763752841],
                            [21.503236437974177, 56.294753758108371],
                            [21.502668684362064, 56.294940036976243],
                            [21.502288052741413, 56.295076162478757],
                            [21.501867405437789, 56.295229454989233],
                            [21.501512723513397, 56.295285210126892],
                            [21.500862740615581, 56.295191192859626],
                            [21.500520722390721, 56.295130357023851],
                            [21.500137669436384, 56.295032739282703],
                            [21.499793799962287, 56.294953888019641],
                            [21.499630270772357, 56.294905643872042],
                            [21.499063939877963, 56.294768367296307],
                            [21.498706772935741, 56.29459936422974],
                            [21.498396838266121, 56.294341434972154],
                            [21.498377357995142, 56.294044437187495],
                            [21.49847418816281, 56.293552054759658],
                            [21.498616128381553, 56.293312248138811],
                            [21.499121210418906, 56.292585441342467],
                            [21.49941132752501, 56.292249760588732],
                            [21.499471123431132, 56.291999305009398],
                            [21.49915491747419, 56.291822142649899],
                            [21.498672947965794, 56.291677580685608],
                            [21.498358316576009, 56.291770088101828],
                            [21.496403420775049, 56.292377686403405],
                            [21.495968642195301, 56.292422816837124],
                            [21.495443638529029, 56.292295347402806],
                            [21.494966964314536, 56.292069986005131],
                            [21.494392101619624, 56.291770730387555],
                            [21.493972273480235, 56.291618420196642],
                            [21.493197790395037, 56.291521840156875],
                            [21.492465679138881, 56.291426113898424],
                            [21.491998202135594, 56.291353723426063],
                            [21.491542743869953, 56.291128778468916],
                            [21.491311736103285, 56.290908382606624],
                            [21.49137190576074, 56.290082704498261],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "BÄrtas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.38320574752057, 56.334808817325964],
                            [21.379433735195985, 56.333586732968243],
                            [21.373618447559565, 56.332178422370198],
                            [21.370736299278516, 56.332974008990945],
                            [21.365730721212984, 56.33101134696625],
                            [21.360962610732059, 56.32933911984842],
                            [21.355129048693772, 56.33192770187383],
                            [21.350213021932863, 56.332393775551516],
                            [21.343332792696632, 56.331532403338969],
                            [21.337449668965, 56.331120465258998],
                            [21.332810104624539, 56.33130620762622],
                            [21.319051202718796, 56.329581161254254],
                            [21.315121567482354, 56.330638368384484],
                            [21.305469799469517, 56.329000783993877],
                            [21.300523396857319, 56.329892608163156],
                            [21.296245816036858, 56.332226785537877],
                            [21.289768988167118, 56.332941968200956],
                            [21.279378326129365, 56.330857783771556],
                            [21.272355395501343, 56.328418557478436],
                            [21.267029376417653, 56.33101423649282],
                            [21.261712851928948, 56.333467108423086],
                            [21.254208617964711, 56.334157717345576],
                            [21.250677256028268, 56.33679249481677],
                            [21.251519326553275, 56.339381519012271],
                            [21.247894846089423, 56.343299323925365],
                            [21.243047675571034, 56.346333040901655],
                            [21.240829042417051, 56.348568379995854],
                            [21.239554741135908, 56.351967103699678],
                            [21.236585856595145, 56.353900056612652],
                            [21.232424150579753, 56.358091045333779],
                            [21.228222083378551, 56.359282265170876],
                            [21.225117324520284, 56.363068276680785],
                            [21.219967414158688, 56.366665543751317],
                            [21.212449098455444, 56.365583293713584],
                            [21.215778791262245, 56.373750968821135],
                            [21.214568052655824, 56.374968802143748],
                            [21.203745669654179, 56.377215136211312],
                            [21.202934996929997, 56.380620726232159],
                            [21.20308492727041, 56.386226831709642],
                            [21.198661517483814, 56.392974693474713],
                            [21.198204774010136, 56.399189614965586],
                            [21.197519317932368, 56.408511980901849],
                            [21.199441548929812, 56.412913084580168],
                            [21.21053914341406, 56.414719583841169],
                            [21.21405424073, 56.420401300129633],
                            [21.222079174929551, 56.425872755918846],
                            [21.227514689337447, 56.425666751454962],
                            [21.233198573219902, 56.418368336609291],
                            [21.237776741437255, 56.419184393375929],
                            [21.241563678693517, 56.416698387091429],
                            [21.249403383032242, 56.415159021245621],
                            [21.254249012054967, 56.415837608901093],
                            [21.25843536709483, 56.411360824512926],
                            [21.263660736789461, 56.410333912924543],
                            [21.269985975514327, 56.408331450971588],
                            [21.275477972850371, 56.407167127022326],
                            [21.278675741510643, 56.40566663386889],
                            [21.281359002509991, 56.404154778312332],
                            [21.283757545031094, 56.406634848026521],
                            [21.298923685739179, 56.410678835200592],
                            [21.304087398399979, 56.410505644854375],
                            [21.312983816284124, 56.415839296096479],
                            [21.319156971906967, 56.415972926055396],
                            [21.320583444243248, 56.414004677346981],
                            [21.323462764831472, 56.413352911206559],
                            [21.330544496872491, 56.415219084297846],
                            [21.347263548630085, 56.415577919910177],
                            [21.392652616236695, 56.414827235609977],
                            [21.42459719870951, 56.414780930802536],
                            [21.440326688322738, 56.414535499038912],
                            [21.439708305501089, 56.412238148578759],
                            [21.442272105249771, 56.408578617103615],
                            [21.440597625462868, 56.402832599368651],
                            [21.437122137607712, 56.400904570354101],
                            [21.434750320274432, 56.401712234292987],
                            [21.432647310785356, 56.398527385353823],
                            [21.433829367213754, 56.396267269019994],
                            [21.438105966504885, 56.393928352229061],
                            [21.43643095340639, 56.392037491067065],
                            [21.432872356695817, 56.387537437824264],
                            [21.428428183358257, 56.384732347626851],
                            [21.427659705107189, 56.380861136595392],
                            [21.427100268910188, 56.377708195683901],
                            [21.425664220206507, 56.376107707164046],
                            [21.426514757499678, 56.371127801902396],
                            [21.426488593043672, 56.367700350482295],
                            [21.427185040669745, 56.365001844342885],
                            [21.427624507504223, 56.362297999207712],
                            [21.429072137901507, 56.359900653130019],
                            [21.427427840912934, 56.357581912800313],
                            [21.422111131780603, 56.356329088629828],
                            [21.419430494243091, 56.354131452675659],
                            [21.414535455070755, 56.350459669755971],
                            [21.41455858128106, 56.34631927895083],
                            [21.412552743579056, 56.345563450622045],
                            [21.408701335514049, 56.345482937147636],
                            [21.403750284270711, 56.342666262834825],
                            [21.40285903200467, 56.340648526458608],
                            [21.397831350106486, 56.338972311561065],
                            [21.393694759512332, 56.339313700313753],
                            [21.388943854951769, 56.337357361530344],
                            [21.38320574752057, 56.334808817325964],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Dunikas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.38320574752057, 56.334808817325964],
                            [21.388267893347571, 56.332202663502571],
                            [21.393774591814989, 56.330605196652634],
                            [21.391344272567522, 56.328554963320407],
                            [21.39509275343412, 56.326349232684855],
                            [21.400423794937467, 56.327318002422096],
                            [21.406089165471872, 56.327151226931043],
                            [21.414160680026995, 56.325606569643185],
                            [21.418629273395396, 56.324129125191448],
                            [21.42270634311425, 56.324642418289123],
                            [21.430292209843568, 56.322658247437893],
                            [21.433220238602932, 56.321148305265652],
                            [21.432651496627621, 56.318137955771675],
                            [21.435351199370761, 56.316194867342169],
                            [21.439276124150911, 56.315133799601014],
                            [21.438630587371197, 56.313264198190225],
                            [21.445576508578949, 56.313122126503288],
                            [21.442631393749242, 56.31106229228817],
                            [21.448170871967928, 56.308891987156052],
                            [21.456749919575298, 56.307355072954294],
                            [21.463619095855112, 56.308352723827667],
                            [21.469196558611475, 56.309466377382833],
                            [21.47296697245379, 56.306830443013666],
                            [21.473287176075214, 56.301982219357299],
                            [21.476981345913469, 56.300486911048885],
                            [21.472249690694536, 56.298248572108257],
                            [21.475809353253879, 56.294894322540721],
                            [21.47859914985683, 56.291524295137648],
                            [21.482151408117101, 56.292167756808446],
                            [21.485131266904727, 56.289800963626114],
                            [21.49137190576074, 56.290082704498261],
                            [21.491409552135799, 56.289562162441349],
                            [21.491157708167123, 56.289359319738708],
                            [21.490777678930549, 56.289216793208745],
                            [21.490563246335924, 56.289059648027866],
                            [21.491009757157695, 56.288781086190966],
                            [21.486189843440592, 56.284144295336354],
                            [21.482392751950847, 56.280993172843232],
                            [21.47674659693886, 56.276743632229035],
                            [21.472806614478916, 56.273867911401723],
                            [21.469286761584449, 56.272007320793989],
                            [21.467216032482266, 56.27083243798365],
                            [21.465849916602508, 56.268683263613994],
                            [21.465802838951198, 56.268196940869323],
                            [21.465438392083922, 56.267281673779529],
                            [21.465090650291337, 56.266411688263574],
                            [21.465212117119908, 56.266162510193645],
                            [21.465738545349819, 56.265696926928364],
                            [21.466000360190371, 56.265477588010249],
                            [21.46602119243839, 56.265208371235204],
                            [21.465993178642581, 56.264731426996967],
                            [21.465887749119069, 56.263929324288227],
                            [21.465890134108648, 56.263336157159642],
                            [21.465771919417548, 56.262704566514827],
                            [21.465568591109832, 56.262116172207151],
                            [21.465321064181129, 56.261562824167484],
                            [21.465205984497686, 56.26117397631549],
                            [21.464895114012855, 56.26065528150427],
                            [21.464616344709373, 56.260254089521709],
                            [21.464211557356116, 56.25990424190703],
                            [21.464025688807787, 56.259639775100993],
                            [21.463700356334179, 56.25930953109242],
                            [21.463163984448826, 56.25906483886169],
                            [21.462548358561214, 56.2587825656571],
                            [21.462057071182109, 56.258466888329963],
                            [21.4615340326785, 56.258051687717575],
                            [21.459761929049677, 56.256451364799865],
                            [21.459045712900231, 56.255906350808615],
                            [21.458518254152249, 56.25553598646276],
                            [21.457344312890097, 56.254756850906375],
                            [21.457279172319918, 56.254521819564609],
                            [21.457118933234717, 56.253628697397481],
                            [21.456953937482126, 56.252807382279109],
                            [21.455353331388519, 56.251381291879675],
                            [21.455138109438277, 56.251188111546938],
                            [21.451882276963364, 56.248343720361724],
                            [21.449100491649027, 56.2478818982921],
                            [21.439859172264732, 56.246351669785874],
                            [21.43953651988793, 56.246273083383365],
                            [21.43935864012354, 56.246179517788548],
                            [21.439205515867208, 56.246032535328453],
                            [21.436917192319669, 56.244502067354958],
                            [21.431350252283337, 56.240683392402786],
                            [21.430839204830988, 56.240654797910459],
                            [21.430470002411894, 56.24064712569082],
                            [21.419130154038651, 56.241938946162321],
                            [21.416692248843002, 56.242157682969541],
                            [21.41527266136746, 56.241381987733838],
                            [21.403875642287939, 56.235705276421932],
                            [21.395930238194527, 56.233309066928868],
                            [21.382897196524855, 56.229294684074567],
                            [21.381131317657296, 56.228762925046219],
                            [21.37910973226203, 56.228099881462569],
                            [21.378205890902116, 56.227838028336954],
                            [21.377465367699777, 56.22760659859388],
                            [21.377182670583, 56.227537681966929],
                            [21.376224681224372, 56.227463421646434],
                            [21.374741261282196, 56.227279123708897],
                            [21.369967015792319, 56.22666529871131],
                            [21.368079482320478, 56.226382437068551],
                            [21.364577072996372, 56.226047150671789],
                            [21.364295305242024, 56.225987212395729],
                            [21.363770426162603, 56.225877146744708],
                            [21.363255417931551, 56.2256234742812],
                            [21.362659863060582, 56.225368081080475],
                            [21.362064547530316, 56.22537335499473],
                            [21.361420769821127, 56.22546747607732],
                            [21.360863032726769, 56.225527477063778],
                            [21.36023496113679, 56.22541519295811],
                            [21.359776739380994, 56.225252602863556],
                            [21.359297101396336, 56.225071576593663],
                            [21.35891573364421, 56.224964555767045],
                            [21.358260513614844, 56.224968531336685],
                            [21.357259103298251, 56.224911171712385],
                            [21.355795514239134, 56.224727068019099],
                            [21.354693540431402, 56.22465854775561],
                            [21.353797207493017, 56.224576443173483],
                            [21.353331942103605, 56.22449457418567],
                            [21.353090479470421, 56.224435472998529],
                            [21.35261999190676, 56.224407420312822],
                            [21.352251926479489, 56.224129882470933],
                            [21.352227133271459, 56.223904639480033],
                            [21.352043099782083, 56.223649019847038],
                            [21.351621336998882, 56.223514145281683],
                            [21.351012612042776, 56.223429193518612],
                            [21.350521265532844, 56.22341866261236],
                            [21.350132851372869, 56.223392359478765],
                            [21.349856507269799, 56.223422388867533],
                            [21.349325968696494, 56.223482920793693],
                            [21.348937205019872, 56.223483571862651],
                            [21.348593056435742, 56.223422259316763],
                            [21.348216697358954, 56.223243404431429],
                            [21.347754678965721, 56.223107652818122],
                            [21.347323514687705, 56.223116377448576],
                            [21.346891109260344, 56.223143050920669],
                            [21.346589371804228, 56.223073654539249],
                            [21.346244106759062, 56.223021299886994],
                            [21.345766575476386, 56.222840265188282],
                            [21.345377667460973, 56.222813936392178],
                            [21.345075314509781, 56.222753511526136],
                            [21.344897776640192, 56.222659813071346],
                            [21.344713529764864, 56.222386200249723],
                            [21.344589459345684, 56.222131856908945],
                            [21.344463645040708, 56.221895452950136],
                            [21.344397384273613, 56.22168729385524],
                            [21.344265982860676, 56.22153166612258],
                            [21.344109327385571, 56.221420438104019],
                            [21.344065454194393, 56.221194782829656],
                            [21.344081249927655, 56.220988386692071],
                            [21.344219990659163, 56.220775643778211],
                            [21.344440043544857, 56.220582624733936],
                            [21.344332271988499, 56.220391550681285],
                            [21.344088097041464, 56.220350350130033],
                            [21.343824793996742, 56.220308738029395],
                            [21.343474470019625, 56.220337163106215],
                            [21.34257053966552, 56.220344697340593],
                            [21.34219113131217, 56.220210700322248],
                            [21.342102145966702, 56.220046993660368],
                            [21.342018991786567, 56.219784538716162],
                            [21.3419570985949, 56.219513552410021],
                            [21.341744286331465, 56.21934718243773],
                            [21.341514834518968, 56.219144500127967],
                            [21.341087563017009, 56.219090366630404],
                            [21.340460782433599, 56.218969019242799],
                            [21.339911196713789, 56.2189122496614],
                            [21.33950009450513, 56.218930366751017],
                            [21.33882881565042, 56.218861984254346],
                            [21.338484725298823, 56.218800644087104],
                            [21.33816426703369, 56.218703857812145],
                            [21.337784387164792, 56.218569836703033],
                            [21.337694417584476, 56.218406105363592],
                            [21.337707133284752, 56.218244585845127],
                            [21.33776198468103, 56.218057008353206],
                            [21.337732299283214, 56.217903564034224],
                            [21.337451495793498, 56.217816618473002],
                            [21.337190708242986, 56.217739092017695],
                            [21.336950559011278, 56.21766200968306],
                            [21.336689150792026, 56.217593457296609],
                            [21.336475126429736, 56.217445028745466],
                            [21.336091408071731, 56.217373839171245],
                            [21.335899948344384, 56.217459597685668],
                            [21.335841974050759, 56.217692049793499],
                            [21.335783111933953, 56.217915494208796],
                            [21.335527124731485, 56.218044803868757],
                            [21.335310610128403, 56.217932273722141],
                            [21.335038176735896, 56.217746629226852],
                            [21.334653211720095, 56.217693385377309],
                            [21.33432390281903, 56.217695271904581],
                            [21.333774968639865, 56.217629500210947],
                            [21.333427358554641, 56.217343356391083],
                            [21.333124444571737, 56.217291877934102],
                            [21.332770519559659, 56.217365137427095],
                            [21.332553425810794, 56.217522245956673],
                            [21.332624605315196, 56.217658610213533],
                            [21.332746711487758, 56.217939890053103],
                            [21.332653176170378, 56.218081688087274],
                            [21.332493241061865, 56.218293961310025],
                            [21.332262748018554, 56.218360894815369],
                            [21.331980925997158, 56.218237960577177],
                            [21.331797202117976, 56.218233994478041],
                            [21.331263527417828, 56.218231460881341],
                            [21.33073261123927, 56.218211007468028],
                            [21.330258594128804, 56.218227735004326],
                            [21.330166559006255, 56.218369563673683],
                            [21.329936197123828, 56.218688174972968],
                            [21.329565865667742, 56.218707139798177],
                            [21.328989409771385, 56.218478958439938],
                            [21.328587290713301, 56.21809274866888],
                            [21.328307753027296, 56.217727164409496],
                            [21.328123647769267, 56.217453528047145],
                            [21.327845629636478, 56.217348643460568],
                            [21.327397761904507, 56.217294016840953],
                            [21.326941150673978, 56.217104371162954],
                            [21.326670014244758, 56.216900758581964],
                            [21.326394254088285, 56.216481319982933],
                            [21.32632372402832, 56.21633597731801],
                            [21.324363220653531, 56.214891334328556],
                            [21.324036071710708, 56.214884251350284],
                            [21.323872619673732, 56.214871723621073],
                            [21.323585735469578, 56.214865511304332],
                            [21.323056748532842, 56.214818100366585],
                            [21.322563299445981, 56.214564719939609],
                            [21.322098262836054, 56.214222067381243],
                            [21.320591800189838, 56.213020901432927],
                            [21.319969623889669, 56.212575959013037],
                            [21.319715800663005, 56.212399671415518],
                            [21.319267309362992, 56.212102309228158],
                            [21.318692894601558, 56.211847156240069],
                            [21.318389100517329, 56.211534952808847],
                            [21.318186465687813, 56.211224943805689],
                            [21.317960263114788, 56.210725662617286],
                            [21.317525284499528, 56.210509484201708],
                            [21.317003080876784, 56.210084672954444],
                            [21.316630392295966, 56.209878832142856],
                            [21.316436742121926, 56.209721821092565],
                            [21.316355921100367, 56.209450408239427],
                            [21.316067600559332, 56.208931796901098],
                            [21.315783730755296, 56.208637996329045],
                            [21.31543645993515, 56.208342817754641],
                            [21.315136484795548, 56.207976756908344],
                            [21.314526923876041, 56.207648910942972],
                            [21.313940137409904, 56.207276613850027],
                            [21.313135719694341, 56.206809696050058],
                            [21.312605951923359, 56.206501552252732],
                            [21.312179824445892, 56.205908024888195],
                            [21.311988957722672, 56.205481408578478],
                            [21.311174293678619, 56.205140094853746],
                            [21.310980814661828, 56.204974089712138],
                            [21.310357873800395, 56.204565033350505],
                            [21.309814570939857, 56.204148718837615],
                            [21.309454680297314, 56.203790327165059],
                            [21.308964479515264, 56.203213369664994],
                            [21.30826712492447, 56.202694817990228],
                            [21.307267409133381, 56.202097764473805],
                            [21.3066791396786, 56.201770341588734],
                            [21.306211863534937, 56.201715212470596],
                            [21.305808991555729, 56.201625531313368],
                            [21.305414455570467, 56.201158508012206],
                            [21.305128861214609, 56.200603972983011],
                            [21.304693465466432, 56.200145044579344],
                            [21.304638441873475, 56.200021030150964],
                            [21.273563473516688, 56.200730970841505],
                            [21.223048946789071, 56.250653973429429],
                            [21.220557889679458, 56.269585199260142],
                            [21.215215325728494, 56.273822768784711],
                            [21.221399203299939, 56.281120888310056],
                            [21.216946567559575, 56.288491171473083],
                            [21.216087658327627, 56.300299899184985],
                            [21.213037021792726, 56.311436757782275],
                            [21.178521136036821, 56.316257663093388],
                            [21.195261911840408, 56.324730979462842],
                            [21.201290553961716, 56.334205337376169],
                            [21.204396928217999, 56.337699410428421],
                            [21.207299399476142, 56.343990169841881],
                            [21.211473283125834, 56.355912201796812],
                            [21.212449098455444, 56.365583293713584],
                            [21.219967414158688, 56.366665543751317],
                            [21.225117324520284, 56.363068276680785],
                            [21.228222083378551, 56.359282265170876],
                            [21.232424150579753, 56.358091045333779],
                            [21.236585856595145, 56.353900056612652],
                            [21.239554741135908, 56.351967103699678],
                            [21.240829042417051, 56.348568379995854],
                            [21.243047675571034, 56.346333040901655],
                            [21.247894846089423, 56.343299323925365],
                            [21.251519326553275, 56.339381519012271],
                            [21.250677256028268, 56.33679249481677],
                            [21.254208617964711, 56.334157717345576],
                            [21.261712851928948, 56.333467108423086],
                            [21.267029376417653, 56.33101423649282],
                            [21.272355395501343, 56.328418557478436],
                            [21.279378326129365, 56.330857783771556],
                            [21.289768988167118, 56.332941968200956],
                            [21.296245816036858, 56.332226785537877],
                            [21.300523396857319, 56.329892608163156],
                            [21.305469799469517, 56.329000783993877],
                            [21.315121567482354, 56.330638368384484],
                            [21.319051202718796, 56.329581161254254],
                            [21.332810104624539, 56.33130620762622],
                            [21.337449668965, 56.331120465258998],
                            [21.343332792696632, 56.331532403338969],
                            [21.350213021932863, 56.332393775551516],
                            [21.355129048693772, 56.33192770187383],
                            [21.360962610732059, 56.32933911984842],
                            [21.365730721212984, 56.33101134696625],
                            [21.370736299278516, 56.332974008990945],
                            [21.373618447559565, 56.332178422370198],
                            [21.379433735195985, 56.333586732968243],
                            [21.38320574752057, 56.334808817325964],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "PurmsÄtu",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.540459951269451, 56.402686994466478],
                            [21.540011037575393, 56.401943337173215],
                            [21.540688680808309, 56.39973193455738],
                            [21.537321260132746, 56.39803353033259],
                            [21.539897881252667, 56.391261818094762],
                            [21.546202562438609, 56.388865291152761],
                            [21.549826550622782, 56.386563811986051],
                            [21.549711771056447, 56.384188374275297],
                            [21.552257563931835, 56.38201383214259],
                            [21.553019621624486, 56.378469127915302],
                            [21.554801902492027, 56.375686168206435],
                            [21.558452538062394, 56.372940009210225],
                            [21.562645961243238, 56.370056101850736],
                            [21.56312772835804, 56.366371632065054],
                            [21.558726478918519, 56.367663351420617],
                            [21.549789224667968, 56.370628170179273],
                            [21.53949263310518, 56.370709716028792],
                            [21.527598872029216, 56.371615251027983],
                            [21.518584146114922, 56.375718578320587],
                            [21.515379621373683, 56.37751056238973],
                            [21.5070719250715, 56.378628782932616],
                            [21.502296530982605, 56.380817181809867],
                            [21.499544128140354, 56.379619404740623],
                            [21.491702686806835, 56.381459934808909],
                            [21.4878662005375, 56.381096659366861],
                            [21.485969829925587, 56.378630858976486],
                            [21.481494480243406, 56.376255425884516],
                            [21.474251840170169, 56.376821950922121],
                            [21.471005572552258, 56.375327887479749],
                            [21.466693845097222, 56.374383103039541],
                            [21.467397055497624, 56.371541756587604],
                            [21.461134677864813, 56.368986238801952],
                            [21.456262557387802, 56.368743528649347],
                            [21.453788507797135, 56.37112008714594],
                            [21.453826632454025, 56.374404962188478],
                            [21.447649997733844, 56.374420683601905],
                            [21.443187114411188, 56.371901301845625],
                            [21.439093731392738, 56.375386452704817],
                            [21.429357865017604, 56.374756507883532],
                            [21.425664220206507, 56.376107707164046],
                            [21.427100268910188, 56.377708195683901],
                            [21.427659705107189, 56.380861136595392],
                            [21.428428183358257, 56.384732347626851],
                            [21.432872356695817, 56.387537437824264],
                            [21.43643095340639, 56.392037491067065],
                            [21.438105966504885, 56.393928352229061],
                            [21.433829367213754, 56.396267269019994],
                            [21.432647310785356, 56.398527385353823],
                            [21.434750320274432, 56.401712234292987],
                            [21.437122137607712, 56.400904570354101],
                            [21.440597625462868, 56.402832599368651],
                            [21.442272105249771, 56.408578617103615],
                            [21.439708305501089, 56.412238148578759],
                            [21.440326688322738, 56.414535499038912],
                            [21.438524463614709, 56.41835351500599],
                            [21.434807659140542, 56.419990119006009],
                            [21.433425250401424, 56.421389379609444],
                            [21.430840469290576, 56.425333880301466],
                            [21.433060082739971, 56.426807709358712],
                            [21.438129610531231, 56.428054828372744],
                            [21.444133092510366, 56.430748846429246],
                            [21.450194724424279, 56.432587044691523],
                            [21.45475086921175, 56.433822912329411],
                            [21.459631290899267, 56.434065754727577],
                            [21.465989562546621, 56.435338100812686],
                            [21.470527614253822, 56.436858578225873],
                            [21.474303295882574, 56.43822057936233],
                            [21.481375718515739, 56.436508193333424],
                            [21.488325216976843, 56.436649112773033],
                            [21.487465057910175, 56.434061580154413],
                            [21.493871233974268, 56.4346195373546],
                            [21.500488179345851, 56.435895326065179],
                            [21.502322514561442, 56.431505992242521],
                            [21.50567236757405, 56.427575473538361],
                            [21.513522715897267, 56.425734150022578],
                            [21.52022502685033, 56.421727644113702],
                            [21.526119082101811, 56.414277881961006],
                            [21.530273561934152, 56.40979165474144],
                            [21.533637035764418, 56.405575128700818],
                            [21.537394319436864, 56.403222513133031],
                            [21.540459951269451, 56.402686994466478],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Priekules",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.620460994693719, 56.48004608480953],
                            [21.623453022752436, 56.475060592685807],
                            [21.633670843751069, 56.474514232796253],
                            [21.642115764141693, 56.47230187465842],
                            [21.652119848105912, 56.470860042833763],
                            [21.660091450491862, 56.467599307298762],
                            [21.662949841900371, 56.464686834272307],
                            [21.661195011942361, 56.462725656053742],
                            [21.656700664329019, 56.461750967676359],
                            [21.65322203021244, 56.461685230101551],
                            [21.65147698645967, 56.45957577462071],
                            [21.646411475988355, 56.459183164990883],
                            [21.642951461444287, 56.458820854522216],
                            [21.6400542101761, 56.458024197768033],
                            [21.639675355069254, 56.455495588708935],
                            [21.649588455546077, 56.446784713281723],
                            [21.654427824477398, 56.442130142090839],
                            [21.661025236446935, 56.434987157599622],
                            [21.659037616873452, 56.42812705634703],
                            [21.656573761596672, 56.424669220905379],
                            [21.651695493792715, 56.421313954195625],
                            [21.651719646402491, 56.42118346925708],
                            [21.646561839676334, 56.422106550344488],
                            [21.645558467845234, 56.425350507277898],
                            [21.639972094785495, 56.424799376251833],
                            [21.633989735487802, 56.426316899721186],
                            [21.63336301064075, 56.427788129124103],
                            [21.632173892580237, 56.429693576515291],
                            [21.628689022198838, 56.429775318583317],
                            [21.629334405459197, 56.428007829897048],
                            [21.623397355639131, 56.428784122178598],
                            [21.623212435780527, 56.431746959574731],
                            [21.618906726710641, 56.432109335455571],
                            [21.617100017631671, 56.431036404245425],
                            [21.615172801345036, 56.431889280225896],
                            [21.611143673121486, 56.432108385471018],
                            [21.606191314293625, 56.434237701960903],
                            [21.604956896553251, 56.43258235572614],
                            [21.60914423313233, 56.429845066813058],
                            [21.600240936700757, 56.426706723175911],
                            [21.594546808423974, 56.423630009205688],
                            [21.592713104348366, 56.423001147417985],
                            [21.594982481685118, 56.420968691732796],
                            [21.596651644175811, 56.419962808325231],
                            [21.594588216344789, 56.418736238256919],
                            [21.596083495821201, 56.416243785700559],
                            [21.593429648899999, 56.415895669626437],
                            [21.59011954214882, 56.417462913401621],
                            [21.587189026000079, 56.417257607941465],
                            [21.582837656657368, 56.418359434189227],
                            [21.577970324637985, 56.419154391760358],
                            [21.574017835019415, 56.418187204401391],
                            [21.571420727571141, 56.416949797538408],
                            [21.565846215728037, 56.416247210804471],
                            [21.562009922418987, 56.417655064831429],
                            [21.560205513541874, 56.416581322643367],
                            [21.556625499118606, 56.413989356665347],
                            [21.551089793030851, 56.41269357307209],
                            [21.546919141755918, 56.410979583615415],
                            [21.54485781671821, 56.40975220286542],
                            [21.54449522217163, 56.407075211875203],
                            [21.541461045095456, 56.404345269314739],
                            [21.540459951269451, 56.402686994466478],
                            [21.537394319436864, 56.403222513133031],
                            [21.533637035764418, 56.405575128700818],
                            [21.530273561934152, 56.40979165474144],
                            [21.526119082101811, 56.414277881961006],
                            [21.52022502685033, 56.421727644113702],
                            [21.513522715897267, 56.425734150022578],
                            [21.50567236757405, 56.427575473538361],
                            [21.502322514561442, 56.431505992242521],
                            [21.500488179345851, 56.435895326065179],
                            [21.502664354846548, 56.438080910059391],
                            [21.503525633027721, 56.440668345673267],
                            [21.502032650282043, 56.443779520703742],
                            [21.503647670870546, 56.446667693812451],
                            [21.508427402437391, 56.448477177983627],
                            [21.507009240593902, 56.450447648349765],
                            [21.506859741882696, 56.452729169911251],
                            [21.502037462791527, 56.455487831928991],
                            [21.495889246433318, 56.458790693065701],
                            [21.491571116150968, 56.461701920107608],
                            [21.486212581844747, 56.464734714309067],
                            [21.482961183298229, 56.467096125567274],
                            [21.482982800354019, 56.470666152806466],
                            [21.484625754688338, 56.473126783240531],
                            [21.487987681526182, 56.476907242398305],
                            [21.489364121173214, 56.479505189999749],
                            [21.488481262616165, 56.48505586767623],
                            [21.487560402047183, 56.491176900594596],
                            [21.494777685889794, 56.49132276330262],
                            [21.504094623605354, 56.490939309755916],
                            [21.509042860234707, 56.486326891994331],
                            [21.518960673927761, 56.48067146905688],
                            [21.526656549357785, 56.477398308067542],
                            [21.531339340745877, 56.480775508733778],
                            [21.534357700777306, 56.481977754158386],
                            [21.539990325101236, 56.482660639449328],
                            [21.546046510079343, 56.484779447203948],
                            [21.55121025583848, 56.484738643787139],
                            [21.551818069403545, 56.487320679008853],
                            [21.559053292874555, 56.487177602124753],
                            [21.56369445551978, 56.49126661199459],
                            [21.566983658590019, 56.49632840392556],
                            [21.572986188100817, 56.495303657385961],
                            [21.574172217711389, 56.492899590356487],
                            [21.578754567947563, 56.489847905527711],
                            [21.585389103040249, 56.48697877238925],
                            [21.592768734216289, 56.484552082087511],
                            [21.594975012560599, 56.482310390597206],
                            [21.602679650520439, 56.482887767506455],
                            [21.610662472878694, 56.479043900404612],
                            [21.620460994693719, 56.48004608480953],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Bunkas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.606959665547691, 56.515679568929706],
                            [21.603494925041105, 56.515316121080261],
                            [21.606121402987458, 56.511955460887599],
                            [21.601532631413747, 56.508158958433086],
                            [21.603616889627784, 56.500634960786591],
                            [21.609963943299359, 56.497790935492326],
                            [21.614507804143432, 56.498026640518418],
                            [21.622451243190099, 56.495360969964764],
                            [21.626635122469963, 56.492771304207139],
                            [21.627679040622116, 56.488934997752771],
                            [21.624660247257367, 56.485762597431474],
                            [21.623525311949635, 56.482477880035496],
                            [21.620460994693719, 56.48004608480953],
                            [21.610662472878694, 56.479043900404612],
                            [21.602679650520439, 56.482887767506455],
                            [21.594975012560599, 56.482310390597206],
                            [21.592768734216289, 56.484552082087511],
                            [21.585389103040249, 56.48697877238925],
                            [21.578754567947563, 56.489847905527711],
                            [21.574172217711389, 56.492899590356487],
                            [21.572986188100817, 56.495303657385961],
                            [21.566983658590019, 56.49632840392556],
                            [21.56369445551978, 56.49126661199459],
                            [21.559053292874555, 56.487177602124753],
                            [21.551818069403545, 56.487320679008853],
                            [21.55121025583848, 56.484738643787139],
                            [21.546046510079343, 56.484779447203948],
                            [21.539990325101236, 56.482660639449328],
                            [21.534357700777306, 56.481977754158386],
                            [21.531339340745877, 56.480775508733778],
                            [21.526656549357785, 56.477398308067542],
                            [21.518960673927761, 56.48067146905688],
                            [21.509042860234707, 56.486326891994331],
                            [21.504094623605354, 56.490939309755916],
                            [21.494777685889794, 56.49132276330262],
                            [21.487560402047183, 56.491176900594596],
                            [21.469655187792295, 56.492220982483595],
                            [21.457523914518926, 56.493637707784089],
                            [21.44947761516347, 56.498228650482119],
                            [21.442733563298553, 56.502608120526062],
                            [21.434033322000641, 56.504093218637593],
                            [21.418778048209486, 56.507106223499683],
                            [21.420667115251451, 56.510950307563832],
                            [21.425627691139091, 56.513906867290494],
                            [21.437634972168947, 56.520813622806628],
                            [21.449282207968857, 56.520339994167237],
                            [21.45925848894958, 56.519117705797427],
                            [21.476856100835068, 56.519714284476493],
                            [21.484604731240506, 56.5196336745203],
                            [21.488947929546388, 56.519008178795268],
                            [21.493165492268602, 56.52028236540071],
                            [21.497110349676685, 56.519172951911109],
                            [21.506960086877783, 56.519846661018903],
                            [21.508787674995617, 56.518218770061523],
                            [21.516856815481617, 56.519807140919596],
                            [21.521919187422117, 56.521335021101336],
                            [21.524280085855064, 56.524711218956853],
                            [21.531767077724378, 56.52866492241143],
                            [21.537260980195196, 56.53020072945597],
                            [21.541773857625472, 56.526961030398539],
                            [21.548173449655568, 56.521142720804356],
                            [21.552976099916066, 56.520048480556483],
                            [21.558868744180316, 56.522066775876787],
                            [21.573320896663962, 56.518069763933084],
                            [21.582893496849749, 56.516354121676478],
                            [21.588599014905622, 56.514562721034764],
                            [21.59308345231014, 56.51845434447015],
                            [21.598254011457602, 56.518316655064275],
                            [21.60215066656674, 56.51791637299312],
                            [21.606959665547691, 56.515679568929706],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Aizteres",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.349884038916276, 56.582228293372758],
                            [21.33184646381147, 56.581366793145591],
                            [21.325392708372284, 56.581228085996429],
                            [21.313944566771077, 56.578603135990164],
                            [21.311194649486048, 56.58092175235533],
                            [21.307482525149123, 56.584646318647998],
                            [21.300116976620753, 56.585199974874349],
                            [21.293957212136977, 56.586968497217327],
                            [21.288577474751534, 56.595888009504222],
                            [21.27892773260843, 56.610183549122688],
                            [21.271646979674934, 56.621438872749756],
                            [21.25523314450005, 56.638331439633966],
                            [21.277029941536462, 56.638238693910765],
                            [21.302440738487487, 56.645653539478893],
                            [21.305730175400353, 56.657731928773444],
                            [21.317142993047607, 56.660104706016583],
                            [21.318903448042331, 56.654570317344557],
                            [21.319206948284432, 56.650296368440841],
                            [21.32418390239437, 56.647074236769605],
                            [21.325314985886376, 56.643293683437726],
                            [21.324671732831554, 56.640188390181955],
                            [21.329115256268587, 56.638381433155686],
                            [21.336277588739694, 56.634730136717735],
                            [21.337093377641288, 56.629278107818166],
                            [21.339995750968235, 56.624821932724771],
                            [21.347451847748943, 56.623078741888691],
                            [21.352919980904794, 56.618914783197489],
                            [21.35282184020932, 56.614156626104887],
                            [21.348336997264315, 56.604311113688652],
                            [21.350474892544195, 56.598411587346256],
                            [21.353389828771935, 56.593717593281255],
                            [21.353555899127169, 56.591343087820739],
                            [21.352464128566702, 56.588466190112435],
                            [21.349884038916276, 56.582228293372758],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Vecpils",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.587936788196881, 56.578907025535521],
                            [21.586004633390214, 56.575624036946444],
                            [21.580223649343925, 56.571707018585712],
                            [21.574443857092444, 56.567789739293701],
                            [21.563381484604257, 56.56567103344787],
                            [21.55848146477361, 56.568190557338362],
                            [21.55138338055864, 56.564721847693583],
                            [21.544685914566468, 56.561736214669835],
                            [21.538512133200911, 56.557333831930592],
                            [21.530140020807558, 56.560259007442674],
                            [21.525223025778121, 56.563014693050938],
                            [21.521196672405953, 56.565312373424732],
                            [21.521041268558086, 56.567687200065862],
                            [21.515614565415479, 56.571621317817851],
                            [21.512275561129421, 56.576548183174175],
                            [21.500979210320331, 56.577986135551797],
                            [21.497700515034371, 56.581962670174583],
                            [21.493586035244579, 56.579026247015108],
                            [21.48746757762968, 56.580329490183793],
                            [21.482509346875222, 56.577137835000457],
                            [21.478225840787534, 56.583233679923275],
                            [21.482067170306646, 56.583787137825666],
                            [21.482817296591072, 56.585466893326135],
                            [21.477384068059045, 56.589399273852585],
                            [21.473940930880516, 56.589329359579885],
                            [21.464201896723239, 56.593173618113141],
                            [21.466466504457536, 56.597975700291592],
                            [21.466212045325147, 56.601775243289069],
                            [21.463342237003403, 56.605997050878898],
                            [21.465496045391863, 56.612461441441525],
                            [21.45522355359989, 56.617720965528065],
                            [21.442668875710286, 56.618414632508426],
                            [21.436812037688846, 56.622098817745339],
                            [21.429042398275495, 56.622176254222268],
                            [21.421907487543152, 56.625595536009342],
                            [21.427076941617692, 56.625702575875152],
                            [21.434368155462945, 56.626328777435234],
                            [21.439441227684327, 56.627860093273675],
                            [21.441003702716667, 56.630270211814938],
                            [21.444418359435726, 56.630816003007155],
                            [21.447322045437055, 56.632540194333096],
                            [21.454774907289718, 56.630790542625846],
                            [21.457503300486941, 56.635126650164253],
                            [21.461477305448707, 56.640201493989245],
                            [21.462914072285184, 56.64451110142447],
                            [21.460886670566996, 56.648987838573149],
                            [21.455744947486085, 56.654827676736268],
                            [21.445269318262433, 56.656515416923462],
                            [21.439072192791169, 56.658765996370896],
                            [21.42900977290984, 56.660698686391804],
                            [21.414422847895327, 56.663540334558554],
                            [21.420210123315076, 56.668734038156622],
                            [21.421542666852147, 56.679624794969392],
                            [21.433911963290459, 56.681023868237645],
                            [21.44378183430376, 56.688659540598778],
                            [21.454619490270321, 56.682020726516662],
                            [21.465069643569837, 56.681090480788093],
                            [21.480088110357233, 56.673962845806003],
                            [21.479813764440109, 56.662522599593281],
                            [21.505508209040865, 56.666470625810284],
                            [21.530731563837243, 56.661828047585942],
                            [21.546284297062755, 56.662135642397601],
                            [21.561800451872358, 56.663012294319017],
                            [21.573316517900796, 56.661522201371902],
                            [21.586160638252839, 56.655483078251009],
                            [21.59378153620278, 56.649913496299789],
                            [21.579184930576236, 56.634765681886776],
                            [21.597235126660291, 56.62825498750248],
                            [21.608606467107698, 56.61246604435626],
                            [21.602646606920384, 56.60834927766534],
                            [21.612866433336187, 56.594252937388596],
                            [21.61858068787086, 56.585786757317841],
                            [21.610626513152301, 56.580488666083106],
                            [21.600316042851528, 56.579718338900264],
                            [21.587936788196881, 56.578907025535521],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Krotes",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.537260980195196, 56.53020072945597],
                            [21.540115170198995, 56.532635210326987],
                            [21.539116959138866, 56.534755570180195],
                            [21.536368511868311, 56.53731680910321],
                            [21.527326828105767, 56.537374958109389],
                            [21.517026783404592, 56.536931715773939],
                            [21.512267721531668, 56.537312088761162],
                            [21.506094180364247, 56.539566248111775],
                            [21.498997531819107, 56.542752707570543],
                            [21.489367451503654, 56.545174216746652],
                            [21.481901533334522, 56.547401078079105],
                            [21.481124455503252, 56.552616837795242],
                            [21.483132410030485, 56.554797689614304],
                            [21.493898244850175, 56.554777497438373],
                            [21.498901599691301, 56.557256254558048],
                            [21.503045480593659, 56.559717534753489],
                            [21.513055350031014, 56.564674133889767],
                            [21.521196672405953, 56.565312373424732],
                            [21.525223025778121, 56.563014693050938],
                            [21.530140020807558, 56.560259007442674],
                            [21.538512133200911, 56.557333831930592],
                            [21.544685914566468, 56.561736214669835],
                            [21.55138338055864, 56.564721847693583],
                            [21.55848146477361, 56.568190557338362],
                            [21.563381484604257, 56.56567103344787],
                            [21.574443857092444, 56.567789739293701],
                            [21.580223649343925, 56.571707018585712],
                            [21.586004633390214, 56.575624036946444],
                            [21.587936788196881, 56.578907025535521],
                            [21.605176908523141, 56.568377668777202],
                            [21.610070787754719, 56.556465736753957],
                            [21.614494411252625, 56.551976970846205],
                            [21.605420443000618, 56.548576443628114],
                            [21.596518044954923, 56.54499324465651],
                            [21.584775579100921, 56.543875620617605],
                            [21.589682613544483, 56.538483140459363],
                            [21.594419127799991, 56.535756903057546],
                            [21.605457956204432, 56.535228585317384],
                            [21.610477127656797, 56.536511771845618],
                            [21.617650878444341, 56.537687770976646],
                            [21.623327741441223, 56.537054920477409],
                            [21.63068711079481, 56.535267379738684],
                            [21.637602402258644, 56.536288976245707],
                            [21.642353658640264, 56.5332645977021],
                            [21.637573670693641, 56.528131027381285],
                            [21.633340231114339, 56.522859354295811],
                            [21.629736097556719, 56.520417555496678],
                            [21.630873006222625, 56.515099836212954],
                            [21.622742608877999, 56.512126437982879],
                            [21.613686584371184, 56.515364056089219],
                            [21.606959665547691, 56.515679568929706],
                            [21.60215066656674, 56.51791637299312],
                            [21.598254011457602, 56.518316655064275],
                            [21.59308345231014, 56.51845434447015],
                            [21.588599014905622, 56.514562721034764],
                            [21.582893496849749, 56.516354121676478],
                            [21.573320896663962, 56.518069763933084],
                            [21.558868744180316, 56.522066775876787],
                            [21.552976099916066, 56.520048480556483],
                            [21.548173449655568, 56.521142720804356],
                            [21.541773857625472, 56.526961030398539],
                            [21.537260980195196, 56.53020072945597],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Durbe",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.349884038916276, 56.582228293372758],
                            [21.352464128566702, 56.588466190112435],
                            [21.353555899127169, 56.591343087820739],
                            [21.353389828771935, 56.593717593281255],
                            [21.360574159249097, 56.595772759687456],
                            [21.360408501168976, 56.598147276881626],
                            [21.367693194229702, 56.598777329698592],
                            [21.369563635455407, 56.596676692298509],
                            [21.373454084301702, 56.59652114174655],
                            [21.377643279034217, 56.598274188460486],
                            [21.381533866710488, 56.598118386327258],
                            [21.384957406100078, 56.592245400636564],
                            [21.389474312873507, 56.589248913308843],
                            [21.389224137381742, 56.58662784247619],
                            [21.392530912578021, 56.582416823767147],
                            [21.397029706371836, 56.579657500209301],
                            [21.39552104271279, 56.576534478967893],
                            [21.388985907063869, 56.577586372714521],
                            [21.384650823698639, 56.577970833000663],
                            [21.378197371567843, 56.577834870957275],
                            [21.374706159315551, 56.578474586514822],
                            [21.370106931512041, 56.582657813677244],
                            [21.370388756925053, 56.584804003879846],
                            [21.365241646712274, 56.584457207414999],
                            [21.361468275768136, 56.582950345605504],
                            [21.363834647079596, 56.579909107315856],
                            [21.366167596886111, 56.577342726272761],
                            [21.361865424263843, 56.577251483401859],
                            [21.357430694998072, 56.579059706781337],
                            [21.356685462053228, 56.583562139621669],
                            [21.349884038916276, 56.582228293372758],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Durbes",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.349884038916276, 56.582228293372758],
                            [21.356685462053228, 56.583562139621669],
                            [21.357430694998072, 56.579059706781337],
                            [21.361865424263843, 56.577251483401859],
                            [21.366167596886111, 56.577342726272761],
                            [21.363834647079596, 56.579909107315856],
                            [21.361468275768136, 56.582950345605504],
                            [21.365241646712274, 56.584457207414999],
                            [21.370388756925053, 56.584804003879846],
                            [21.370106931512041, 56.582657813677244],
                            [21.374706159315551, 56.578474586514822],
                            [21.378197371567843, 56.577834870957275],
                            [21.384650823698639, 56.577970833000663],
                            [21.388985907063869, 56.577586372714521],
                            [21.39552104271279, 56.576534478967893],
                            [21.397029706371836, 56.579657500209301],
                            [21.392530912578021, 56.582416823767147],
                            [21.389224137381742, 56.58662784247619],
                            [21.389474312873507, 56.589248913308843],
                            [21.384957406100078, 56.592245400636564],
                            [21.381533866710488, 56.598118386327258],
                            [21.377643279034217, 56.598274188460486],
                            [21.373454084301702, 56.59652114174655],
                            [21.369563635455407, 56.596676692298509],
                            [21.367693194229702, 56.598777329698592],
                            [21.360408501168976, 56.598147276881626],
                            [21.360574159249097, 56.595772759687456],
                            [21.353389828771935, 56.593717593281255],
                            [21.350474892544195, 56.598411587346256],
                            [21.348336997264315, 56.604311113688652],
                            [21.35282184020932, 56.614156626104887],
                            [21.352919980904794, 56.618914783197489],
                            [21.36348849060013, 56.621992909527222],
                            [21.367945385993384, 56.626129943721807],
                            [21.375054169678823, 56.629371589408166],
                            [21.382841742655021, 56.629060085135016],
                            [21.388442326220304, 56.629177797609714],
                            [21.400887090479436, 56.630151853836381],
                            [21.410593241373199, 56.62702510087172],
                            [21.421907487543152, 56.625595536009342],
                            [21.429042398275495, 56.622176254222268],
                            [21.436812037688846, 56.622098817745339],
                            [21.442668875710286, 56.618414632508426],
                            [21.45522355359989, 56.617720965528065],
                            [21.465496045391863, 56.612461441441525],
                            [21.463342237003403, 56.605997050878898],
                            [21.466212045325147, 56.601775243289069],
                            [21.466466504457536, 56.597975700291592],
                            [21.464201896723239, 56.593173618113141],
                            [21.473940930880516, 56.589329359579885],
                            [21.477384068059045, 56.589399273852585],
                            [21.482817296591072, 56.585466893326135],
                            [21.482067170306646, 56.583787137825666],
                            [21.478225840787534, 56.583233679923275],
                            [21.482509346875222, 56.577137835000457],
                            [21.48746757762968, 56.580329490183793],
                            [21.493586035244579, 56.579026247015108],
                            [21.497700515034371, 56.581962670174583],
                            [21.500979210320331, 56.577986135551797],
                            [21.512275561129421, 56.576548183174175],
                            [21.515614565415479, 56.571621317817851],
                            [21.521041268558086, 56.567687200065862],
                            [21.521196672405953, 56.565312373424732],
                            [21.513055350031014, 56.564674133889767],
                            [21.503045480593659, 56.559717534753489],
                            [21.498901599691301, 56.557256254558048],
                            [21.493898244850175, 56.554777497438373],
                            [21.483132410030485, 56.554797689614304],
                            [21.481124455503252, 56.552616837795242],
                            [21.481901533334522, 56.547401078079105],
                            [21.489367451503654, 56.545174216746652],
                            [21.498997531819107, 56.542752707570543],
                            [21.506094180364247, 56.539566248111775],
                            [21.512267721531668, 56.537312088761162],
                            [21.517026783404592, 56.536931715773939],
                            [21.527326828105767, 56.537374958109389],
                            [21.536368511868311, 56.53731680910321],
                            [21.539116959138866, 56.534755570180195],
                            [21.540115170198995, 56.532635210326987],
                            [21.537260980195196, 56.53020072945597],
                            [21.531767077724378, 56.52866492241143],
                            [21.524280085855064, 56.524711218956853],
                            [21.521919187422117, 56.521335021101336],
                            [21.516856815481617, 56.519807140919596],
                            [21.508787674995617, 56.518218770061523],
                            [21.506960086877783, 56.519846661018903],
                            [21.497110349676685, 56.519172951911109],
                            [21.493165492268602, 56.52028236540071],
                            [21.488947929546388, 56.519008178795268],
                            [21.484604731240506, 56.5196336745203],
                            [21.476856100835068, 56.519714284476493],
                            [21.478211534308588, 56.525211147811675],
                            [21.472770827154552, 56.529380909510884],
                            [21.463397592319922, 56.534421390254394],
                            [21.452685447465331, 56.533726577342406],
                            [21.439472311384201, 56.538210892382544],
                            [21.438914204863774, 56.540101782082445],
                            [21.433784390748698, 56.545940907365861],
                            [21.425041563820518, 56.547900207104057],
                            [21.407901984370504, 56.553013216875335],
                            [21.395253814620457, 56.555364521623702],
                            [21.381793330643937, 56.556984032796656],
                            [21.373691413210114, 56.562044725041311],
                            [21.366761171557702, 56.562611469609905],
                            [21.362659284796798, 56.565853737765387],
                            [21.354320677978382, 56.574237455418846],
                            [21.349884038916276, 56.582228293372758],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "TÄÅ¡u",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.194269645323669, 56.565483735245905],
                            [21.198410994282263, 56.567728856351692],
                            [21.207547127866064, 56.566507608561032],
                            [21.209162317571131, 56.567970792526367],
                            [21.202825914642407, 56.572109014147458],
                            [21.188886568810972, 56.57417264139314],
                            [21.184285239628522, 56.57811137196127],
                            [21.182694388519653, 56.582118220687981],
                            [21.185264459931844, 56.588121888227974],
                            [21.184840571685037, 56.593819903339551],
                            [21.183101534254817, 56.594018324872593],
                            [21.174513783712733, 56.616653922298042],
                            [21.17868332296068, 56.62435873464004],
                            [21.184105357147121, 56.626859783460709],
                            [21.190530831186525, 56.627480730483292],
                            [21.196314393723977, 56.630940656669083],
                            [21.193525647894866, 56.639439112861012],
                            [21.182813119162354, 56.64419109748787],
                            [21.176483416391541, 56.653798061276589],
                            [21.164801515945751, 56.67136866934154],
                            [21.17532857188472, 56.669229888107751],
                            [21.1847263753533, 56.670631914369793],
                            [21.1914314322092, 56.673399369459894],
                            [21.198076566091096, 56.671171010750925],
                            [21.210326597263002, 56.669068071935882],
                            [21.207659586043832, 56.664251995026852],
                            [21.21748410839685, 56.654008301668895],
                            [21.222074045336665, 56.650305863409606],
                            [21.229348773550225, 56.651181514298223],
                            [21.23550464121773, 56.649653765456144],
                            [21.242494069989601, 56.651153153487463],
                            [21.241967955660307, 56.649473631176832],
                            [21.251585245333974, 56.645684010074092],
                            [21.25523314450005, 56.638331439633966],
                            [21.271646979674934, 56.621438872749756],
                            [21.27892773260843, 56.610183549122688],
                            [21.288577474751534, 56.595888009504222],
                            [21.293957212136977, 56.586968497217327],
                            [21.300116976620753, 56.585199974874349],
                            [21.307482525149123, 56.584646318647998],
                            [21.311194649486048, 56.58092175235533],
                            [21.31147467177821, 56.580685665201642],
                            [21.298111527163293, 56.577070904212952],
                            [21.286355558457913, 56.57277201020618],
                            [21.275151940761937, 56.566819405263089],
                            [21.267342253988055, 56.567599153839573],
                            [21.258791918842181, 56.560752088599642],
                            [21.253924599250237, 56.556601793640809],
                            [21.24460403069255, 56.554492926282272],
                            [21.237607036271449, 56.550056890629826],
                            [21.231058830134863, 56.545392627244794],
                            [21.218582803281038, 56.539406316255487],
                            [21.210033493334581, 56.544446542568934],
                            [21.203104335713697, 56.545004168340654],
                            [21.196700957046623, 56.55009181099954],
                            [21.198823778452141, 56.556322945644858],
                            [21.194638080608666, 56.56050921499876],
                            [21.194269645323669, 56.565483735245905],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Medzes",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.164801515945751, 56.67136866934154],
                            [21.176483416391541, 56.653798061276589],
                            [21.182813119162354, 56.64419109748787],
                            [21.193525647894866, 56.639439112861012],
                            [21.196314393723977, 56.630940656669083],
                            [21.190530831186525, 56.627480730483292],
                            [21.184105357147121, 56.626859783460709],
                            [21.17868332296068, 56.62435873464004],
                            [21.174513783712733, 56.616653922298042],
                            [21.183101534254817, 56.594018324872593],
                            [21.184840571685037, 56.593819903339551],
                            [21.185264459931844, 56.588121888227974],
                            [21.182694388519653, 56.582118220687981],
                            [21.184285239628522, 56.57811137196127],
                            [21.188886568810972, 56.57417264139314],
                            [21.202825914642407, 56.572109014147458],
                            [21.209162317571131, 56.567970792526367],
                            [21.207547127866064, 56.566507608561032],
                            [21.198410994282263, 56.567728856351692],
                            [21.194269645323669, 56.565483735245905],
                            [21.194268807836554, 56.565495040967406],
                            [21.181209225773202, 56.567339826545805],
                            [21.172001189404824, 56.569508789264695],
                            [21.161448483141541, 56.572359832486597],
                            [21.153744404069773, 56.577415657472912],
                            [21.149066482677988, 56.576594968952811],
                            [21.137811352159083, 56.577287540074813],
                            [21.121249767337524, 56.579758869742868],
                            [21.11510500696755, 56.575573382551632],
                            [21.099082076194005, 56.576627321238647],
                            [21.098003472552211, 56.579456034774324],
                            [21.100923586893956, 56.580713311924796],
                            [21.101941424176371, 56.58430441591269],
                            [21.097960399485281, 56.585638469225437],
                            [21.100414372261508, 56.587360514770616],
                            [21.108031662908637, 56.589202752743674],
                            [21.106535758481606, 56.597491764232608],
                            [21.100486259786219, 56.603296403198463],
                            [21.099327485989257, 56.612782322746824],
                            [21.091570284106929, 56.618308891933147],
                            [21.085413990927933, 56.619829517377426],
                            [21.077462860288026, 56.61108118330521],
                            [21.073588401476012, 56.610990049906718],
                            [21.073003083832109, 56.607408882627006],
                            [21.068735370980399, 56.60683268086018],
                            [21.065660239910482, 56.602003604009425],
                            [21.062567441525683, 56.597411847426002],
                            [21.061362501146924, 56.607372106631971],
                            [21.027388724113603, 56.61232329532659],
                            [21.027905319554108, 56.613054769668956],
                            [21.028380633623627, 56.613767276635777],
                            [21.028845387464813, 56.614614364233297],
                            [21.029232918096795, 56.615387692156048],
                            [21.029707671114796, 56.616360860886694],
                            [21.029999739288403, 56.617266739811072],
                            [21.030356621348798, 56.617931463027979],
                            [21.030602629127046, 56.618431734642407],
                            [21.030964974315175, 56.619033663226958],
                            [21.031381193374934, 56.619708789039962],
                            [21.031703765534839, 56.620525501167734],
                            [21.031895108342507, 56.621177277269631],
                            [21.032160990794896, 56.621678019548767],
                            [21.032502333799989, 56.622522144033688],
                            [21.032935751269623, 56.623251607914838],
                            [21.033032131964916, 56.624035950018076],
                            [21.033454700892111, 56.624657284866629],
                            [21.03376233298118, 56.625392732658419],
                            [21.033988398860561, 56.625901509061094],
                            [21.034311271469374, 56.626709230530842],
                            [21.034500258593987, 56.627145209422743],
                            [21.034655720118948, 56.627742189954276],
                            [21.034951110349859, 56.628387452143606],
                            [21.035388158917115, 56.629072047136766],
                            [21.035617287528343, 56.629769661219228],
                            [21.036207410995534, 56.630601725836719],
                            [21.03672742635549, 56.631288292910888],
                            [21.03685350054959, 56.631740745856945],
                            [21.037120341124737, 56.632250486803379],
                            [21.037315838157721, 56.632623692687694],
                            [21.037537656289341, 56.632837558928117],
                            [21.03775557401989, 56.633047661893698],
                            [21.037823484847632, 56.633202092109848],
                            [21.038125201061373, 56.633559848993414],
                            [21.038567288008657, 56.6341816281058],
                            [21.038819953314903, 56.634619115446583],
                            [21.039096206620087, 56.635236942970522],
                            [21.03936859444719, 56.636151313163161],
                            [21.039423500750654, 56.636718924508592],
                            [21.0394942577073, 56.637565570660676],
                            [21.039658274655007, 56.638054878824597],
                            [21.039784751372515, 56.638750038886094],
                            [21.039913925194565, 56.639391329207974],
                            [21.039910315568076, 56.640146314945042],
                            [21.039997381916752, 56.640804580565181],
                            [21.040170326101318, 56.64144691215629],
                            [21.040132340585505, 56.642120178963943],
                            [21.040030041799962, 56.642800903917902],
                            [21.040195841797313, 56.643514976695236],
                            [21.040325156315699, 56.644174247145607],
                            [21.040414116475549, 56.64458086664547],
                            [21.040435402923631, 56.645291499567747],
                            [21.040461806956579, 56.645930342679904],
                            [21.040719759616767, 56.64676346330662],
                            [21.040982023932234, 56.647327017646155],
                            [21.041028052857907, 56.647741603854769],
                            [21.041059859510884, 56.648083940157889],
                            [21.041191077654894, 56.648491564050822],
                            [21.041416742240848, 56.648982334913761],
                            [21.041546560840942, 56.649407902866727],
                            [21.041699280715616, 56.65002278291589],
                            [21.041930511499345, 56.65046874028701],
                            [21.042274254279263, 56.651034228874458],
                            [21.042461143197915, 56.65150609733125],
                            [21.042557291409874, 56.651840973907881],
                            [21.042696269406363, 56.652149901961849],
                            [21.042813871713264, 56.652458321595255],
                            [21.042960585330025, 56.652668555020135],
                            [21.043165182056175, 56.652934097848245],
                            [21.043398046210658, 56.653353123922976],
                            [21.043687393579013, 56.653845403365253],
                            [21.0438628932623, 56.654209131387788],
                            [21.044055106595472, 56.654860901713214],
                            [21.044154667879276, 56.655132935298241],
                            [21.044208589118806, 56.655466806638735],
                            [21.044353587144347, 56.655946664821229],
                            [21.044618834645981, 56.656708036301687],
                            [21.044853650999571, 56.657109127485917],
                            [21.045040793224103, 56.657572007988428],
                            [21.045245106218914, 56.658089229471905],
                            [21.045484151816968, 56.65843648619289],
                            [21.045656176867645, 56.658845072981904],
                            [21.045962832061882, 56.659364723633857],
                            [21.046239810666137, 56.659748835100444],
                            [21.046532752565316, 56.660196247212959],
                            [21.046762694697762, 56.660660140658138],
                            [21.047059426489611, 56.66128741932733],
                            [21.047187819171171, 56.661712945489384],
                            [21.047507476714866, 56.662340766991832],
                            [21.047691867399074, 56.662839532716291],
                            [21.047791675097809, 56.663363257483987],
                            [21.048114741840124, 56.663928235610967],
                            [21.048394979406961, 56.664519163232029],
                            [21.048776990825836, 56.665139471190649],
                            [21.049094071045843, 56.665533515298293],
                            [21.049199834567716, 56.665994457450687],
                            [21.049334581031736, 56.666339231317728],
                            [21.049372720064703, 56.666627780367051],
                            [21.049351823607328, 56.667103695864149],
                            [21.049391136664411, 56.667599017144383],
                            [21.049438678721355, 56.667995655772927],
                            [21.049640718404582, 56.668315058401255],
                            [21.049975203216459, 56.668754456806475],
                            [21.050013416918727, 56.669016040594173],
                            [21.050075949528285, 56.669260223222295],
                            [21.050203698843053, 56.669694718670897],
                            [21.050258391733596, 56.670019615220703],
                            [21.050341681660591, 56.670246312021504],
                            [21.050513809067912, 56.670654892508296],
                            [21.050910864971812, 56.671338470967186],
                            [21.051068436368112, 56.67166580554553],
                            [21.051184058577839, 56.672001134504058],
                            [21.051330702350146, 56.672696753598565],
                            [21.051430484082886, 56.672986762415626],
                            [21.051562593518433, 56.673385403725689],
                            [21.051680328918714, 56.673693815479048],
                            [21.051814421950954, 56.674047559056604],
                            [21.051907898890903, 56.674418317805632],
                            [21.051923563181123, 56.674949032438867],
                            [21.052260654818458, 56.675604217857803],
                            [21.05253109577178, 56.676302767624939],
                            [21.052698661124971, 56.676998879795264],
                            [21.05289673967156, 56.677578859065491],
                            [21.053007995918431, 56.677977004277309],
                            [21.05303712303893, 56.678355226472981],
                            [21.053026778674919, 56.678696558335794],
                            [21.053046090041551, 56.679200392106601],
                            [21.05302242286238, 56.679712196810755],
                            [21.053052953252227, 56.680072474413087],
                            [21.053138893092051, 56.680272264715377],
                            [21.053220117489548, 56.680525876442559],
                            [21.053294331451159, 56.680869210692997],
                            [21.053368930161781, 56.681194576256367],
                            [21.053503189339015, 56.681566298779131],
                            [21.053648395106197, 56.682046146607597],
                            [21.053854652735321, 56.682770138834485],
                            [21.053874550389651, 56.683247019365041],
                            [21.053872986970564, 56.683750358326947],
                            [21.05398656442323, 56.684112601519551],
                            [21.054179358712901, 56.684512675293476],
                            [21.054360126141894, 56.684831564321399],
                            [21.054563760206477, 56.685106050013097],
                            [21.054736696887637, 56.685505652706581],
                            [21.054679298945391, 56.685926770233962],
                            [21.054736152138631, 56.686224747927668],
                            [21.054615004745141, 56.686671323146669],
                            [21.054469016612614, 56.687135287997954],
                            [21.054479503356333, 56.687504079092214],
                            [21.054508954996795, 56.688107029144092],
                            [21.054693756014494, 56.688381068506814],
                            [21.054873016790186, 56.688699920676001],
                            [21.055038017783982, 56.688946524310317],
                            [21.055258989964862, 56.689509061727215],
                            [21.055346290632837, 56.689933603163922],
                            [21.055294498488276, 56.690282942633473],
                            [21.055228951188312, 56.690560045845736],
                            [21.055194351017523, 56.690963725137216],
                            [21.055231917332915, 56.691234279364529],
                            [21.055280679443914, 56.691864652211315],
                            [21.055389385610294, 56.692289699898645],
                            [21.055524401545036, 56.692652448011771],
                            [21.055597128040318, 56.692995744596537],
                            [21.055641253858873, 56.69343724172424],
                            [21.055727674176708, 56.693879739366423],
                            [21.055778237330998, 56.69425846677786],
                            [21.055831796362742, 56.694592320815374],
                            [21.055808412316591, 56.69485244395927],
                            [21.05593529104728, 56.695071177442955],
                            [21.056136886900411, 56.695372577622578],
                            [21.056302433545699, 56.695619191785738],
                            [21.05647192923681, 56.696063653459028],
                            [21.0566693298959, 56.696418886397879],
                            [21.056732771983977, 56.696887806030986],
                            [21.05703413953977, 56.697461228759011],
                            [21.057088222926559, 56.697795094315644],
                            [21.057213336217494, 56.698265471691968],
                            [21.057204165919728, 56.698840539988566],
                            [21.05740146437665, 56.69968116567302],
                            [21.057567358858673, 56.700152506562446],
                            [21.057797664654139, 56.700616380887134],
                            [21.057898586903239, 56.701122140647158],
                            [21.057923569617664, 56.701554194740318],
                            [21.057886127142947, 56.702452192126444],
                            [21.057816370736731, 56.702783129780599],
                            [21.05776037570314, 56.703186303267088],
                            [21.057763950235923, 56.703617851259288],
                            [21.057918526488628, 56.704214767139128],
                            [21.058028694739377, 56.704621867930399],
                            [21.058132431591769, 56.705091738314962],
                            [21.058150921301849, 56.705613526827811],
                            [21.071605039950867, 56.708927092806682],
                            [21.077821400779918, 56.7124026521617],
                            [21.09100108748083, 56.715327276301622],
                            [21.096272933498167, 56.714261209502254],
                            [21.104778867238139, 56.716124000522662],
                            [21.107411500326108, 56.710001855793081],
                            [21.11180591915204, 56.70344490211415],
                            [21.114958829027621, 56.696145584202235],
                            [21.11989048573113, 56.688173904106357],
                            [21.127570580165138, 56.678125132764308],
                            [21.137381973197659, 56.679778092013585],
                            [21.144480596084236, 56.677325154144107],
                            [21.156393686786519, 56.674030647899158],
                            [21.164801515945751, 56.67136866934154],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "LiepÄja",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.062567441525683, 56.597411847426002],
                            [21.057563978611963, 56.589683024438472],
                            [21.061110391014097, 56.582869930993617],
                            [21.063217884497064, 56.577925371320447],
                            [21.064821134871888, 56.573920181008482],
                            [21.068070610411365, 56.570905138099974],
                            [21.066233102182949, 56.566818696587312],
                            [21.07396481154106, 56.561530993406436],
                            [21.07889546190685, 56.559030925171143],
                            [21.07909680369292, 56.556419563180185],
                            [21.089273211638353, 56.541675357055688],
                            [21.074106887703383, 56.531805885068778],
                            [21.067618873726886, 56.526658448513793],
                            [21.05821833687709, 56.520252525807805],
                            [21.040999560029658, 56.514848902567429],
                            [21.037094904983377, 56.509761310832786],
                            [21.032594989689283, 56.506799840903426],
                            [21.023597258238691, 56.500876430177236],
                            [21.030031412605613, 56.490090243505342],
                            [21.026000578561352, 56.48666404736727],
                            [21.028816365041841, 56.483639665162656],
                            [21.025160269674192, 56.47845782648411],
                            [21.011675548496633, 56.480123352114092],
                            [21.008990537972071, 56.478502262080468],
                            [20.998411256641102, 56.478506117119018],
                            [20.998345829775097, 56.479025910685962],
                            [20.998129019188124, 56.479694858352708],
                            [20.997907261846024, 56.480921019646132],
                            [20.997734530451275, 56.481995549753115],
                            [20.997471685620575, 56.482771253374146],
                            [20.99720102996195, 56.483690595484703],
                            [20.996525092218587, 56.486281116167476],
                            [20.995910387711881, 56.487974191198546],
                            [20.995560687918605, 56.489269164816285],
                            [20.995132409469999, 56.490517288273246],
                            [20.994701343152126, 56.492223794723053],
                            [20.994101419547999, 56.494465564308577],
                            [20.993522846658809, 56.496276364682146],
                            [20.991641674230575, 56.502559204437922],
                            [20.991447924355835, 56.503183754798989],
                            [20.990996115490731, 56.504449273946221],
                            [20.990598569833558, 56.50544643005852],
                            [20.990182455339422, 56.506389199216322],
                            [20.989772441625398, 56.507664717402797],
                            [20.988908299957256, 56.509810163703655],
                            [20.98834522884982, 56.511252760025926],
                            [20.987790670237004, 56.512542743455064],
                            [20.984486565162356, 56.519608969349086],
                            [20.984430221039243, 56.51974243933126],
                            [20.983957868464799, 56.519892769482276],
                            [20.983141455658391, 56.520241489002402],
                            [20.982604848940735, 56.52047115579694],
                            [20.981600332989416, 56.520833271308206],
                            [20.980672760239333, 56.521269164667849],
                            [20.979821413488985, 56.521787809445826],
                            [20.979260604094669, 56.522052830511015],
                            [20.978628523698749, 56.522414996378537],
                            [20.978296570899357, 56.522658615704195],
                            [20.97792668703126, 56.52287434291852],
                            [20.977708715788694, 56.522994885863511],
                            [20.97696547161846, 56.523444229788396],
                            [20.97666612822098, 56.523571778546881],
                            [20.976406763288328, 56.523682321848739],
                            [20.976128836947659, 56.523783423195766],
                            [20.975749161734623, 56.523873055792251],
                            [20.975372346374883, 56.523926799814696],
                            [20.97501826512859, 56.523963118152231],
                            [20.974803856151475, 56.52403879659154],
                            [20.974364230167968, 56.524108985410642],
                            [20.971345987201392, 56.52410729595249],
                            [20.97099067712384, 56.524152562182877],
                            [20.970674303350769, 56.524225745493716],
                            [20.970338057330252, 56.524280464411184],
                            [20.970019531242507, 56.524380561442911],
                            [20.969656034977124, 56.524515517067549],
                            [20.969359019163075, 56.524607148259264],
                            [20.969095324838776, 56.524771506749673],
                            [20.968918490173678, 56.524911017756963],
                            [20.968761646825765, 56.525042027396914],
                            [20.968646904554237, 56.525174064961043],
                            [20.968532878528055, 56.525297130618597],
                            [20.967782675296458, 56.527687940721172],
                            [20.968020523138492, 56.527783643141326],
                            [20.968259351439201, 56.527663625858573],
                            [20.968813869400812, 56.52560962848834],
                            [20.968826863098574, 56.525466116981633],
                            [20.969055718403272, 56.525228993958507],
                            [20.969256726288396, 56.525054115744126],
                            [20.969414284837463, 56.524914133663906],
                            [20.969720709089579, 56.524723849714299],
                            [20.970022830158737, 56.524587395788934],
                            [20.970278757280241, 56.524494760189469],
                            [20.970699747288432, 56.524397163018648],
                            [20.97099613070549, 56.524332481131744],
                            [20.971474195645889, 56.5242902098203],
                            [20.971784838418927, 56.524288799006207],
                            [20.97374575931698, 56.524318641305221],
                            [20.974118286469565, 56.524318733312064],
                            [20.974595723125411, 56.524303402553301],
                            [20.974929726357029, 56.524257606803666],
                            [20.975309407299591, 56.524167976779076],
                            [20.97554237593635, 56.524101738950591],
                            [20.975878106103483, 56.524046993484788],
                            [20.976215772983668, 56.523974315746251],
                            [20.976491555104726, 56.523900129792523],
                            [20.976873374050399, 56.523783579327961],
                            [20.977131931623024, 56.523664026125978],
                            [20.977371420233819, 56.523535018803237],
                            [20.978706087425163, 56.522704540933837],
                            [20.979248257575033, 56.522412100813526],
                            [20.979685818040753, 56.522144080923084],
                            [20.980008679180415, 56.522008108057335],
                            [20.980292803010087, 56.52183523495674],
                            [20.980643389230409, 56.521619031583604],
                            [20.980861456543099, 56.521471518242222],
                            [20.981162798208214, 56.521344008348578],
                            [20.981420818471399, 56.521224433519585],
                            [20.981917373761746, 56.520993797806703],
                            [20.982670301863791, 56.520670510583493],
                            [20.983122097251261, 56.520465749960991],
                            [20.983506715138596, 56.520313290786142],
                            [20.984146369841422, 56.520104102465837],
                            [20.98249611710769, 56.521978708193309],
                            [20.981822800417834, 56.52400290050835],
                            [20.982429591733428, 56.524718814529415],
                            [20.98322454673065, 56.524513405052076],
                            [20.983068381709078, 56.524329824670978],
                            [20.982419536634108, 56.52449383869633],
                            [20.982075032384714, 56.523937118948474],
                            [20.982351432717618, 56.523305601194153],
                            [20.98294638677207, 56.523409955631955],
                            [20.983613487999683, 56.523201436468533],
                            [20.987155121712306, 56.521795232506122],
                            [20.987510318920418, 56.521642046884061],
                            [20.995751620184191, 56.524152008377591],
                            [20.995916518042634, 56.527697748229407],
                            [20.993103961669974, 56.527476838758467],
                            [20.992980527453909, 56.527950277504104],
                            [20.996301843754999, 56.528255413763333],
                            [20.995902022604518, 56.529504228330225],
                            [20.99364708309345, 56.529287836053648],
                            [20.993526623769746, 56.52947369239299],
                            [20.995820027601436, 56.52971798513795],
                            [20.995572816013556, 56.530413160840077],
                            [20.993359222103503, 56.530206753871255],
                            [20.993347030227987, 56.530341296822357],
                            [20.995536276893546, 56.530592060712372],
                            [20.995287632082146, 56.53130517965333],
                            [20.992702815245565, 56.531080787287408],
                            [20.992668600568191, 56.531223785936859],
                            [20.995207862361642, 56.531510000761564],
                            [20.995080277146307, 56.532010308347239],
                            [20.998210080196834, 56.532157936427836],
                            [20.997523792270844, 56.535008895019033],
                            [20.982233338172033, 56.533253833263174],
                            [20.982113618070922, 56.533448686589061],
                            [20.9976292281074, 56.535218196265198],
                            [20.9978390897564, 56.535277206210111],
                            [20.998053924682512, 56.535363303621949],
                            [20.998128716485319, 56.535446014727867],
                            [20.998522162954963, 56.535716213535672],
                            [20.998845086491347, 56.536074598240219],
                            [20.998991944839606, 56.536563564320083],
                            [20.99887666828732, 56.53699225905271],
                            [20.998772143471633, 56.537259408170804],
                            [20.998621137346138, 56.53760633631417],
                            [20.998557004554598, 56.538153126569213],
                            [20.998679103746209, 56.538704418639767],
                            [20.998684286837488, 56.539171981725524],
                            [20.998534086102865, 56.539752648159528],
                            [20.998443762456873, 56.540379707853134],
                            [20.998294161654805, 56.540978366907105],
                            [20.997918825330128, 56.541544600670889],
                            [20.997383200254077, 56.542574395266101],
                            [20.996993313356096, 56.543311069266913],
                            [20.996591230360426, 56.544047447192526],
                            [20.993120592322924, 56.544107279558354],
                            [20.992344685245712, 56.546093080268825],
                            [20.99267031864477, 56.5461549022273],
                            [20.993391176285268, 56.544311593992525],
                            [20.994282898672864, 56.544288236305626],
                            [20.994339153712353, 56.545053679699109],
                            [20.994649763896597, 56.54506119773675],
                            [20.994632174078603, 56.544314668792481],
                            [20.995459540797889, 56.544307723413795],
                            [20.995499378217133, 56.545036811939354],
                            [20.995851505998942, 56.545027353138252],
                            [20.995813895497527, 56.544289329502618],
                            [20.99643825230687, 56.544277465877741],
                            [20.997121987706819, 56.544311981033736],
                            [20.997405590620879, 56.544390752620473],
                            [20.997603117563454, 56.544503399065491],
                            [20.99785413983701, 56.5445634034444],
                            [20.99803683583038, 56.546365657097802],
                            [20.997974302788169, 56.546615842458451],
                            [20.998021300653587, 56.546805751473009],
                            [20.998177830390283, 56.547025275840234],
                            [20.992485530708393, 56.547067325253778],
                            [20.992469056296859, 56.547255699445437],
                            [20.998222494963176, 56.547206139163379],
                            [20.998251730243712, 56.547305726862376],
                            [20.998256602148306, 56.547494617427873],
                            [20.99837435744136, 56.547857031060332],
                            [20.998499931787073, 56.548345482034065],
                            [20.998730378339619, 56.549115131968797],
                            [20.998907328262295, 56.549487964693249],
                            [20.99924448101396, 56.549918603402062],
                            [20.999223979343597, 56.550196772418921],
                            [20.999156270560238, 56.550518746571996],
                            [20.998998308393816, 56.550946409787848],
                            [20.99889861532704, 56.55117771914859],
                            [20.998905827583005, 56.551600384643642],
                            [20.998806947544775, 56.552335107340355],
                            [20.998677299752341, 56.552925259596108],
                            [20.998481449144382, 56.553837421945275],
                            [20.998320618777075, 56.554570646991628],
                            [20.998051853764718, 56.555112490298548],
                            [20.997779628188582, 56.555672227786253],
                            [20.997472467988448, 56.556159206782183],
                            [20.997052802077306, 56.556499638044677],
                            [20.99655515022166, 56.556784246994539],
                            [20.996046127451365, 56.556942730522238],
                            [20.995809646279262, 56.556910042928088],
                            [20.971287893175656, 56.55375251512087],
                            [20.971106833757204, 56.553936873799067],
                            [20.996476026828688, 56.557204824803151],
                            [20.998422637561404, 56.557494593342128],
                            [20.998927293443284, 56.557641626303855],
                            [20.999163478780076, 56.557800149046095],
                            [20.999476432709617, 56.558023450162501],
                            [20.999827267120811, 56.558301600477087],
                            [21.00021090885387, 56.558679422911759],
                            [21.000447725787041, 56.55908066564492],
                            [21.001981248593609, 56.562740321489855],
                            [21.002001986120082, 56.562992518301144],
                            [21.001707601598973, 56.563318011040849],
                            [21.001656547041229, 56.563712301330639],
                            [21.001821312731728, 56.564246638544979],
                            [21.002275731516367, 56.564778977172907],
                            [21.002611938368176, 56.565236548198754],
                            [21.004200094606642, 56.568564887882886],
                            [21.004341131205504, 56.568981789594936],
                            [21.00469210055795, 56.569259927186813],
                            [21.00519207424713, 56.569487721323952],
                            [21.005640274430633, 56.569849102354965],
                            [21.005950679497108, 56.570395932259686],
                            [21.006636211017323, 56.571958583504767],
                            [21.008300583603511, 56.575792086508756],
                            [21.008645596045138, 56.576681327919601],
                            [21.008869407715991, 56.577513715353248],
                            [21.009454182385429, 56.579820016673906],
                            [21.009804925808115, 56.58063747865468],
                            [21.010117769914011, 56.58140009268331],
                            [21.010445679484338, 56.582217002817309],
                            [21.010749081680416, 56.583267038853776],
                            [21.010608067115566, 56.583686133905317],
                            [21.010856279778114, 56.583952789634935],
                            [21.011140475086208, 56.584247277704762],
                            [21.011117761528013, 56.584741131809395],
                            [21.011223978446466, 56.585175163638958],
                            [21.011638181529264, 56.585886276034479],
                            [21.011725192712067, 56.58629287804704],
                            [21.01171162412691, 56.586445366351469],
                            [21.011761638882071, 56.586824111223585],
                            [21.011891641854433, 56.587240736048336],
                            [21.01203439959037, 56.587495863708206],
                            [21.012287063714385, 56.587906448508626],
                            [21.01269315512479, 56.588230830535245],
                            [21.01316993029651, 56.588691746558823],
                            [21.013526970788359, 56.589347542762489],
                            [21.013803320081021, 56.589974431310807],
                            [21.014114042495109, 56.59090777388603],
                            [21.01421766995918, 56.591620401472028],
                            [21.014537531935833, 56.592212377027828],
                            [21.014801177534785, 56.592749066630631],
                            [21.01525153536717, 56.593029557122229],
                            [21.014873968847482, 56.593317127240844],
                            [21.014876997701631, 56.593523948802094],
                            [21.014927670381194, 56.593668991307588],
                            [21.015234818541966, 56.594170768369338],
                            [21.015697525939643, 56.595017865225387],
                            [21.016098255099603, 56.596115165823008],
                            [21.016975130333527, 56.597457610715232],
                            [21.017613723901331, 56.598425778629554],
                            [21.018764731972464, 56.599702874889822],
                            [21.0197762444981, 56.601381121653922],
                            [21.02056459149907, 56.602298928695674],
                            [21.021299590098369, 56.60337725437833],
                            [21.022101679189134, 56.604367292079466],
                            [21.022910391419778, 56.605312537362934],
                            [21.023565611231202, 56.606577706367716],
                            [21.024344609648267, 56.607836845509439],
                            [21.024813948500313, 56.608630126581197],
                            [21.025174509585487, 56.609181495980792],
                            [21.02543501507245, 56.609579850142204],
                            [21.026074529258029, 56.610547989492304],
                            [21.026583397190613, 56.611351197445323],
                            [21.027388724113603, 56.61232329532659],
                            [21.061362501146924, 56.607372106631971],
                            [21.062567441525683, 56.597411847426002],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "GrobiÅ†as",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.025160269674192, 56.47845782648411],
                            [21.028816365041841, 56.483639665162656],
                            [21.026000578561352, 56.48666404736727],
                            [21.030031412605613, 56.490090243505342],
                            [21.023597258238691, 56.500876430177236],
                            [21.032594989689283, 56.506799840903426],
                            [21.037094904983377, 56.509761310832786],
                            [21.040999560029658, 56.514848902567429],
                            [21.05821833687709, 56.520252525807805],
                            [21.067618873726886, 56.526658448513793],
                            [21.074106887703383, 56.531805885068778],
                            [21.089273211638353, 56.541675357055688],
                            [21.07909680369292, 56.556419563180185],
                            [21.07889546190685, 56.559030925171143],
                            [21.07396481154106, 56.561530993406436],
                            [21.066233102182949, 56.566818696587312],
                            [21.068070610411365, 56.570905138099974],
                            [21.064821134871888, 56.573920181008482],
                            [21.063217884497064, 56.577925371320447],
                            [21.061110391014097, 56.582869930993617],
                            [21.057563978611963, 56.589683024438472],
                            [21.062567441525683, 56.597411847426002],
                            [21.065660239910482, 56.602003604009425],
                            [21.068735370980399, 56.60683268086018],
                            [21.073003083832109, 56.607408882627006],
                            [21.073588401476012, 56.610990049906718],
                            [21.077462860288026, 56.61108118330521],
                            [21.085413990927933, 56.619829517377426],
                            [21.091570284106929, 56.618308891933147],
                            [21.099327485989257, 56.612782322746824],
                            [21.100486259786219, 56.603296403198463],
                            [21.106535758481606, 56.597491764232608],
                            [21.108031662908637, 56.589202752743674],
                            [21.100414372261508, 56.587360514770616],
                            [21.097960399485281, 56.585638469225437],
                            [21.101941424176371, 56.58430441591269],
                            [21.100923586893956, 56.580713311924796],
                            [21.098003472552211, 56.579456034774324],
                            [21.099082076194005, 56.576627321238647],
                            [21.11510500696755, 56.575573382551632],
                            [21.121249767337524, 56.579758869742868],
                            [21.137811352159083, 56.577287540074813],
                            [21.149066482677988, 56.576594968952811],
                            [21.153744404069773, 56.577415657472912],
                            [21.161448483141541, 56.572359832486597],
                            [21.172001189404824, 56.569508789264695],
                            [21.181209225773202, 56.567339826545805],
                            [21.194268807836554, 56.565495040967406],
                            [21.194638080608666, 56.56050921499876],
                            [21.198823778452141, 56.556322945644858],
                            [21.196700957046623, 56.55009181099954],
                            [21.203104335713697, 56.545004168340654],
                            [21.210033493334581, 56.544446542568934],
                            [21.218582803281038, 56.539406316255487],
                            [21.231058830134863, 56.545392627244794],
                            [21.237607036271449, 56.550056890629826],
                            [21.25359819419068, 56.549222377158166],
                            [21.254578394297958, 56.541634023882104],
                            [21.253495692703439, 56.532810992056639],
                            [21.247069039921911, 56.526485538972452],
                            [21.241935020492679, 56.514243065917107],
                            [21.237694846120831, 56.507489972535183],
                            [21.237662832669404, 56.502019500655813],
                            [21.235827363828722, 56.497697957947373],
                            [21.236155683604139, 56.493186764016116],
                            [21.230766269833872, 56.490450659075073],
                            [21.221167900471272, 56.49237649097531],
                            [21.205804022434616, 56.490842476981541],
                            [21.207116261814193, 56.484688729876233],
                            [21.211616505484233, 56.481936102082265],
                            [21.207761850521266, 56.4759039642937],
                            [21.212644021069607, 56.467927894257592],
                            [21.212528438772672, 56.463644559927708],
                            [21.210303556220509, 56.458838171102379],
                            [21.212593091136924, 56.451041605179235],
                            [21.215240785301628, 56.444204320071087],
                            [21.214134515516168, 56.435855798286575],
                            [21.215663357273446, 56.432560660076447],
                            [21.22094438389443, 56.430776566650529],
                            [21.227514689337447, 56.425666751454962],
                            [21.222079174929551, 56.425872755918846],
                            [21.212568983133878, 56.425348074885591],
                            [21.206241137850341, 56.427384486024458],
                            [21.199889768533762, 56.429731311701268],
                            [21.193835390333259, 56.428038143171555],
                            [21.186499321288728, 56.42849443275],
                            [21.177572865370166, 56.427669048256028],
                            [21.169276875001813, 56.425923617826285],
                            [21.159906591297787, 56.423530488675439],
                            [21.151801172250572, 56.426768487471207],
                            [21.141193773815008, 56.425901843553895],
                            [21.126474346656284, 56.427429204535684],
                            [21.116004482177058, 56.432166440135795],
                            [21.101859216161358, 56.440863502293666],
                            [21.093982552514522, 56.44099045453811],
                            [21.092118737531205, 56.43596641705134],
                            [21.061545653991701, 56.438981025358807],
                            [21.060633652439908, 56.45078786276293],
                            [21.059048008103453, 56.471294398424398],
                            [21.042774261938337, 56.478066921398259],
                            [21.026443898392586, 56.478299198504551],
                            [21.025160269674192, 56.47845782648411],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "Virgas",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.389383589513233, 56.471772184167172],
                            [21.386466562750709, 56.476704692995291],
                            [21.389323377594465, 56.478905066837712],
                            [21.387742243786025, 56.483152285236557],
                            [21.389099923909587, 56.488412555808345],
                            [21.393576980282873, 56.492073710348713],
                            [21.397147463623632, 56.496429097717211],
                            [21.400767515359622, 56.500071997939649],
                            [21.410642749973835, 56.500278358787419],
                            [21.418778048209486, 56.507106223499683],
                            [21.434033322000641, 56.504093218637593],
                            [21.442733563298553, 56.502608120526062],
                            [21.44947761516347, 56.498228650482119],
                            [21.457523914518926, 56.493637707784089],
                            [21.469655187792295, 56.492220982483595],
                            [21.487560402047183, 56.491176900594596],
                            [21.488481262616165, 56.48505586767623],
                            [21.489364121173214, 56.479505189999749],
                            [21.487987681526182, 56.476907242398305],
                            [21.484625754688338, 56.473126783240531],
                            [21.482982800354019, 56.470666152806466],
                            [21.482961183298229, 56.467096125567274],
                            [21.486212581844747, 56.464734714309067],
                            [21.491571116150968, 56.461701920107608],
                            [21.495889246433318, 56.458790693065701],
                            [21.502037462791527, 56.455487831928991],
                            [21.506859741882696, 56.452729169911251],
                            [21.507009240593902, 56.450447648349765],
                            [21.508427402437391, 56.448477177983627],
                            [21.503647670870546, 56.446667693812451],
                            [21.502032650282043, 56.443779520703742],
                            [21.503525633027721, 56.440668345673267],
                            [21.502664354846548, 56.438080910059391],
                            [21.500488179345851, 56.435895326065179],
                            [21.493871233974268, 56.4346195373546],
                            [21.487465057910175, 56.434061580154413],
                            [21.488325216976843, 56.436649112773033],
                            [21.481375718515739, 56.436508193333424],
                            [21.474303295882574, 56.43822057936233],
                            [21.470527614253822, 56.436858578225873],
                            [21.465989562546621, 56.435338100812686],
                            [21.459631290899267, 56.434065754727577],
                            [21.45475086921175, 56.433822912329411],
                            [21.450194724424279, 56.432587044691523],
                            [21.444133092510366, 56.430748846429246],
                            [21.438129610531231, 56.428054828372744],
                            [21.433060082739971, 56.426807709358712],
                            [21.430840469290576, 56.425333880301466],
                            [21.427853380754041, 56.430246596082021],
                            [21.425469644799975, 56.433764190087956],
                            [21.42153169459074, 56.434871403316393],
                            [21.420926100298477, 56.437474654463941],
                            [21.414950415240156, 56.44329535958714],
                            [21.408956713085775, 56.449353221645694],
                            [21.398194998396267, 56.456024326301552],
                            [21.394650295310427, 56.457614575079134],
                            [21.390877232460575, 56.462529197976913],
                            [21.387119497165287, 56.467206231825948],
                            [21.389383589513233, 56.471772184167172],
                        ],
                    ],
                },
            },
            {
                type: "Feature",
                properties: {
                    Pagasts: "Kurzeme",
                    Rajons: null,
                    Aporinkis: "Liepājas",
                    Pagasts_1: "TadaiÄ·u",
                },
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [21.418778048209486, 56.507106223499683],
                            [21.410642749973835, 56.500278358787419],
                            [21.400767515359622, 56.500071997939649],
                            [21.397147463623632, 56.496429097717211],
                            [21.393576980282873, 56.492073710348713],
                            [21.389099923909587, 56.488412555808345],
                            [21.387742243786025, 56.483152285236557],
                            [21.389323377594465, 56.478905066837712],
                            [21.386466562750709, 56.476704692995291],
                            [21.389383589513233, 56.471772184167172],
                            [21.37591694740955, 56.46768325090239],
                            [21.368459951699627, 56.469903398165009],
                            [21.363064869624345, 56.473355973856371],
                            [21.355606024133518, 56.475575329511521],
                            [21.344730230440714, 56.477483376918251],
                            [21.338144370073891, 56.479482569776337],
                            [21.332349390435343, 56.482449659012516],
                            [21.331603434732425, 56.486951994160236],
                            [21.335578872322493, 56.491555760176297],
                            [21.343997621999037, 56.494114262659771],
                            [21.343781743224021, 56.497201144249928],
                            [21.347346935687156, 56.501557910976388],
                            [21.349475522990119, 56.50802416477012],
                            [21.354974626192512, 56.515513435983365],
                            [21.3514874560374, 56.522335493913971],
                            [21.347272512172054, 56.527239468618646],
                            [21.354079607390016, 56.534518855103087],
                            [21.350359748941088, 56.538482260161146],
                            [21.340291839635814, 56.540882966064139],
                            [21.327068721423242, 56.539172288896246],
                            [21.312987342170839, 56.537441624901106],
                            [21.298098603488867, 56.534978357351676],
                            [21.293417697197288, 56.546291334106989],
                            [21.292875041059169, 56.553889429520133],
                            [21.288756082693787, 56.563312013499832],
                            [21.286355558457913, 56.57277201020618],
                            [21.298111527163293, 56.577070904212952],
                            [21.31147467177821, 56.580685665201642],
                            [21.313944566771077, 56.578603135990164],
                            [21.325392708372284, 56.581228085996429],
                            [21.33184646381147, 56.581366793145591],
                            [21.349884038916276, 56.582228293372758],
                            [21.354320677978382, 56.574237455418846],
                            [21.362659284796798, 56.565853737765387],
                            [21.366761171557702, 56.562611469609905],
                            [21.373691413210114, 56.562044725041311],
                            [21.381793330643937, 56.556984032796656],
                            [21.395253814620457, 56.555364521623702],
                            [21.407901984370504, 56.553013216875335],
                            [21.425041563820518, 56.547900207104057],
                            [21.433784390748698, 56.545940907365861],
                            [21.438914204863774, 56.540101782082445],
                            [21.439472311384201, 56.538210892382544],
                            [21.452685447465331, 56.533726577342406],
                            [21.463397592319922, 56.534421390254394],
                            [21.472770827154552, 56.529380909510884],
                            [21.478211534308588, 56.525211147811675],
                            [21.476856100835068, 56.519714284476493],
                            [21.45925848894958, 56.519117705797427],
                            [21.449282207968857, 56.520339994167237],
                            [21.437634972168947, 56.520813622806628],
                            [21.425627691139091, 56.513906867290494],
                            [21.420667115251451, 56.510950307563832],
                            [21.418778048209486, 56.507106223499683],
                        ],
                    ],
                },
            },
        ],
    },

    getters: {
        latvianAlphabet(state) {
            return state.latvianAlphabet;
        },
    },
};
